var $u = Object.defineProperty;
var ku = (e, t, r) => t in e ? $u(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Hr = (e, t, r) => ku(e, typeof t != "symbol" ? t + "" : t, r);
import * as h from "react";
import ot, { forwardRef as Iu, useContext as Nu, isValidElement as Kn, cloneElement as Gn, Children as Au, useEffect as Hi, useState as Mu } from "react";
import * as ju from "react-dom";
import Dn from "react-dom";
import { AuthProvider as _u, useAuth as Yi } from "react-oidc-context";
function Du(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bi = { exports: {} }, Yr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ha;
function Lu() {
  if (Ha) return Yr;
  Ha = 1;
  var e = ot, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, u) {
    var p, f = {}, g = null, v = null;
    u !== void 0 && (g = "" + u), c.key !== void 0 && (g = "" + c.key), c.ref !== void 0 && (v = c.ref);
    for (p in c) n.call(c, p) && !a.hasOwnProperty(p) && (f[p] = c[p]);
    if (l && l.defaultProps) for (p in c = l.defaultProps, c) f[p] === void 0 && (f[p] = c[p]);
    return { $$typeof: t, type: l, key: g, ref: v, props: f, _owner: o.current };
  }
  return Yr.Fragment = r, Yr.jsx = s, Yr.jsxs = s, Yr;
}
var qr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ya;
function Bu() {
  return Ya || (Ya = 1, process.env.NODE_ENV !== "production" && function() {
    var e = ot, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), y = Symbol.iterator, d = "@@iterator";
    function x(S) {
      if (S === null || typeof S != "object")
        return null;
      var F = y && S[y] || S[d];
      return typeof F == "function" ? F : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function O(S) {
      {
        for (var F = arguments.length, J = new Array(F > 1 ? F - 1 : 0), ae = 1; ae < F; ae++)
          J[ae - 1] = arguments[ae];
        T("error", S, J);
      }
    }
    function T(S, F, J) {
      {
        var ae = b.ReactDebugCurrentFrame, xe = ae.getStackAddendum();
        xe !== "" && (F += "%s", J = J.concat([xe]));
        var $e = J.map(function(pe) {
          return String(pe);
        });
        $e.unshift("Warning: " + F), Function.prototype.apply.call(console[S], console, $e);
      }
    }
    var E = !1, C = !1, $ = !1, P = !1, k = !1, I;
    I = Symbol.for("react.module.reference");
    function m(S) {
      return !!(typeof S == "string" || typeof S == "function" || S === n || S === a || k || S === o || S === u || S === p || P || S === v || E || C || $ || typeof S == "object" && S !== null && (S.$$typeof === g || S.$$typeof === f || S.$$typeof === s || S.$$typeof === l || S.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      S.$$typeof === I || S.getModuleId !== void 0));
    }
    function R(S, F, J) {
      var ae = S.displayName;
      if (ae)
        return ae;
      var xe = F.displayName || F.name || "";
      return xe !== "" ? J + "(" + xe + ")" : J;
    }
    function _(S) {
      return S.displayName || "Context";
    }
    function j(S) {
      if (S == null)
        return null;
      if (typeof S.tag == "number" && O("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof S == "function")
        return S.displayName || S.name || null;
      if (typeof S == "string")
        return S;
      switch (S) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case u:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof S == "object")
        switch (S.$$typeof) {
          case l:
            var F = S;
            return _(F) + ".Consumer";
          case s:
            var J = S;
            return _(J._context) + ".Provider";
          case c:
            return R(S, S.render, "ForwardRef");
          case f:
            var ae = S.displayName || null;
            return ae !== null ? ae : j(S.type) || "Memo";
          case g: {
            var xe = S, $e = xe._payload, pe = xe._init;
            try {
              return j(pe($e));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var V = Object.assign, D = 0, M, U, te, Y, N, B, H;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function G() {
      {
        if (D === 0) {
          M = console.log, U = console.info, te = console.warn, Y = console.error, N = console.group, B = console.groupCollapsed, H = console.groupEnd;
          var S = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: S,
            log: S,
            warn: S,
            error: S,
            group: S,
            groupCollapsed: S,
            groupEnd: S
          });
        }
        D++;
      }
    }
    function Q() {
      {
        if (D--, D === 0) {
          var S = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: V({}, S, {
              value: M
            }),
            info: V({}, S, {
              value: U
            }),
            warn: V({}, S, {
              value: te
            }),
            error: V({}, S, {
              value: Y
            }),
            group: V({}, S, {
              value: N
            }),
            groupCollapsed: V({}, S, {
              value: B
            }),
            groupEnd: V({}, S, {
              value: H
            })
          });
        }
        D < 0 && O("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var z = b.ReactCurrentDispatcher, K;
    function X(S, F, J) {
      {
        if (K === void 0)
          try {
            throw Error();
          } catch (xe) {
            var ae = xe.stack.trim().match(/\n( *(at )?)/);
            K = ae && ae[1] || "";
          }
        return `
` + K + S;
      }
    }
    var ie = !1, W;
    {
      var ne = typeof WeakMap == "function" ? WeakMap : Map;
      W = new ne();
    }
    function L(S, F) {
      if (!S || ie)
        return "";
      {
        var J = W.get(S);
        if (J !== void 0)
          return J;
      }
      var ae;
      ie = !0;
      var xe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var $e;
      $e = z.current, z.current = null, G();
      try {
        if (F) {
          var pe = function() {
            throw Error();
          };
          if (Object.defineProperty(pe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(pe, []);
            } catch (st) {
              ae = st;
            }
            Reflect.construct(S, [], pe);
          } else {
            try {
              pe.call();
            } catch (st) {
              ae = st;
            }
            S.call(pe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (st) {
            ae = st;
          }
          S();
        }
      } catch (st) {
        if (st && ae && typeof st.stack == "string") {
          for (var ue = st.stack.split(`
`), nt = ae.stack.split(`
`), He = ue.length - 1, Ke = nt.length - 1; He >= 1 && Ke >= 0 && ue[He] !== nt[Ke]; )
            Ke--;
          for (; He >= 1 && Ke >= 0; He--, Ke--)
            if (ue[He] !== nt[Ke]) {
              if (He !== 1 || Ke !== 1)
                do
                  if (He--, Ke--, Ke < 0 || ue[He] !== nt[Ke]) {
                    var gt = `
` + ue[He].replace(" at new ", " at ");
                    return S.displayName && gt.includes("<anonymous>") && (gt = gt.replace("<anonymous>", S.displayName)), typeof S == "function" && W.set(S, gt), gt;
                  }
                while (He >= 1 && Ke >= 0);
              break;
            }
        }
      } finally {
        ie = !1, z.current = $e, Q(), Error.prepareStackTrace = xe;
      }
      var Er = S ? S.displayName || S.name : "", pr = Er ? X(Er) : "";
      return typeof S == "function" && W.set(S, pr), pr;
    }
    function de(S, F, J) {
      return L(S, !1);
    }
    function Se(S) {
      var F = S.prototype;
      return !!(F && F.isReactComponent);
    }
    function Ae(S, F, J) {
      if (S == null)
        return "";
      if (typeof S == "function")
        return L(S, Se(S));
      if (typeof S == "string")
        return X(S);
      switch (S) {
        case u:
          return X("Suspense");
        case p:
          return X("SuspenseList");
      }
      if (typeof S == "object")
        switch (S.$$typeof) {
          case c:
            return de(S.render);
          case f:
            return Ae(S.type, F, J);
          case g: {
            var ae = S, xe = ae._payload, $e = ae._init;
            try {
              return Ae($e(xe), F, J);
            } catch {
            }
          }
        }
      return "";
    }
    var Je = Object.prototype.hasOwnProperty, Ue = {}, Fe = b.ReactDebugCurrentFrame;
    function ve(S) {
      if (S) {
        var F = S._owner, J = Ae(S.type, S._source, F ? F.type : null);
        Fe.setExtraStackFrame(J);
      } else
        Fe.setExtraStackFrame(null);
    }
    function De(S, F, J, ae, xe) {
      {
        var $e = Function.call.bind(Je);
        for (var pe in S)
          if ($e(S, pe)) {
            var ue = void 0;
            try {
              if (typeof S[pe] != "function") {
                var nt = Error((ae || "React class") + ": " + J + " type `" + pe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof S[pe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw nt.name = "Invariant Violation", nt;
              }
              ue = S[pe](F, pe, ae, J, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (He) {
              ue = He;
            }
            ue && !(ue instanceof Error) && (ve(xe), O("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ae || "React class", J, pe, typeof ue), ve(null)), ue instanceof Error && !(ue.message in Ue) && (Ue[ue.message] = !0, ve(xe), O("Failed %s type: %s", J, ue.message), ve(null));
          }
      }
    }
    var be = Array.isArray;
    function re(S) {
      return be(S);
    }
    function Yt(S) {
      {
        var F = typeof Symbol == "function" && Symbol.toStringTag, J = F && S[Symbol.toStringTag] || S.constructor.name || "Object";
        return J;
      }
    }
    function Rt(S) {
      try {
        return Pt(S), !1;
      } catch {
        return !0;
      }
    }
    function Pt(S) {
      return "" + S;
    }
    function $t(S) {
      if (Rt(S))
        return O("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Yt(S)), Pt(S);
    }
    var ht = b.ReactCurrentOwner, qt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, St, Le;
    function ce(S) {
      if (Je.call(S, "ref")) {
        var F = Object.getOwnPropertyDescriptor(S, "ref").get;
        if (F && F.isReactWarning)
          return !1;
      }
      return S.ref !== void 0;
    }
    function rt(S) {
      if (Je.call(S, "key")) {
        var F = Object.getOwnPropertyDescriptor(S, "key").get;
        if (F && F.isReactWarning)
          return !1;
      }
      return S.key !== void 0;
    }
    function qe(S, F) {
      typeof S.ref == "string" && ht.current;
    }
    function Me(S, F) {
      {
        var J = function() {
          St || (St = !0, O("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", F));
        };
        J.isReactWarning = !0, Object.defineProperty(S, "key", {
          get: J,
          configurable: !0
        });
      }
    }
    function Vr(S, F) {
      {
        var J = function() {
          Le || (Le = !0, O("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", F));
        };
        J.isReactWarning = !0, Object.defineProperty(S, "ref", {
          get: J,
          configurable: !0
        });
      }
    }
    var zr = function(S, F, J, ae, xe, $e, pe) {
      var ue = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: S,
        key: F,
        ref: J,
        props: pe,
        // Record the component responsible for creating this element.
        _owner: $e
      };
      return ue._store = {}, Object.defineProperty(ue._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ue, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ae
      }), Object.defineProperty(ue, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xe
      }), Object.freeze && (Object.freeze(ue.props), Object.freeze(ue)), ue;
    };
    function Xo(S, F, J, ae, xe) {
      {
        var $e, pe = {}, ue = null, nt = null;
        J !== void 0 && ($t(J), ue = "" + J), rt(F) && ($t(F.key), ue = "" + F.key), ce(F) && (nt = F.ref, qe(F, xe));
        for ($e in F)
          Je.call(F, $e) && !qt.hasOwnProperty($e) && (pe[$e] = F[$e]);
        if (S && S.defaultProps) {
          var He = S.defaultProps;
          for ($e in He)
            pe[$e] === void 0 && (pe[$e] = He[$e]);
        }
        if (ue || nt) {
          var Ke = typeof S == "function" ? S.displayName || S.name || "Unknown" : S;
          ue && Me(pe, Ke), nt && Vr(pe, Ke);
        }
        return zr(S, ue, nt, xe, ae, ht.current, pe);
      }
    }
    var Qt = b.ReactCurrentOwner, An = b.ReactDebugCurrentFrame;
    function er(S) {
      if (S) {
        var F = S._owner, J = Ae(S.type, S._source, F ? F.type : null);
        An.setExtraStackFrame(J);
      } else
        An.setExtraStackFrame(null);
    }
    var Wr;
    Wr = !1;
    function Ur(S) {
      return typeof S == "object" && S !== null && S.$$typeof === t;
    }
    function Mn() {
      {
        if (Qt.current) {
          var S = j(Qt.current.type);
          if (S)
            return `

Check the render method of \`` + S + "`.";
        }
        return "";
      }
    }
    function Jo(S) {
      return "";
    }
    var jn = {};
    function Zo(S) {
      {
        var F = Mn();
        if (!F) {
          var J = typeof S == "string" ? S : S.displayName || S.name;
          J && (F = `

Check the top-level render call using <` + J + ">.");
        }
        return F;
      }
    }
    function se(S, F) {
      {
        if (!S._store || S._store.validated || S.key != null)
          return;
        S._store.validated = !0;
        var J = Zo(F);
        if (jn[J])
          return;
        jn[J] = !0;
        var ae = "";
        S && S._owner && S._owner !== Qt.current && (ae = " It was passed a child from " + j(S._owner.type) + "."), er(S), O('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', J, ae), er(null);
      }
    }
    function at(S, F) {
      {
        if (typeof S != "object")
          return;
        if (re(S))
          for (var J = 0; J < S.length; J++) {
            var ae = S[J];
            Ur(ae) && se(ae, F);
          }
        else if (Ur(S))
          S._store && (S._store.validated = !0);
        else if (S) {
          var xe = x(S);
          if (typeof xe == "function" && xe !== S.entries)
            for (var $e = xe.call(S), pe; !(pe = $e.next()).done; )
              Ur(pe.value) && se(pe.value, F);
        }
      }
    }
    function _n(S) {
      {
        var F = S.type;
        if (F == null || typeof F == "string")
          return;
        var J;
        if (typeof F == "function")
          J = F.propTypes;
        else if (typeof F == "object" && (F.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        F.$$typeof === f))
          J = F.propTypes;
        else
          return;
        if (J) {
          var ae = j(F);
          De(J, S.props, "prop", ae, S);
        } else if (F.PropTypes !== void 0 && !Wr) {
          Wr = !0;
          var xe = j(F);
          O("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", xe || "Unknown");
        }
        typeof F.getDefaultProps == "function" && !F.getDefaultProps.isReactClassApproved && O("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Cu(S) {
      {
        for (var F = Object.keys(S.props), J = 0; J < F.length; J++) {
          var ae = F[J];
          if (ae !== "children" && ae !== "key") {
            er(S), O("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ae), er(null);
            break;
          }
        }
        S.ref !== null && (er(S), O("Invalid attribute `ref` supplied to `React.Fragment`."), er(null));
      }
    }
    var Wa = {};
    function Ua(S, F, J, ae, xe, $e) {
      {
        var pe = m(S);
        if (!pe) {
          var ue = "";
          (S === void 0 || typeof S == "object" && S !== null && Object.keys(S).length === 0) && (ue += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var nt = Jo();
          nt ? ue += nt : ue += Mn();
          var He;
          S === null ? He = "null" : re(S) ? He = "array" : S !== void 0 && S.$$typeof === t ? (He = "<" + (j(S.type) || "Unknown") + " />", ue = " Did you accidentally export a JSX literal instead of a component?") : He = typeof S, O("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", He, ue);
        }
        var Ke = Xo(S, F, J, xe, $e);
        if (Ke == null)
          return Ke;
        if (pe) {
          var gt = F.children;
          if (gt !== void 0)
            if (ae)
              if (re(gt)) {
                for (var Er = 0; Er < gt.length; Er++)
                  at(gt[Er], S);
                Object.freeze && Object.freeze(gt);
              } else
                O("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              at(gt, S);
        }
        if (Je.call(F, "key")) {
          var pr = j(S), st = Object.keys(F).filter(function(Pu) {
            return Pu !== "key";
          }), Qo = st.length > 0 ? "{key: someKey, " + st.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Wa[pr + Qo]) {
            var Ru = st.length > 0 ? "{" + st.join(": ..., ") + ": ...}" : "{}";
            O(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Qo, pr, Ru, pr), Wa[pr + Qo] = !0;
          }
        }
        return S === n ? Cu(Ke) : _n(Ke), Ke;
      }
    }
    function Tu(S, F, J) {
      return Ua(S, F, J, !0);
    }
    function Su(S, F, J) {
      return Ua(S, F, J, !1);
    }
    var wu = Su, Ou = Tu;
    qr.Fragment = n, qr.jsx = wu, qr.jsxs = Ou;
  }()), qr;
}
process.env.NODE_ENV === "production" ? bi.exports = Lu() : bi.exports = Bu();
var w = bi.exports;
function nr(e, ...t) {
  const r = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((n) => r.searchParams.append("args[]", n)), `Minified MUI error #${e}; visit ${r} for the full message.`;
}
function io() {
  return io = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, io.apply(null, arguments);
}
function Fu(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function Vu(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var zu = /* @__PURE__ */ function() {
  function e(r) {
    var n = this;
    this._insertTag = function(o) {
      var a;
      n.tags.length === 0 ? n.insertionPoint ? a = n.insertionPoint.nextSibling : n.prepend ? a = n.container.firstChild : a = n.before : a = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(o, a), n.tags.push(o);
    }, this.isSpeedy = r.speedy === void 0 ? !0 : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Vu(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = Fu(o);
      try {
        a.insertRule(n, a.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      var o;
      return (o = n.parentNode) == null ? void 0 : o.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), et = "-ms-", ao = "-moz-", fe = "-webkit-", vl = "comm", qi = "rule", Ki = "decl", Wu = "@import", bl = "@keyframes", Uu = "@layer", Hu = Math.abs, To = String.fromCharCode, Yu = Object.assign;
function qu(e, t) {
  return Qe(e, 0) ^ 45 ? (((t << 2 ^ Qe(e, 0)) << 2 ^ Qe(e, 1)) << 2 ^ Qe(e, 2)) << 2 ^ Qe(e, 3) : 0;
}
function xl(e) {
  return e.trim();
}
function Ku(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function me(e, t, r) {
  return e.replace(t, r);
}
function xi(e, t) {
  return e.indexOf(t);
}
function Qe(e, t) {
  return e.charCodeAt(t) | 0;
}
function pn(e, t, r) {
  return e.slice(t, r);
}
function It(e) {
  return e.length;
}
function Gi(e) {
  return e.length;
}
function Ln(e, t) {
  return t.push(e), e;
}
function Gu(e, t) {
  return e.map(t).join("");
}
var So = 1, Ar = 1, El = 0, ut = 0, Ge = 0, Lr = "";
function wo(e, t, r, n, o, a, s) {
  return { value: e, root: t, parent: r, type: n, props: o, children: a, line: So, column: Ar, length: s, return: "" };
}
function Kr(e, t) {
  return Yu(wo("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Xu() {
  return Ge;
}
function Ju() {
  return Ge = ut > 0 ? Qe(Lr, --ut) : 0, Ar--, Ge === 10 && (Ar = 1, So--), Ge;
}
function ft() {
  return Ge = ut < El ? Qe(Lr, ut++) : 0, Ar++, Ge === 10 && (Ar = 1, So++), Ge;
}
function _t() {
  return Qe(Lr, ut);
}
function Xn() {
  return ut;
}
function Cn(e, t) {
  return pn(Lr, e, t);
}
function fn(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Cl(e) {
  return So = Ar = 1, El = It(Lr = e), ut = 0, [];
}
function Tl(e) {
  return Lr = "", e;
}
function Jn(e) {
  return xl(Cn(ut - 1, Ei(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Zu(e) {
  for (; (Ge = _t()) && Ge < 33; )
    ft();
  return fn(e) > 2 || fn(Ge) > 3 ? "" : " ";
}
function Qu(e, t) {
  for (; --t && ft() && !(Ge < 48 || Ge > 102 || Ge > 57 && Ge < 65 || Ge > 70 && Ge < 97); )
    ;
  return Cn(e, Xn() + (t < 6 && _t() == 32 && ft() == 32));
}
function Ei(e) {
  for (; ft(); )
    switch (Ge) {
      case e:
        return ut;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Ei(Ge);
        break;
      case 40:
        e === 41 && Ei(e);
        break;
      case 92:
        ft();
        break;
    }
  return ut;
}
function ed(e, t) {
  for (; ft() && e + Ge !== 57; )
    if (e + Ge === 84 && _t() === 47)
      break;
  return "/*" + Cn(t, ut - 1) + "*" + To(e === 47 ? e : ft());
}
function td(e) {
  for (; !fn(_t()); )
    ft();
  return Cn(e, ut);
}
function rd(e) {
  return Tl(Zn("", null, null, null, [""], e = Cl(e), 0, [0], e));
}
function Zn(e, t, r, n, o, a, s, l, c) {
  for (var u = 0, p = 0, f = s, g = 0, v = 0, y = 0, d = 1, x = 1, b = 1, O = 0, T = "", E = o, C = a, $ = n, P = T; x; )
    switch (y = O, O = ft()) {
      case 40:
        if (y != 108 && Qe(P, f - 1) == 58) {
          xi(P += me(Jn(O), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        P += Jn(O);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        P += Zu(y);
        break;
      case 92:
        P += Qu(Xn() - 1, 7);
        continue;
      case 47:
        switch (_t()) {
          case 42:
          case 47:
            Ln(nd(ed(ft(), Xn()), t, r), c);
            break;
          default:
            P += "/";
        }
        break;
      case 123 * d:
        l[u++] = It(P) * b;
      case 125 * d:
      case 59:
      case 0:
        switch (O) {
          case 0:
          case 125:
            x = 0;
          case 59 + p:
            b == -1 && (P = me(P, /\f/g, "")), v > 0 && It(P) - f && Ln(v > 32 ? Ka(P + ";", n, r, f - 1) : Ka(me(P, " ", "") + ";", n, r, f - 2), c);
            break;
          case 59:
            P += ";";
          default:
            if (Ln($ = qa(P, t, r, u, p, o, l, T, E = [], C = [], f), a), O === 123)
              if (p === 0)
                Zn(P, t, $, $, E, a, f, l, C);
              else
                switch (g === 99 && Qe(P, 3) === 110 ? 100 : g) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Zn(e, $, $, n && Ln(qa(e, $, $, 0, 0, o, l, T, o, E = [], f), C), o, C, f, l, n ? E : C);
                    break;
                  default:
                    Zn(P, $, $, $, [""], C, 0, l, C);
                }
        }
        u = p = v = 0, d = b = 1, T = P = "", f = s;
        break;
      case 58:
        f = 1 + It(P), v = y;
      default:
        if (d < 1) {
          if (O == 123)
            --d;
          else if (O == 125 && d++ == 0 && Ju() == 125)
            continue;
        }
        switch (P += To(O), O * d) {
          case 38:
            b = p > 0 ? 1 : (P += "\f", -1);
            break;
          case 44:
            l[u++] = (It(P) - 1) * b, b = 1;
            break;
          case 64:
            _t() === 45 && (P += Jn(ft())), g = _t(), p = f = It(T = P += td(Xn())), O++;
            break;
          case 45:
            y === 45 && It(P) == 2 && (d = 0);
        }
    }
  return a;
}
function qa(e, t, r, n, o, a, s, l, c, u, p) {
  for (var f = o - 1, g = o === 0 ? a : [""], v = Gi(g), y = 0, d = 0, x = 0; y < n; ++y)
    for (var b = 0, O = pn(e, f + 1, f = Hu(d = s[y])), T = e; b < v; ++b)
      (T = xl(d > 0 ? g[b] + " " + O : me(O, /&\f/g, g[b]))) && (c[x++] = T);
  return wo(e, t, r, o === 0 ? qi : l, c, u, p);
}
function nd(e, t, r) {
  return wo(e, t, r, vl, To(Xu()), pn(e, 2, -2), 0);
}
function Ka(e, t, r, n) {
  return wo(e, t, r, Ki, pn(e, 0, n), pn(e, n + 1, -1), n);
}
function Ir(e, t) {
  for (var r = "", n = Gi(e), o = 0; o < n; o++)
    r += t(e[o], o, e, t) || "";
  return r;
}
function od(e, t, r, n) {
  switch (e.type) {
    case Uu:
      if (e.children.length) break;
    case Wu:
    case Ki:
      return e.return = e.return || e.value;
    case vl:
      return "";
    case bl:
      return e.return = e.value + "{" + Ir(e.children, n) + "}";
    case qi:
      e.value = e.props.join(",");
  }
  return It(r = Ir(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function id(e) {
  var t = Gi(e);
  return function(r, n, o, a) {
    for (var s = "", l = 0; l < t; l++)
      s += e[l](r, n, o, a) || "";
    return s;
  };
}
function ad(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function Sl(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var sd = function(t, r, n) {
  for (var o = 0, a = 0; o = a, a = _t(), o === 38 && a === 12 && (r[n] = 1), !fn(a); )
    ft();
  return Cn(t, ut);
}, ld = function(t, r) {
  var n = -1, o = 44;
  do
    switch (fn(o)) {
      case 0:
        o === 38 && _t() === 12 && (r[n] = 1), t[n] += sd(ut - 1, r, n);
        break;
      case 2:
        t[n] += Jn(o);
        break;
      case 4:
        if (o === 44) {
          t[++n] = _t() === 58 ? "&\f" : "", r[n] = t[n].length;
          break;
        }
      default:
        t[n] += To(o);
    }
  while (o = ft());
  return t;
}, cd = function(t, r) {
  return Tl(ld(Cl(t), r));
}, Ga = /* @__PURE__ */ new WeakMap(), ud = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var r = t.value, n = t.parent, o = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(t.props.length === 1 && r.charCodeAt(0) !== 58 && !Ga.get(n)) && !o) {
      Ga.set(t, !0);
      for (var a = [], s = cd(r, a), l = n.props, c = 0, u = 0; c < s.length; c++)
        for (var p = 0; p < l.length; p++, u++)
          t.props[u] = a[c] ? s[c].replace(/&\f/g, l[p]) : l[p] + " " + s[c];
    }
  }
}, dd = function(t) {
  if (t.type === "decl") {
    var r = t.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function wl(e, t) {
  switch (qu(e, t)) {
    case 5103:
      return fe + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return fe + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return fe + e + ao + e + et + e + e;
    case 6828:
    case 4268:
      return fe + e + et + e + e;
    case 6165:
      return fe + e + et + "flex-" + e + e;
    case 5187:
      return fe + e + me(e, /(\w+).+(:[^]+)/, fe + "box-$1$2" + et + "flex-$1$2") + e;
    case 5443:
      return fe + e + et + "flex-item-" + me(e, /flex-|-self/, "") + e;
    case 4675:
      return fe + e + et + "flex-line-pack" + me(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return fe + e + et + me(e, "shrink", "negative") + e;
    case 5292:
      return fe + e + et + me(e, "basis", "preferred-size") + e;
    case 6060:
      return fe + "box-" + me(e, "-grow", "") + fe + e + et + me(e, "grow", "positive") + e;
    case 4554:
      return fe + me(e, /([^-])(transform)/g, "$1" + fe + "$2") + e;
    case 6187:
      return me(me(me(e, /(zoom-|grab)/, fe + "$1"), /(image-set)/, fe + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return me(e, /(image-set\([^]*)/, fe + "$1$`$1");
    case 4968:
      return me(me(e, /(.+:)(flex-)?(.*)/, fe + "box-pack:$3" + et + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + fe + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return me(e, /(.+)-inline(.+)/, fe + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (It(e) - 1 - t > 6) switch (Qe(e, t + 1)) {
        case 109:
          if (Qe(e, t + 4) !== 45) break;
        case 102:
          return me(e, /(.+:)(.+)-([^]+)/, "$1" + fe + "$2-$3$1" + ao + (Qe(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~xi(e, "stretch") ? wl(me(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (Qe(e, t + 1) !== 115) break;
    case 6444:
      switch (Qe(e, It(e) - 3 - (~xi(e, "!important") && 10))) {
        case 107:
          return me(e, ":", ":" + fe) + e;
        case 101:
          return me(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + fe + (Qe(e, 14) === 45 ? "inline-" : "") + "box$3$1" + fe + "$2$3$1" + et + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Qe(e, t + 11)) {
        case 114:
          return fe + e + et + me(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return fe + e + et + me(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return fe + e + et + me(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return fe + e + et + e + e;
  }
  return e;
}
var pd = function(t, r, n, o) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case Ki:
      t.return = wl(t.value, t.length);
      break;
    case bl:
      return Ir([Kr(t, {
        value: me(t.value, "@", "@" + fe)
      })], o);
    case qi:
      if (t.length) return Gu(t.props, function(a) {
        switch (Ku(a, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Ir([Kr(t, {
              props: [me(a, /:(read-\w+)/, ":" + ao + "$1")]
            })], o);
          case "::placeholder":
            return Ir([Kr(t, {
              props: [me(a, /:(plac\w+)/, ":" + fe + "input-$1")]
            }), Kr(t, {
              props: [me(a, /:(plac\w+)/, ":" + ao + "$1")]
            }), Kr(t, {
              props: [me(a, /:(plac\w+)/, et + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, fd = [pd], md = function(t) {
  var r = t.key;
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(d) {
      var x = d.getAttribute("data-emotion");
      x.indexOf(" ") !== -1 && (document.head.appendChild(d), d.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || fd, a = {}, s, l = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(d) {
      for (var x = d.getAttribute("data-emotion").split(" "), b = 1; b < x.length; b++)
        a[x[b]] = !0;
      l.push(d);
    }
  );
  var c, u = [ud, dd];
  {
    var p, f = [od, ad(function(d) {
      p.insert(d);
    })], g = id(u.concat(o, f)), v = function(x) {
      return Ir(rd(x), g);
    };
    c = function(x, b, O, T) {
      p = O, v(x ? x + "{" + b.styles + "}" : b.styles), T && (y.inserted[b.name] = !0);
    };
  }
  var y = {
    key: r,
    sheet: new zu({
      key: r,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: c
  };
  return y.sheet.hydrate(l), y;
}, Bn = { exports: {} }, Ee = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xa;
function hd() {
  if (Xa) return Ee;
  Xa = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, d = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, O = e ? Symbol.for("react.scope") : 60119;
  function T(C) {
    if (typeof C == "object" && C !== null) {
      var $ = C.$$typeof;
      switch ($) {
        case t:
          switch (C = C.type, C) {
            case c:
            case u:
            case n:
            case a:
            case o:
            case f:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case l:
                case p:
                case y:
                case v:
                case s:
                  return C;
                default:
                  return $;
              }
          }
        case r:
          return $;
      }
    }
  }
  function E(C) {
    return T(C) === u;
  }
  return Ee.AsyncMode = c, Ee.ConcurrentMode = u, Ee.ContextConsumer = l, Ee.ContextProvider = s, Ee.Element = t, Ee.ForwardRef = p, Ee.Fragment = n, Ee.Lazy = y, Ee.Memo = v, Ee.Portal = r, Ee.Profiler = a, Ee.StrictMode = o, Ee.Suspense = f, Ee.isAsyncMode = function(C) {
    return E(C) || T(C) === c;
  }, Ee.isConcurrentMode = E, Ee.isContextConsumer = function(C) {
    return T(C) === l;
  }, Ee.isContextProvider = function(C) {
    return T(C) === s;
  }, Ee.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, Ee.isForwardRef = function(C) {
    return T(C) === p;
  }, Ee.isFragment = function(C) {
    return T(C) === n;
  }, Ee.isLazy = function(C) {
    return T(C) === y;
  }, Ee.isMemo = function(C) {
    return T(C) === v;
  }, Ee.isPortal = function(C) {
    return T(C) === r;
  }, Ee.isProfiler = function(C) {
    return T(C) === a;
  }, Ee.isStrictMode = function(C) {
    return T(C) === o;
  }, Ee.isSuspense = function(C) {
    return T(C) === f;
  }, Ee.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === n || C === u || C === a || C === o || C === f || C === g || typeof C == "object" && C !== null && (C.$$typeof === y || C.$$typeof === v || C.$$typeof === s || C.$$typeof === l || C.$$typeof === p || C.$$typeof === x || C.$$typeof === b || C.$$typeof === O || C.$$typeof === d);
  }, Ee.typeOf = T, Ee;
}
var Ce = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ja;
function gd() {
  return Ja || (Ja = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, d = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, O = e ? Symbol.for("react.scope") : 60119;
    function T(L) {
      return typeof L == "string" || typeof L == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      L === n || L === u || L === a || L === o || L === f || L === g || typeof L == "object" && L !== null && (L.$$typeof === y || L.$$typeof === v || L.$$typeof === s || L.$$typeof === l || L.$$typeof === p || L.$$typeof === x || L.$$typeof === b || L.$$typeof === O || L.$$typeof === d);
    }
    function E(L) {
      if (typeof L == "object" && L !== null) {
        var de = L.$$typeof;
        switch (de) {
          case t:
            var Se = L.type;
            switch (Se) {
              case c:
              case u:
              case n:
              case a:
              case o:
              case f:
                return Se;
              default:
                var Ae = Se && Se.$$typeof;
                switch (Ae) {
                  case l:
                  case p:
                  case y:
                  case v:
                  case s:
                    return Ae;
                  default:
                    return de;
                }
            }
          case r:
            return de;
        }
      }
    }
    var C = c, $ = u, P = l, k = s, I = t, m = p, R = n, _ = y, j = v, V = r, D = a, M = o, U = f, te = !1;
    function Y(L) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), N(L) || E(L) === c;
    }
    function N(L) {
      return E(L) === u;
    }
    function B(L) {
      return E(L) === l;
    }
    function H(L) {
      return E(L) === s;
    }
    function q(L) {
      return typeof L == "object" && L !== null && L.$$typeof === t;
    }
    function G(L) {
      return E(L) === p;
    }
    function Q(L) {
      return E(L) === n;
    }
    function z(L) {
      return E(L) === y;
    }
    function K(L) {
      return E(L) === v;
    }
    function X(L) {
      return E(L) === r;
    }
    function ie(L) {
      return E(L) === a;
    }
    function W(L) {
      return E(L) === o;
    }
    function ne(L) {
      return E(L) === f;
    }
    Ce.AsyncMode = C, Ce.ConcurrentMode = $, Ce.ContextConsumer = P, Ce.ContextProvider = k, Ce.Element = I, Ce.ForwardRef = m, Ce.Fragment = R, Ce.Lazy = _, Ce.Memo = j, Ce.Portal = V, Ce.Profiler = D, Ce.StrictMode = M, Ce.Suspense = U, Ce.isAsyncMode = Y, Ce.isConcurrentMode = N, Ce.isContextConsumer = B, Ce.isContextProvider = H, Ce.isElement = q, Ce.isForwardRef = G, Ce.isFragment = Q, Ce.isLazy = z, Ce.isMemo = K, Ce.isPortal = X, Ce.isProfiler = ie, Ce.isStrictMode = W, Ce.isSuspense = ne, Ce.isValidElementType = T, Ce.typeOf = E;
  }()), Ce;
}
var Za;
function Xi() {
  return Za || (Za = 1, process.env.NODE_ENV === "production" ? Bn.exports = hd() : Bn.exports = gd()), Bn.exports;
}
var Ol = Xi(), yd = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, vd = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Rl = {};
Rl[Ol.ForwardRef] = yd;
Rl[Ol.Memo] = vd;
var bd = !0;
function Pl(e, t, r) {
  var n = "";
  return r.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : o && (n += o + " ");
  }), n;
}
var Ji = function(t, r, n) {
  var o = t.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  bd === !1) && t.registered[o] === void 0 && (t.registered[o] = r.styles);
}, Zi = function(t, r, n) {
  Ji(t, r, n);
  var o = t.key + "-" + r.name;
  if (t.inserted[r.name] === void 0) {
    var a = r;
    do
      t.insert(r === a ? "." + o : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function xd(e) {
  for (var t = 0, r, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Ed = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Cd = /[A-Z]|^ms/g, Td = /_EMO_([^_]+?)_([^]*?)_EMO_/g, $l = function(t) {
  return t.charCodeAt(1) === 45;
}, Qa = function(t) {
  return t != null && typeof t != "boolean";
}, ei = /* @__PURE__ */ Sl(function(e) {
  return $l(e) ? e : e.replace(Cd, "-$&").toLowerCase();
}), es = function(t, r) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(Td, function(n, o, a) {
          return Nt = {
            name: o,
            styles: a,
            next: Nt
          }, o;
        });
  }
  return Ed[t] !== 1 && !$l(t) && typeof r == "number" && r !== 0 ? r + "px" : r;
};
function mn(e, t, r) {
  if (r == null)
    return "";
  var n = r;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      var o = r;
      if (o.anim === 1)
        return Nt = {
          name: o.name,
          styles: o.styles,
          next: Nt
        }, o.name;
      var a = r;
      if (a.styles !== void 0) {
        var s = a.next;
        if (s !== void 0)
          for (; s !== void 0; )
            Nt = {
              name: s.name,
              styles: s.styles,
              next: Nt
            }, s = s.next;
        var l = a.styles + ";";
        return l;
      }
      return Sd(e, t, r);
    }
    case "function": {
      if (e !== void 0) {
        var c = Nt, u = r(e);
        return Nt = c, mn(e, t, u);
      }
      break;
    }
  }
  var p = r;
  if (t == null)
    return p;
  var f = t[p];
  return f !== void 0 ? f : p;
}
function Sd(e, t, r) {
  var n = "";
  if (Array.isArray(r))
    for (var o = 0; o < r.length; o++)
      n += mn(e, t, r[o]) + ";";
  else
    for (var a in r) {
      var s = r[a];
      if (typeof s != "object") {
        var l = s;
        t != null && t[l] !== void 0 ? n += a + "{" + t[l] + "}" : Qa(l) && (n += ei(a) + ":" + es(a, l) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
        for (var c = 0; c < s.length; c++)
          Qa(s[c]) && (n += ei(a) + ":" + es(a, s[c]) + ";");
      else {
        var u = mn(e, t, s);
        switch (a) {
          case "animation":
          case "animationName": {
            n += ei(a) + ":" + u + ";";
            break;
          }
          default:
            n += a + "{" + u + "}";
        }
      }
    }
  return n;
}
var ts = /label:\s*([^\s;{]+)\s*(;|$)/g, Nt;
function Tn(e, t, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var n = !0, o = "";
  Nt = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    n = !1, o += mn(r, t, a);
  else {
    var s = a;
    o += s[0];
  }
  for (var l = 1; l < e.length; l++)
    if (o += mn(r, t, e[l]), n) {
      var c = a;
      o += c[l];
    }
  ts.lastIndex = 0;
  for (var u = "", p; (p = ts.exec(o)) !== null; )
    u += "-" + p[1];
  var f = xd(o) + u;
  return {
    name: f,
    styles: o,
    next: Nt
  };
}
var wd = function(t) {
  return t();
}, kl = h.useInsertionEffect ? h.useInsertionEffect : !1, Il = kl || wd, rs = kl || h.useLayoutEffect, Nl = /* @__PURE__ */ h.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ md({
    key: "css"
  }) : null
);
Nl.Provider;
var Qi = function(t) {
  return /* @__PURE__ */ Iu(function(r, n) {
    var o = Nu(Nl);
    return t(r, o, n);
  });
}, Sn = /* @__PURE__ */ h.createContext({}), ea = {}.hasOwnProperty, Ci = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Od = function(t, r) {
  var n = {};
  for (var o in r)
    ea.call(r, o) && (n[o] = r[o]);
  return n[Ci] = t, n;
}, Rd = function(t) {
  var r = t.cache, n = t.serialized, o = t.isStringTag;
  return Ji(r, n, o), Il(function() {
    return Zi(r, n, o);
  }), null;
}, Pd = /* @__PURE__ */ Qi(function(e, t, r) {
  var n = e.css;
  typeof n == "string" && t.registered[n] !== void 0 && (n = t.registered[n]);
  var o = e[Ci], a = [n], s = "";
  typeof e.className == "string" ? s = Pl(t.registered, a, e.className) : e.className != null && (s = e.className + " ");
  var l = Tn(a, void 0, h.useContext(Sn));
  s += t.key + "-" + l.name;
  var c = {};
  for (var u in e)
    ea.call(e, u) && u !== "css" && u !== Ci && (c[u] = e[u]);
  return c.className = s, r && (c.ref = r), /* @__PURE__ */ h.createElement(h.Fragment, null, /* @__PURE__ */ h.createElement(Rd, {
    cache: t,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ h.createElement(o, c));
}), $d = Pd, ns = function(t, r) {
  var n = arguments;
  if (r == null || !ea.call(r, "css"))
    return h.createElement.apply(void 0, n);
  var o = n.length, a = new Array(o);
  a[0] = $d, a[1] = Od(t, r);
  for (var s = 2; s < o; s++)
    a[s] = n[s];
  return h.createElement.apply(null, a);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(ns || (ns = {}));
var kd = /* @__PURE__ */ Qi(function(e, t) {
  var r = e.styles, n = Tn([r], void 0, h.useContext(Sn)), o = h.useRef();
  return rs(function() {
    var a = t.key + "-global", s = new t.sheet.constructor({
      key: a,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), l = !1, c = document.querySelector('style[data-emotion="' + a + " " + n.name + '"]');
    return t.sheet.tags.length && (s.before = t.sheet.tags[0]), c !== null && (l = !0, c.setAttribute("data-emotion", a), s.hydrate([c])), o.current = [s, l], function() {
      s.flush();
    };
  }, [t]), rs(function() {
    var a = o.current, s = a[0], l = a[1];
    if (l) {
      a[1] = !1;
      return;
    }
    if (n.next !== void 0 && Zi(t, n.next, !0), s.tags.length) {
      var c = s.tags[s.tags.length - 1].nextElementSibling;
      s.before = c, s.flush();
    }
    t.insert("", n, s, !1);
  }, [t, n.name]), null;
});
function ta() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return Tn(t);
}
function wn() {
  var e = ta.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var Id = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Nd = /* @__PURE__ */ Sl(
  function(e) {
    return Id.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Ad = Nd, Md = function(t) {
  return t !== "theme";
}, os = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? Ad : Md;
}, is = function(t, r, n) {
  var o;
  if (r) {
    var a = r.shouldForwardProp;
    o = t.__emotion_forwardProp && a ? function(s) {
      return t.__emotion_forwardProp(s) && a(s);
    } : a;
  }
  return typeof o != "function" && n && (o = t.__emotion_forwardProp), o;
}, jd = function(t) {
  var r = t.cache, n = t.serialized, o = t.isStringTag;
  return Ji(r, n, o), Il(function() {
    return Zi(r, n, o);
  }), null;
}, _d = function e(t, r) {
  var n = t.__emotion_real === t, o = n && t.__emotion_base || t, a, s;
  r !== void 0 && (a = r.label, s = r.target);
  var l = is(t, r, n), c = l || os(o), u = !c("as");
  return function() {
    var p = arguments, f = n && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (a !== void 0 && f.push("label:" + a + ";"), p[0] == null || p[0].raw === void 0)
      f.push.apply(f, p);
    else {
      var g = p[0];
      f.push(g[0]);
      for (var v = p.length, y = 1; y < v; y++)
        f.push(p[y], g[y]);
    }
    var d = Qi(function(x, b, O) {
      var T = u && x.as || o, E = "", C = [], $ = x;
      if (x.theme == null) {
        $ = {};
        for (var P in x)
          $[P] = x[P];
        $.theme = h.useContext(Sn);
      }
      typeof x.className == "string" ? E = Pl(b.registered, C, x.className) : x.className != null && (E = x.className + " ");
      var k = Tn(f.concat(C), b.registered, $);
      E += b.key + "-" + k.name, s !== void 0 && (E += " " + s);
      var I = u && l === void 0 ? os(T) : c, m = {};
      for (var R in x)
        u && R === "as" || I(R) && (m[R] = x[R]);
      return m.className = E, O && (m.ref = O), /* @__PURE__ */ h.createElement(h.Fragment, null, /* @__PURE__ */ h.createElement(jd, {
        cache: b,
        serialized: k,
        isStringTag: typeof T == "string"
      }), /* @__PURE__ */ h.createElement(T, m));
    });
    return d.displayName = a !== void 0 ? a : "Styled(" + (typeof o == "string" ? o : o.displayName || o.name || "Component") + ")", d.defaultProps = t.defaultProps, d.__emotion_real = d, d.__emotion_base = o, d.__emotion_styles = f, d.__emotion_forwardProp = l, Object.defineProperty(d, "toString", {
      value: function() {
        return "." + s;
      }
    }), d.withComponent = function(x, b) {
      var O = e(x, io({}, r, b, {
        shouldForwardProp: is(d, b, !0)
      }));
      return O.apply(void 0, f);
    }, d;
  };
}, Dd = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], Ti = _d.bind(null);
Dd.forEach(function(e) {
  Ti[e] = Ti(e);
});
var Si = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ti, as;
function Ld() {
  if (as) return ti;
  as = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var s = {}, l = 0; l < 10; l++)
        s["_" + String.fromCharCode(l)] = l;
      var c = Object.getOwnPropertyNames(s).map(function(p) {
        return s[p];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        u[p] = p;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ti = o() ? Object.assign : function(a, s) {
    for (var l, c = n(a), u, p = 1; p < arguments.length; p++) {
      l = Object(arguments[p]);
      for (var f in l)
        t.call(l, f) && (c[f] = l[f]);
      if (e) {
        u = e(l);
        for (var g = 0; g < u.length; g++)
          r.call(l, u[g]) && (c[u[g]] = l[u[g]]);
      }
    }
    return c;
  }, ti;
}
var ri, ss;
function ra() {
  if (ss) return ri;
  ss = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ri = e, ri;
}
var ni, ls;
function Al() {
  return ls || (ls = 1, ni = Function.call.bind(Object.prototype.hasOwnProperty)), ni;
}
var oi, cs;
function Bd() {
  if (cs) return oi;
  cs = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = ra(), r = {}, n = Al();
    e = function(a) {
      var s = "Warning: " + a;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(a, s, l, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in a)
        if (n(a, p)) {
          var f;
          try {
            if (typeof a[p] != "function") {
              var g = Error(
                (c || "React class") + ": " + l + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            f = a[p](s, p, c, l, null, t);
          } catch (y) {
            f = y;
          }
          if (f && !(f instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var v = u ? u() : "";
            e(
              "Failed " + l + " type: " + f.message + (v ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, oi = o, oi;
}
var ii, us;
function Fd() {
  if (us) return ii;
  us = 1;
  var e = Xi(), t = Ld(), r = ra(), n = Al(), o = Bd(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return ii = function(l, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function f(N) {
      var B = N && (u && N[u] || N[p]);
      if (typeof B == "function")
        return B;
    }
    var g = "<<anonymous>>", v = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: O(),
      arrayOf: T,
      element: E(),
      elementType: C(),
      instanceOf: $,
      node: m(),
      objectOf: k,
      oneOf: P,
      oneOfType: I,
      shape: _,
      exact: j
    };
    function y(N, B) {
      return N === B ? N !== 0 || 1 / N === 1 / B : N !== N && B !== B;
    }
    function d(N, B) {
      this.message = N, this.data = B && typeof B == "object" ? B : {}, this.stack = "";
    }
    d.prototype = Error.prototype;
    function x(N) {
      if (process.env.NODE_ENV !== "production")
        var B = {}, H = 0;
      function q(Q, z, K, X, ie, W, ne) {
        if (X = X || g, W = W || K, ne !== r) {
          if (c) {
            var L = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw L.name = "Invariant Violation", L;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var de = X + ":" + K;
            !B[de] && // Avoid spamming the console because they are often not actionable except for lib authors
            H < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + W + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), B[de] = !0, H++);
          }
        }
        return z[K] == null ? Q ? z[K] === null ? new d("The " + ie + " `" + W + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new d("The " + ie + " `" + W + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : N(z, K, X, ie, W);
      }
      var G = q.bind(null, !1);
      return G.isRequired = q.bind(null, !0), G;
    }
    function b(N) {
      function B(H, q, G, Q, z, K) {
        var X = H[q], ie = M(X);
        if (ie !== N) {
          var W = U(X);
          return new d(
            "Invalid " + Q + " `" + z + "` of type " + ("`" + W + "` supplied to `" + G + "`, expected ") + ("`" + N + "`."),
            { expectedType: N }
          );
        }
        return null;
      }
      return x(B);
    }
    function O() {
      return x(s);
    }
    function T(N) {
      function B(H, q, G, Q, z) {
        if (typeof N != "function")
          return new d("Property `" + z + "` of component `" + G + "` has invalid PropType notation inside arrayOf.");
        var K = H[q];
        if (!Array.isArray(K)) {
          var X = M(K);
          return new d("Invalid " + Q + " `" + z + "` of type " + ("`" + X + "` supplied to `" + G + "`, expected an array."));
        }
        for (var ie = 0; ie < K.length; ie++) {
          var W = N(K, ie, G, Q, z + "[" + ie + "]", r);
          if (W instanceof Error)
            return W;
        }
        return null;
      }
      return x(B);
    }
    function E() {
      function N(B, H, q, G, Q) {
        var z = B[H];
        if (!l(z)) {
          var K = M(z);
          return new d("Invalid " + G + " `" + Q + "` of type " + ("`" + K + "` supplied to `" + q + "`, expected a single ReactElement."));
        }
        return null;
      }
      return x(N);
    }
    function C() {
      function N(B, H, q, G, Q) {
        var z = B[H];
        if (!e.isValidElementType(z)) {
          var K = M(z);
          return new d("Invalid " + G + " `" + Q + "` of type " + ("`" + K + "` supplied to `" + q + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return x(N);
    }
    function $(N) {
      function B(H, q, G, Q, z) {
        if (!(H[q] instanceof N)) {
          var K = N.name || g, X = Y(H[q]);
          return new d("Invalid " + Q + " `" + z + "` of type " + ("`" + X + "` supplied to `" + G + "`, expected ") + ("instance of `" + K + "`."));
        }
        return null;
      }
      return x(B);
    }
    function P(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), s;
      function B(H, q, G, Q, z) {
        for (var K = H[q], X = 0; X < N.length; X++)
          if (y(K, N[X]))
            return null;
        var ie = JSON.stringify(N, function(ne, L) {
          var de = U(L);
          return de === "symbol" ? String(L) : L;
        });
        return new d("Invalid " + Q + " `" + z + "` of value `" + String(K) + "` " + ("supplied to `" + G + "`, expected one of " + ie + "."));
      }
      return x(B);
    }
    function k(N) {
      function B(H, q, G, Q, z) {
        if (typeof N != "function")
          return new d("Property `" + z + "` of component `" + G + "` has invalid PropType notation inside objectOf.");
        var K = H[q], X = M(K);
        if (X !== "object")
          return new d("Invalid " + Q + " `" + z + "` of type " + ("`" + X + "` supplied to `" + G + "`, expected an object."));
        for (var ie in K)
          if (n(K, ie)) {
            var W = N(K, ie, G, Q, z + "." + ie, r);
            if (W instanceof Error)
              return W;
          }
        return null;
      }
      return x(B);
    }
    function I(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var B = 0; B < N.length; B++) {
        var H = N[B];
        if (typeof H != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + te(H) + " at index " + B + "."
          ), s;
      }
      function q(G, Q, z, K, X) {
        for (var ie = [], W = 0; W < N.length; W++) {
          var ne = N[W], L = ne(G, Q, z, K, X, r);
          if (L == null)
            return null;
          L.data && n(L.data, "expectedType") && ie.push(L.data.expectedType);
        }
        var de = ie.length > 0 ? ", expected one of type [" + ie.join(", ") + "]" : "";
        return new d("Invalid " + K + " `" + X + "` supplied to " + ("`" + z + "`" + de + "."));
      }
      return x(q);
    }
    function m() {
      function N(B, H, q, G, Q) {
        return V(B[H]) ? null : new d("Invalid " + G + " `" + Q + "` supplied to " + ("`" + q + "`, expected a ReactNode."));
      }
      return x(N);
    }
    function R(N, B, H, q, G) {
      return new d(
        (N || "React class") + ": " + B + " type `" + H + "." + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + G + "`."
      );
    }
    function _(N) {
      function B(H, q, G, Q, z) {
        var K = H[q], X = M(K);
        if (X !== "object")
          return new d("Invalid " + Q + " `" + z + "` of type `" + X + "` " + ("supplied to `" + G + "`, expected `object`."));
        for (var ie in N) {
          var W = N[ie];
          if (typeof W != "function")
            return R(G, Q, z, ie, U(W));
          var ne = W(K, ie, G, Q, z + "." + ie, r);
          if (ne)
            return ne;
        }
        return null;
      }
      return x(B);
    }
    function j(N) {
      function B(H, q, G, Q, z) {
        var K = H[q], X = M(K);
        if (X !== "object")
          return new d("Invalid " + Q + " `" + z + "` of type `" + X + "` " + ("supplied to `" + G + "`, expected `object`."));
        var ie = t({}, H[q], N);
        for (var W in ie) {
          var ne = N[W];
          if (n(N, W) && typeof ne != "function")
            return R(G, Q, z, W, U(ne));
          if (!ne)
            return new d(
              "Invalid " + Q + " `" + z + "` key `" + W + "` supplied to `" + G + "`.\nBad object: " + JSON.stringify(H[q], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(N), null, "  ")
            );
          var L = ne(K, W, G, Q, z + "." + W, r);
          if (L)
            return L;
        }
        return null;
      }
      return x(B);
    }
    function V(N) {
      switch (typeof N) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !N;
        case "object":
          if (Array.isArray(N))
            return N.every(V);
          if (N === null || l(N))
            return !0;
          var B = f(N);
          if (B) {
            var H = B.call(N), q;
            if (B !== N.entries) {
              for (; !(q = H.next()).done; )
                if (!V(q.value))
                  return !1;
            } else
              for (; !(q = H.next()).done; ) {
                var G = q.value;
                if (G && !V(G[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function D(N, B) {
      return N === "symbol" ? !0 : B ? B["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && B instanceof Symbol : !1;
    }
    function M(N) {
      var B = typeof N;
      return Array.isArray(N) ? "array" : N instanceof RegExp ? "object" : D(B, N) ? "symbol" : B;
    }
    function U(N) {
      if (typeof N > "u" || N === null)
        return "" + N;
      var B = M(N);
      if (B === "object") {
        if (N instanceof Date)
          return "date";
        if (N instanceof RegExp)
          return "regexp";
      }
      return B;
    }
    function te(N) {
      var B = U(N);
      switch (B) {
        case "array":
        case "object":
          return "an " + B;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + B;
        default:
          return B;
      }
    }
    function Y(N) {
      return !N.constructor || !N.constructor.name ? g : N.constructor.name;
    }
    return v.checkPropTypes = o, v.resetWarningCache = o.resetWarningCache, v.PropTypes = v, v;
  }, ii;
}
var ai, ds;
function Vd() {
  if (ds) return ai;
  ds = 1;
  var e = ra();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, ai = function() {
    function n(s, l, c, u, p, f) {
      if (f !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, ai;
}
if (process.env.NODE_ENV !== "production") {
  var zd = Xi(), Wd = !0;
  Si.exports = Fd()(zd.isElement, Wd);
} else
  Si.exports = Vd()();
var Ud = Si.exports;
const i = /* @__PURE__ */ Du(Ud);
function Hd(e) {
  return e == null || Object.keys(e).length === 0;
}
function na(e) {
  const {
    styles: t,
    defaultTheme: r = {}
  } = e, n = typeof t == "function" ? (o) => t(Hd(o) ? r : o) : t;
  return /* @__PURE__ */ w.jsx(kd, {
    styles: n
  });
}
process.env.NODE_ENV !== "production" && (na.propTypes = {
  defaultTheme: i.object,
  styles: i.oneOfType([i.array, i.string, i.object, i.func])
});
/**
 * @mui/styled-engine v7.1.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function Ml(e, t) {
  const r = Ti(e, t);
  return process.env.NODE_ENV !== "production" ? (...n) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return n.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : n.some((a) => a === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), r(...n);
  } : r;
}
function Yd(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const ps = [];
function fs(e) {
  return ps[0] = e, Tn(ps);
}
var wi = { exports: {} }, we = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ms;
function qd() {
  if (ms) return we;
  ms = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), g = Symbol.for("react.view_transition"), v = Symbol.for("react.client.reference");
  function y(d) {
    if (typeof d == "object" && d !== null) {
      var x = d.$$typeof;
      switch (x) {
        case e:
          switch (d = d.type, d) {
            case r:
            case o:
            case n:
            case c:
            case u:
            case g:
              return d;
            default:
              switch (d = d && d.$$typeof, d) {
                case s:
                case l:
                case f:
                case p:
                  return d;
                case a:
                  return d;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  return we.ContextConsumer = a, we.ContextProvider = s, we.Element = e, we.ForwardRef = l, we.Fragment = r, we.Lazy = f, we.Memo = p, we.Portal = t, we.Profiler = o, we.StrictMode = n, we.Suspense = c, we.SuspenseList = u, we.isContextConsumer = function(d) {
    return y(d) === a;
  }, we.isContextProvider = function(d) {
    return y(d) === s;
  }, we.isElement = function(d) {
    return typeof d == "object" && d !== null && d.$$typeof === e;
  }, we.isForwardRef = function(d) {
    return y(d) === l;
  }, we.isFragment = function(d) {
    return y(d) === r;
  }, we.isLazy = function(d) {
    return y(d) === f;
  }, we.isMemo = function(d) {
    return y(d) === p;
  }, we.isPortal = function(d) {
    return y(d) === t;
  }, we.isProfiler = function(d) {
    return y(d) === o;
  }, we.isStrictMode = function(d) {
    return y(d) === n;
  }, we.isSuspense = function(d) {
    return y(d) === c;
  }, we.isSuspenseList = function(d) {
    return y(d) === u;
  }, we.isValidElementType = function(d) {
    return typeof d == "string" || typeof d == "function" || d === r || d === o || d === n || d === c || d === u || typeof d == "object" && d !== null && (d.$$typeof === f || d.$$typeof === p || d.$$typeof === s || d.$$typeof === a || d.$$typeof === l || d.$$typeof === v || d.getModuleId !== void 0);
  }, we.typeOf = y, we;
}
var Oe = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hs;
function Kd() {
  return hs || (hs = 1, process.env.NODE_ENV !== "production" && function() {
    function e(d) {
      if (typeof d == "object" && d !== null) {
        var x = d.$$typeof;
        switch (x) {
          case t:
            switch (d = d.type, d) {
              case n:
              case a:
              case o:
              case u:
              case p:
              case v:
                return d;
              default:
                switch (d = d && d.$$typeof, d) {
                  case l:
                  case c:
                  case g:
                  case f:
                    return d;
                  case s:
                    return d;
                  default:
                    return x;
                }
            }
          case r:
            return x;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), v = Symbol.for("react.view_transition"), y = Symbol.for("react.client.reference");
    Oe.ContextConsumer = s, Oe.ContextProvider = l, Oe.Element = t, Oe.ForwardRef = c, Oe.Fragment = n, Oe.Lazy = g, Oe.Memo = f, Oe.Portal = r, Oe.Profiler = a, Oe.StrictMode = o, Oe.Suspense = u, Oe.SuspenseList = p, Oe.isContextConsumer = function(d) {
      return e(d) === s;
    }, Oe.isContextProvider = function(d) {
      return e(d) === l;
    }, Oe.isElement = function(d) {
      return typeof d == "object" && d !== null && d.$$typeof === t;
    }, Oe.isForwardRef = function(d) {
      return e(d) === c;
    }, Oe.isFragment = function(d) {
      return e(d) === n;
    }, Oe.isLazy = function(d) {
      return e(d) === g;
    }, Oe.isMemo = function(d) {
      return e(d) === f;
    }, Oe.isPortal = function(d) {
      return e(d) === r;
    }, Oe.isProfiler = function(d) {
      return e(d) === a;
    }, Oe.isStrictMode = function(d) {
      return e(d) === o;
    }, Oe.isSuspense = function(d) {
      return e(d) === u;
    }, Oe.isSuspenseList = function(d) {
      return e(d) === p;
    }, Oe.isValidElementType = function(d) {
      return typeof d == "string" || typeof d == "function" || d === n || d === a || d === o || d === u || d === p || typeof d == "object" && d !== null && (d.$$typeof === g || d.$$typeof === f || d.$$typeof === l || d.$$typeof === s || d.$$typeof === c || d.$$typeof === y || d.getModuleId !== void 0);
    }, Oe.typeOf = e;
  }()), Oe;
}
process.env.NODE_ENV === "production" ? wi.exports = qd() : wi.exports = Kd();
var so = wi.exports;
function At(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function jl(e) {
  if (/* @__PURE__ */ h.isValidElement(e) || so.isValidElementType(e) || !At(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((r) => {
    t[r] = jl(e[r]);
  }), t;
}
function it(e, t, r = {
  clone: !0
}) {
  const n = r.clone ? {
    ...e
  } : e;
  return At(e) && At(t) && Object.keys(t).forEach((o) => {
    /* @__PURE__ */ h.isValidElement(t[o]) || so.isValidElementType(t[o]) ? n[o] = t[o] : At(t[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && At(e[o]) ? n[o] = it(e[o], t[o], r) : r.clone ? n[o] = At(t[o]) ? jl(t[o]) : t[o] : n[o] = t[o];
  }), n;
}
const Gd = (e) => {
  const t = Object.keys(e).map((r) => ({
    key: r,
    val: e[r]
  })) || [];
  return t.sort((r, n) => r.val - n.val), t.reduce((r, n) => ({
    ...r,
    [n.key]: n.val
  }), {});
};
function Xd(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: r = "px",
    step: n = 5,
    ...o
  } = e, a = Gd(t), s = Object.keys(a);
  function l(g) {
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${r})`;
  }
  function c(g) {
    return `@media (max-width:${(typeof t[g] == "number" ? t[g] : g) - n / 100}${r})`;
  }
  function u(g, v) {
    const y = s.indexOf(v);
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${r}) and (max-width:${(y !== -1 && typeof t[s[y]] == "number" ? t[s[y]] : v) - n / 100}${r})`;
  }
  function p(g) {
    return s.indexOf(g) + 1 < s.length ? u(g, s[s.indexOf(g) + 1]) : l(g);
  }
  function f(g) {
    const v = s.indexOf(g);
    return v === 0 ? l(s[1]) : v === s.length - 1 ? c(s[v]) : u(g, s[s.indexOf(g) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: s,
    values: a,
    up: l,
    down: c,
    between: u,
    only: p,
    not: f,
    unit: r,
    ...o
  };
}
function Jd(e, t) {
  if (!e.containerQueries)
    return t;
  const r = Object.keys(t).filter((n) => n.startsWith("@container")).sort((n, o) => {
    var s, l;
    const a = /min-width:\s*([0-9.]+)/;
    return +(((s = n.match(a)) == null ? void 0 : s[1]) || 0) - +(((l = o.match(a)) == null ? void 0 : l[1]) || 0);
  });
  return r.length ? r.reduce((n, o) => {
    const a = t[o];
    return delete n[o], n[o] = a, n;
  }, {
    ...t
  }) : t;
}
function Zd(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((r) => t.startsWith(`@${r}`)) || !!t.match(/^@\d/));
}
function Qd(e, t) {
  const r = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!r) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : nr(18, `(${t})`));
    return null;
  }
  const [, n, o] = r, a = Number.isNaN(+n) ? n || 0 : +n;
  return e.containerQueries(o).up(a);
}
function ep(e) {
  const t = (a, s) => a.replace("@media", s ? `@container ${s}` : "@container");
  function r(a, s) {
    a.up = (...l) => t(e.breakpoints.up(...l), s), a.down = (...l) => t(e.breakpoints.down(...l), s), a.between = (...l) => t(e.breakpoints.between(...l), s), a.only = (...l) => t(e.breakpoints.only(...l), s), a.not = (...l) => {
      const c = t(e.breakpoints.not(...l), s);
      return c.includes("not all and") ? c.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : c;
    };
  }
  const n = {}, o = (a) => (r(n, a), n);
  return r(o), {
    ...e,
    containerQueries: o
  };
}
const tp = {
  borderRadius: 4
}, cr = process.env.NODE_ENV !== "production" ? i.oneOfType([i.number, i.string, i.object, i.array]) : {};
function an(e, t) {
  return t ? it(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Oo = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, gs = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Oo[e]}px)`
}, rp = {
  containerQueries: (e) => ({
    up: (t) => {
      let r = typeof t == "number" ? t : Oo[t] || t;
      return typeof r == "number" && (r = `${r}px`), e ? `@container ${e} (min-width:${r})` : `@container (min-width:${r})`;
    }
  })
};
function Ot(e, t, r) {
  const n = e.theme || {};
  if (Array.isArray(t)) {
    const a = n.breakpoints || gs;
    return t.reduce((s, l, c) => (s[a.up(a.keys[c])] = r(t[c]), s), {});
  }
  if (typeof t == "object") {
    const a = n.breakpoints || gs;
    return Object.keys(t).reduce((s, l) => {
      if (Zd(a.keys, l)) {
        const c = Qd(n.containerQueries ? n : rp, l);
        c && (s[c] = r(t[l], l));
      } else if (Object.keys(a.values || Oo).includes(l)) {
        const c = a.up(l);
        s[c] = r(t[l], l);
      } else {
        const c = l;
        s[c] = t[c];
      }
      return s;
    }, {});
  }
  return r(t);
}
function _l(e = {}) {
  var r;
  return ((r = e.keys) == null ? void 0 : r.reduce((n, o) => {
    const a = e.up(o);
    return n[a] = {}, n;
  }, {})) || {};
}
function Dl(e, t) {
  return e.reduce((r, n) => {
    const o = r[n];
    return (!o || Object.keys(o).length === 0) && delete r[n], r;
  }, t);
}
function np(e, ...t) {
  const r = _l(e), n = [r, ...t].reduce((o, a) => it(o, a), {});
  return Dl(Object.keys(r), n);
}
function op(e, t) {
  if (typeof e != "object")
    return {};
  const r = {}, n = Object.keys(t);
  return Array.isArray(e) ? n.forEach((o, a) => {
    a < e.length && (r[o] = !0);
  }) : n.forEach((o) => {
    e[o] != null && (r[o] = !0);
  }), r;
}
function si({
  values: e,
  breakpoints: t,
  base: r
}) {
  const n = r || op(e, t), o = Object.keys(n);
  if (o.length === 0)
    return e;
  let a;
  return o.reduce((s, l, c) => (Array.isArray(e) ? (s[l] = e[c] != null ? e[c] : e[a], a = c) : typeof e == "object" ? (s[l] = e[l] != null ? e[l] : e[a], a = l) : s[l] = e, s), {});
}
function Z(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : nr(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Ro(e, t, r = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && r) {
    const n = `vars.${t}`.split(".").reduce((o, a) => o && o[a] ? o[a] : null, e);
    if (n != null)
      return n;
  }
  return t.split(".").reduce((n, o) => n && n[o] != null ? n[o] : null, e);
}
function lo(e, t, r, n = r) {
  let o;
  return typeof e == "function" ? o = e(r) : Array.isArray(e) ? o = e[r] || n : o = Ro(e, r) || n, t && (o = t(o, n, e)), o;
}
function Ye(e) {
  const {
    prop: t,
    cssProperty: r = e.prop,
    themeKey: n,
    transform: o
  } = e, a = (s) => {
    if (s[t] == null)
      return null;
    const l = s[t], c = s.theme, u = Ro(c, n) || {};
    return Ot(s, l, (f) => {
      let g = lo(u, o, f);
      return f === g && typeof f == "string" && (g = lo(u, o, `${t}${f === "default" ? "" : Z(f)}`, f)), r === !1 ? g : {
        [r]: g
      };
    });
  };
  return a.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: cr
  } : {}, a.filterProps = [t], a;
}
function ip(e) {
  const t = {};
  return (r) => (t[r] === void 0 && (t[r] = e(r)), t[r]);
}
const ap = {
  m: "margin",
  p: "padding"
}, sp = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, ys = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, lp = ip((e) => {
  if (e.length > 2)
    if (ys[e])
      e = ys[e];
    else
      return [e];
  const [t, r] = e.split(""), n = ap[t], o = sp[r] || "";
  return Array.isArray(o) ? o.map((a) => n + a) : [n + o];
}), Po = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], $o = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], cp = [...Po, ...$o];
function On(e, t, r, n) {
  const o = Ro(e, t, !0) ?? r;
  return typeof o == "number" || typeof o == "string" ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && typeof a != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${a}.`), typeof o == "string" ? o.startsWith("var(") && a === 0 ? 0 : o.startsWith("var(") && a === 1 ? o : `calc(${a} * ${o})` : o * a) : Array.isArray(o) ? (a) => {
    if (typeof a == "string")
      return a;
    const s = Math.abs(a);
    process.env.NODE_ENV !== "production" && (Number.isInteger(s) ? s > o.length - 1 && console.error([`MUI: The value provided (${s}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${s} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const l = o[s];
    return a >= 0 ? l : typeof l == "number" ? -l : typeof l == "string" && l.startsWith("var(") ? `calc(-1 * ${l})` : `-${l}`;
  } : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function ko(e) {
  return On(e, "spacing", 8, "spacing");
}
function vr(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function up(e, t) {
  return (r) => e.reduce((n, o) => (n[o] = vr(t, r), n), {});
}
function dp(e, t, r, n) {
  if (!t.includes(r))
    return null;
  const o = lp(r), a = up(o, n), s = e[r];
  return Ot(e, s, a);
}
function Ll(e, t) {
  const r = ko(e.theme);
  return Object.keys(e).map((n) => dp(e, t, n, r)).reduce(an, {});
}
function Ve(e) {
  return Ll(e, Po);
}
Ve.propTypes = process.env.NODE_ENV !== "production" ? Po.reduce((e, t) => (e[t] = cr, e), {}) : {};
Ve.filterProps = Po;
function ze(e) {
  return Ll(e, $o);
}
ze.propTypes = process.env.NODE_ENV !== "production" ? $o.reduce((e, t) => (e[t] = cr, e), {}) : {};
ze.filterProps = $o;
process.env.NODE_ENV !== "production" && cp.reduce((e, t) => (e[t] = cr, e), {});
function Bl(e = 8, t = ko({
  spacing: e
})) {
  if (e.mui)
    return e;
  const r = (...n) => (process.env.NODE_ENV !== "production" && (n.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${n.length}`)), (n.length === 0 ? [1] : n).map((a) => {
    const s = t(a);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return r.mui = !0, r;
}
function Io(...e) {
  const t = e.reduce((n, o) => (o.filterProps.forEach((a) => {
    n[a] = o;
  }), n), {}), r = (n) => Object.keys(n).reduce((o, a) => t[a] ? an(o, t[a](n)) : o, {});
  return r.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((n, o) => Object.assign(n, o.propTypes), {}) : {}, r.filterProps = e.reduce((n, o) => n.concat(o.filterProps), []), r;
}
function vt(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Tt(e, t) {
  return Ye({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const pp = Tt("border", vt), fp = Tt("borderTop", vt), mp = Tt("borderRight", vt), hp = Tt("borderBottom", vt), gp = Tt("borderLeft", vt), yp = Tt("borderColor"), vp = Tt("borderTopColor"), bp = Tt("borderRightColor"), xp = Tt("borderBottomColor"), Ep = Tt("borderLeftColor"), Cp = Tt("outline", vt), Tp = Tt("outlineColor"), No = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = On(e.theme, "shape.borderRadius", 4, "borderRadius"), r = (n) => ({
      borderRadius: vr(t, n)
    });
    return Ot(e, e.borderRadius, r);
  }
  return null;
};
No.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: cr
} : {};
No.filterProps = ["borderRadius"];
Io(pp, fp, mp, hp, gp, yp, vp, bp, xp, Ep, No, Cp, Tp);
const Ao = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = On(e.theme, "spacing", 8, "gap"), r = (n) => ({
      gap: vr(t, n)
    });
    return Ot(e, e.gap, r);
  }
  return null;
};
Ao.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: cr
} : {};
Ao.filterProps = ["gap"];
const Mo = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = On(e.theme, "spacing", 8, "columnGap"), r = (n) => ({
      columnGap: vr(t, n)
    });
    return Ot(e, e.columnGap, r);
  }
  return null;
};
Mo.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: cr
} : {};
Mo.filterProps = ["columnGap"];
const jo = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = On(e.theme, "spacing", 8, "rowGap"), r = (n) => ({
      rowGap: vr(t, n)
    });
    return Ot(e, e.rowGap, r);
  }
  return null;
};
jo.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: cr
} : {};
jo.filterProps = ["rowGap"];
const Sp = Ye({
  prop: "gridColumn"
}), wp = Ye({
  prop: "gridRow"
}), Op = Ye({
  prop: "gridAutoFlow"
}), Rp = Ye({
  prop: "gridAutoColumns"
}), Pp = Ye({
  prop: "gridAutoRows"
}), $p = Ye({
  prop: "gridTemplateColumns"
}), kp = Ye({
  prop: "gridTemplateRows"
}), Ip = Ye({
  prop: "gridTemplateAreas"
}), Np = Ye({
  prop: "gridArea"
});
Io(Ao, Mo, jo, Sp, wp, Op, Rp, Pp, $p, kp, Ip, Np);
function Nr(e, t) {
  return t === "grey" ? t : e;
}
const Ap = Ye({
  prop: "color",
  themeKey: "palette",
  transform: Nr
}), Mp = Ye({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Nr
}), jp = Ye({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Nr
});
Io(Ap, Mp, jp);
function pt(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const _p = Ye({
  prop: "width",
  transform: pt
}), oa = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (r) => {
      var o, a, s, l, c;
      const n = ((s = (a = (o = e.theme) == null ? void 0 : o.breakpoints) == null ? void 0 : a.values) == null ? void 0 : s[r]) || Oo[r];
      return n ? ((c = (l = e.theme) == null ? void 0 : l.breakpoints) == null ? void 0 : c.unit) !== "px" ? {
        maxWidth: `${n}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: n
      } : {
        maxWidth: pt(r)
      };
    };
    return Ot(e, e.maxWidth, t);
  }
  return null;
};
oa.filterProps = ["maxWidth"];
const Dp = Ye({
  prop: "minWidth",
  transform: pt
}), Lp = Ye({
  prop: "height",
  transform: pt
}), Bp = Ye({
  prop: "maxHeight",
  transform: pt
}), Fp = Ye({
  prop: "minHeight",
  transform: pt
});
Ye({
  prop: "size",
  cssProperty: "width",
  transform: pt
});
Ye({
  prop: "size",
  cssProperty: "height",
  transform: pt
});
const Vp = Ye({
  prop: "boxSizing"
});
Io(_p, oa, Dp, Lp, Bp, Fp, Vp);
const Rn = {
  // borders
  border: {
    themeKey: "borders",
    transform: vt
  },
  borderTop: {
    themeKey: "borders",
    transform: vt
  },
  borderRight: {
    themeKey: "borders",
    transform: vt
  },
  borderBottom: {
    themeKey: "borders",
    transform: vt
  },
  borderLeft: {
    themeKey: "borders",
    transform: vt
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: vt
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: No
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Nr
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Nr
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Nr
  },
  // spacing
  p: {
    style: ze
  },
  pt: {
    style: ze
  },
  pr: {
    style: ze
  },
  pb: {
    style: ze
  },
  pl: {
    style: ze
  },
  px: {
    style: ze
  },
  py: {
    style: ze
  },
  padding: {
    style: ze
  },
  paddingTop: {
    style: ze
  },
  paddingRight: {
    style: ze
  },
  paddingBottom: {
    style: ze
  },
  paddingLeft: {
    style: ze
  },
  paddingX: {
    style: ze
  },
  paddingY: {
    style: ze
  },
  paddingInline: {
    style: ze
  },
  paddingInlineStart: {
    style: ze
  },
  paddingInlineEnd: {
    style: ze
  },
  paddingBlock: {
    style: ze
  },
  paddingBlockStart: {
    style: ze
  },
  paddingBlockEnd: {
    style: ze
  },
  m: {
    style: Ve
  },
  mt: {
    style: Ve
  },
  mr: {
    style: Ve
  },
  mb: {
    style: Ve
  },
  ml: {
    style: Ve
  },
  mx: {
    style: Ve
  },
  my: {
    style: Ve
  },
  margin: {
    style: Ve
  },
  marginTop: {
    style: Ve
  },
  marginRight: {
    style: Ve
  },
  marginBottom: {
    style: Ve
  },
  marginLeft: {
    style: Ve
  },
  marginX: {
    style: Ve
  },
  marginY: {
    style: Ve
  },
  marginInline: {
    style: Ve
  },
  marginInlineStart: {
    style: Ve
  },
  marginInlineEnd: {
    style: Ve
  },
  marginBlock: {
    style: Ve
  },
  marginBlockStart: {
    style: Ve
  },
  marginBlockEnd: {
    style: Ve
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Ao
  },
  rowGap: {
    style: jo
  },
  columnGap: {
    style: Mo
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: pt
  },
  maxWidth: {
    style: oa
  },
  minWidth: {
    transform: pt
  },
  height: {
    transform: pt
  },
  maxHeight: {
    transform: pt
  },
  minHeight: {
    transform: pt
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function zp(...e) {
  const t = e.reduce((n, o) => n.concat(Object.keys(o)), []), r = new Set(t);
  return e.every((n) => r.size === Object.keys(n).length);
}
function Wp(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Up() {
  function e(r, n, o, a) {
    const s = {
      [r]: n,
      theme: o
    }, l = a[r];
    if (!l)
      return {
        [r]: n
      };
    const {
      cssProperty: c = r,
      themeKey: u,
      transform: p,
      style: f
    } = l;
    if (n == null)
      return null;
    if (u === "typography" && n === "inherit")
      return {
        [r]: n
      };
    const g = Ro(o, u) || {};
    return f ? f(s) : Ot(s, n, (y) => {
      let d = lo(g, p, y);
      return y === d && typeof y == "string" && (d = lo(g, p, `${r}${y === "default" ? "" : Z(y)}`, y)), c === !1 ? d : {
        [c]: d
      };
    });
  }
  function t(r) {
    const {
      sx: n,
      theme: o = {}
    } = r || {};
    if (!n)
      return null;
    const a = o.unstable_sxConfig ?? Rn;
    function s(l) {
      let c = l;
      if (typeof l == "function")
        c = l(o);
      else if (typeof l != "object")
        return l;
      if (!c)
        return null;
      const u = _l(o.breakpoints), p = Object.keys(u);
      let f = u;
      return Object.keys(c).forEach((g) => {
        const v = Wp(c[g], o);
        if (v != null)
          if (typeof v == "object")
            if (a[g])
              f = an(f, e(g, v, o, a));
            else {
              const y = Ot({
                theme: o
              }, v, (d) => ({
                [g]: d
              }));
              zp(y, v) ? f[g] = t({
                sx: v,
                theme: o
              }) : f = an(f, y);
            }
          else
            f = an(f, e(g, v, o, a));
      }), Jd(o, Dl(p, f));
    }
    return Array.isArray(n) ? n.map(s) : s(n);
  }
  return t;
}
const or = Up();
or.filterProps = ["sx"];
function Hp(e, t) {
  var n;
  const r = this;
  if (r.vars) {
    if (!((n = r.colorSchemes) != null && n[e]) || typeof r.getColorSchemeSelector != "function")
      return {};
    let o = r.getColorSchemeSelector(e);
    return o === "&" ? t : ((o.includes("data-") || o.includes(".")) && (o = `*:where(${o.replace(/\s*&$/, "")}) &`), {
      [o]: t
    });
  }
  return r.palette.mode === e ? t : {};
}
function _o(e = {}, ...t) {
  const {
    breakpoints: r = {},
    palette: n = {},
    spacing: o,
    shape: a = {},
    ...s
  } = e, l = Xd(r), c = Bl(o);
  let u = it({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...n
    },
    spacing: c,
    shape: {
      ...tp,
      ...a
    }
  }, s);
  return u = ep(u), u.applyStyles = Hp, u = t.reduce((p, f) => it(p, f), u), u.unstable_sxConfig = {
    ...Rn,
    ...s == null ? void 0 : s.unstable_sxConfig
  }, u.unstable_sx = function(f) {
    return or({
      sx: f,
      theme: this
    });
  }, u;
}
function Yp(e) {
  return Object.keys(e).length === 0;
}
function Fl(e = null) {
  const t = h.useContext(Sn);
  return !t || Yp(t) ? e : t;
}
const qp = _o();
function Do(e = qp) {
  return Fl(e);
}
function Vl({
  styles: e,
  themeId: t,
  defaultTheme: r = {}
}) {
  const n = Do(r), o = typeof e == "function" ? e(t && n[t] || n) : e;
  return /* @__PURE__ */ w.jsx(na, {
    styles: o
  });
}
process.env.NODE_ENV !== "production" && (Vl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: i.object,
  /**
   * @ignore
   */
  styles: i.oneOfType([i.array, i.func, i.number, i.object, i.string, i.bool]),
  /**
   * @ignore
   */
  themeId: i.string
});
const Kp = (e) => {
  var n;
  const t = {
    systemProps: {},
    otherProps: {}
  }, r = ((n = e == null ? void 0 : e.theme) == null ? void 0 : n.unstable_sxConfig) ?? Rn;
  return Object.keys(e).forEach((o) => {
    r[o] ? t.systemProps[o] = e[o] : t.otherProps[o] = e[o];
  }), t;
};
function ia(e) {
  const {
    sx: t,
    ...r
  } = e, {
    systemProps: n,
    otherProps: o
  } = Kp(r);
  let a;
  return Array.isArray(t) ? a = [n, ...t] : typeof t == "function" ? a = (...s) => {
    const l = t(...s);
    return At(l) ? {
      ...n,
      ...l
    } : n;
  } : a = {
    ...n,
    ...t
  }, {
    ...o,
    sx: a
  };
}
const vs = (e) => e, Gp = () => {
  let e = vs;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = vs;
    }
  };
}, zl = Gp();
function Wl(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = Wl(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function oe() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = Wl(e)) && (n && (n += " "), n += t);
  return n;
}
function Xp(e = {}) {
  const {
    themeId: t,
    defaultTheme: r,
    defaultClassName: n = "MuiBox-root",
    generateClassName: o
  } = e, a = Ml("div", {
    shouldForwardProp: (l) => l !== "theme" && l !== "sx" && l !== "as"
  })(or);
  return /* @__PURE__ */ h.forwardRef(function(c, u) {
    const p = Do(r), {
      className: f,
      component: g = "div",
      ...v
    } = ia(c);
    return /* @__PURE__ */ w.jsx(a, {
      as: g,
      ref: u,
      className: oe(f, o ? o(n) : n),
      theme: t && p[t] || p,
      ...v
    });
  });
}
const Jp = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function he(e, t, r = "Mui") {
  const n = Jp[t];
  return n ? `${r}-${n}` : `${zl.generate(e)}-${t}`;
}
function ge(e, t, r = "Mui") {
  const n = {};
  return t.forEach((o) => {
    n[o] = he(e, o, r);
  }), n;
}
function Ul(e, t = "") {
  return e.displayName || e.name || t;
}
function bs(e, t, r) {
  const n = Ul(t);
  return e.displayName || (n !== "" ? `${r}(${n})` : r);
}
function Zp(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return Ul(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case so.ForwardRef:
          return bs(e, e.render, "ForwardRef");
        case so.Memo:
          return bs(e, e.type, "memo");
        default:
          return;
      }
  }
}
function Hl(e) {
  const {
    variants: t,
    ...r
  } = e, n = {
    variants: t,
    style: fs(r),
    isProcessed: !0
  };
  return n.style === r || t && t.forEach((o) => {
    typeof o.style != "function" && (o.style = fs(o.style));
  }), n;
}
const Qp = _o();
function li(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function ef(e) {
  return e ? (t, r) => r[e] : null;
}
function tf(e, t, r) {
  e.theme = of(e.theme) ? r : e.theme[t] || e.theme;
}
function Qn(e, t) {
  const r = typeof t == "function" ? t(e) : t;
  if (Array.isArray(r))
    return r.flatMap((n) => Qn(e, n));
  if (Array.isArray(r == null ? void 0 : r.variants)) {
    let n;
    if (r.isProcessed)
      n = r.style;
    else {
      const {
        variants: o,
        ...a
      } = r;
      n = a;
    }
    return Yl(e, r.variants, [n]);
  }
  return r != null && r.isProcessed ? r.style : r;
}
function Yl(e, t, r = []) {
  var o;
  let n;
  e: for (let a = 0; a < t.length; a += 1) {
    const s = t[a];
    if (typeof s.props == "function") {
      if (n ?? (n = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !s.props(n))
        continue;
    } else
      for (const l in s.props)
        if (e[l] !== s.props[l] && ((o = e.ownerState) == null ? void 0 : o[l]) !== s.props[l])
          continue e;
    typeof s.style == "function" ? (n ?? (n = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), r.push(s.style(n))) : r.push(s.style);
  }
  return r;
}
function ql(e = {}) {
  const {
    themeId: t,
    defaultTheme: r = Qp,
    rootShouldForwardProp: n = li,
    slotShouldForwardProp: o = li
  } = e;
  function a(l) {
    tf(l, t, r);
  }
  return (l, c = {}) => {
    Yd(l, (C) => C.filter(($) => $ !== or));
    const {
      name: u,
      slot: p,
      skipVariantsResolver: f,
      skipSx: g,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: v = ef(Kl(p)),
      ...y
    } = c, d = f !== void 0 ? f : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      p && p !== "Root" && p !== "root" || !1
    ), x = g || !1;
    let b = li;
    p === "Root" || p === "root" ? b = n : p ? b = o : af(l) && (b = void 0);
    const O = Ml(l, {
      shouldForwardProp: b,
      label: nf(u, p),
      ...y
    }), T = (C) => {
      if (C.__emotion_real === C)
        return C;
      if (typeof C == "function")
        return function(P) {
          return Qn(P, C);
        };
      if (At(C)) {
        const $ = Hl(C);
        return $.variants ? function(k) {
          return Qn(k, $);
        } : $.style;
      }
      return C;
    }, E = (...C) => {
      const $ = [], P = C.map(T), k = [];
      if ($.push(a), u && v && k.push(function(_) {
        var M, U;
        const V = (U = (M = _.theme.components) == null ? void 0 : M[u]) == null ? void 0 : U.styleOverrides;
        if (!V)
          return null;
        const D = {};
        for (const te in V)
          D[te] = Qn(_, V[te]);
        return v(_, D);
      }), u && !d && k.push(function(_) {
        var D, M;
        const j = _.theme, V = (M = (D = j == null ? void 0 : j.components) == null ? void 0 : D[u]) == null ? void 0 : M.variants;
        return V ? Yl(_, V) : null;
      }), x || k.push(or), Array.isArray(P[0])) {
        const R = P.shift(), _ = new Array($.length).fill(""), j = new Array(k.length).fill("");
        let V;
        V = [..._, ...R, ...j], V.raw = [..._, ...R.raw, ...j], $.unshift(V);
      }
      const I = [...$, ...P, ...k], m = O(...I);
      return l.muiName && (m.muiName = l.muiName), process.env.NODE_ENV !== "production" && (m.displayName = rf(u, p, l)), m;
    };
    return O.withConfig && (E.withConfig = O.withConfig), E;
  };
}
function rf(e, t, r) {
  return e ? `${e}${Z(t || "")}` : `Styled(${Zp(r)})`;
}
function nf(e, t) {
  let r;
  return process.env.NODE_ENV !== "production" && e && (r = `${e}-${Kl(t || "Root")}`), r;
}
function of(e) {
  for (const t in e)
    return !1;
  return !0;
}
function af(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function Kl(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
const sf = ql();
function hn(e, t) {
  const r = {
    ...t
  };
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      const o = n;
      if (o === "components" || o === "slots")
        r[o] = {
          ...e[o],
          ...r[o]
        };
      else if (o === "componentsProps" || o === "slotProps") {
        const a = e[o], s = t[o];
        if (!s)
          r[o] = a || {};
        else if (!a)
          r[o] = s;
        else {
          r[o] = {
            ...s
          };
          for (const l in a)
            if (Object.prototype.hasOwnProperty.call(a, l)) {
              const c = l;
              r[o][c] = hn(a[c], s[c]);
            }
        }
      } else r[o] === void 0 && (r[o] = e[o]);
    }
  return r;
}
function lf(e) {
  const {
    theme: t,
    name: r,
    props: n
  } = e;
  return !t || !t.components || !t.components[r] || !t.components[r].defaultProps ? n : hn(t.components[r].defaultProps, n);
}
function cf({
  props: e,
  name: t,
  defaultTheme: r,
  themeId: n
}) {
  let o = Do(r);
  return n && (o = o[n] || o), lf({
    theme: o,
    name: t,
    props: e
  });
}
const ir = typeof window < "u" ? h.useLayoutEffect : h.useEffect;
function uf(e, t = Number.MIN_SAFE_INTEGER, r = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, r));
}
function aa(e, t = 0, r = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > r) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${r}].`), uf(e, t, r);
}
function df(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let r = e.match(t);
  return r && r[0].length === 1 && (r = r.map((n) => n + n)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((n, o) => o < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function ar(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return ar(df(e));
  const t = e.indexOf("("), r = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(r))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : nr(9, e));
  let n = e.substring(t + 1, e.length - 1), o;
  if (r === "color") {
    if (n = n.split(" "), o = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(o))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : nr(10, o));
  } else
    n = n.split(",");
  return n = n.map((a) => parseFloat(a)), {
    type: r,
    values: n,
    colorSpace: o
  };
}
const pf = (e) => {
  const t = ar(e);
  return t.values.slice(0, 3).map((r, n) => t.type.includes("hsl") && n !== 0 ? `${r}%` : r).join(" ");
}, tn = (e, t) => {
  try {
    return pf(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function Lo(e) {
  const {
    type: t,
    colorSpace: r
  } = e;
  let {
    values: n
  } = e;
  return t.includes("rgb") ? n = n.map((o, a) => a < 3 ? parseInt(o, 10) : o) : t.includes("hsl") && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.includes("color") ? n = `${r} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function Gl(e) {
  e = ar(e);
  const {
    values: t
  } = e, r = t[0], n = t[1] / 100, o = t[2] / 100, a = n * Math.min(o, 1 - o), s = (u, p = (u + r / 30) % 12) => o - a * Math.max(Math.min(p - 3, 9 - p, 1), -1);
  let l = "rgb";
  const c = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (l += "a", c.push(t[3])), Lo({
    type: l,
    values: c
  });
}
function Oi(e) {
  e = ar(e);
  let t = e.type === "hsl" || e.type === "hsla" ? ar(Gl(e)).values : e.values;
  return t = t.map((r) => (e.type !== "color" && (r /= 255), r <= 0.03928 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function xs(e, t) {
  const r = Oi(e), n = Oi(t);
  return (Math.max(r, n) + 0.05) / (Math.min(r, n) + 0.05);
}
function Ne(e, t) {
  return e = ar(e), t = aa(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Lo(e);
}
function Fn(e, t, r) {
  try {
    return Ne(e, t);
  } catch {
    return e;
  }
}
function sa(e, t) {
  if (e = ar(e), t = aa(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let r = 0; r < 3; r += 1)
      e.values[r] *= 1 - t;
  return Lo(e);
}
function ke(e, t, r) {
  try {
    return sa(e, t);
  } catch {
    return e;
  }
}
function la(e, t) {
  if (e = ar(e), t = aa(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (255 - e.values[r]) * t;
  else if (e.type.includes("color"))
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (1 - e.values[r]) * t;
  return Lo(e);
}
function Ie(e, t, r) {
  try {
    return la(e, t);
  } catch {
    return e;
  }
}
function Ri(e, t = 0.15) {
  return Oi(e) > 0.5 ? sa(e, t) : la(e, t);
}
function Vn(e, t, r) {
  try {
    return Ri(e, t);
  } catch {
    return e;
  }
}
const ff = "exact-prop: ​";
function Bo(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [ff]: (t) => {
      const r = Object.keys(t).filter((n) => !e.hasOwnProperty(n));
      return r.length > 0 ? new Error(`The following props are not supported: ${r.map((n) => `\`${n}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
const ca = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (ca.displayName = "ThemeContext");
function ua() {
  const e = h.useContext(ca);
  return process.env.NODE_ENV !== "production" && h.useDebugValue(e), e;
}
const mf = typeof Symbol == "function" && Symbol.for, hf = mf ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function gf(e, t) {
  if (typeof t == "function") {
    const r = t(e);
    return process.env.NODE_ENV !== "production" && (r || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), r;
  }
  return {
    ...e,
    ...t
  };
}
function co(e) {
  const {
    children: t,
    theme: r
  } = e, n = ua();
  process.env.NODE_ENV !== "production" && n === null && typeof r == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const o = h.useMemo(() => {
    const a = n === null ? {
      ...r
    } : gf(n, r);
    return a != null && (a[hf] = n !== null), a;
  }, [r, n]);
  return /* @__PURE__ */ w.jsx(ca.Provider, {
    value: o,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (co.propTypes = {
  /**
   * Your component tree.
   */
  children: i.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: i.oneOfType([i.object, i.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (co.propTypes = Bo(co.propTypes));
const Xl = /* @__PURE__ */ h.createContext();
function Jl({
  value: e,
  ...t
}) {
  return /* @__PURE__ */ w.jsx(Xl.Provider, {
    value: e ?? !0,
    ...t
  });
}
process.env.NODE_ENV !== "production" && (Jl.propTypes = {
  children: i.node,
  value: i.bool
});
const da = () => h.useContext(Xl) ?? !1, Zl = /* @__PURE__ */ h.createContext(void 0);
function Ql({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ w.jsx(Zl.Provider, {
    value: e,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Ql.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: i.node,
  /**
   * @ignore
   */
  value: i.object
});
function yf(e) {
  const {
    theme: t,
    name: r,
    props: n
  } = e;
  if (!t || !t.components || !t.components[r])
    return n;
  const o = t.components[r];
  return o.defaultProps ? hn(o.defaultProps, n) : !o.styleOverrides && !o.variants ? hn(o, n) : n;
}
function vf({
  props: e,
  name: t
}) {
  const r = h.useContext(Zl);
  return yf({
    props: e,
    name: t,
    theme: {
      components: r
    }
  });
}
const Es = {};
function Cs(e, t, r, n = !1) {
  return h.useMemo(() => {
    const o = e && t[e] || t;
    if (typeof r == "function") {
      const a = r(o), s = e ? {
        ...t,
        [e]: a
      } : a;
      return n ? () => s : s;
    }
    return e ? {
      ...t,
      [e]: r
    } : {
      ...t,
      ...r
    };
  }, [e, t, r, n]);
}
function gn(e) {
  const {
    children: t,
    theme: r,
    themeId: n
  } = e, o = Fl(Es), a = ua() || Es;
  process.env.NODE_ENV !== "production" && (o === null && typeof r == "function" || n && o && !o[n] && typeof r == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const s = Cs(n, o, r), l = Cs(n, a, r, !0), c = (n ? s[n] : s).direction === "rtl";
  return /* @__PURE__ */ w.jsx(co, {
    theme: l,
    children: /* @__PURE__ */ w.jsx(Sn.Provider, {
      value: s,
      children: /* @__PURE__ */ w.jsx(Jl, {
        value: c,
        children: /* @__PURE__ */ w.jsx(Ql, {
          value: n ? s[n].components : s.components,
          children: t
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (gn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: i.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: i.oneOfType([i.func, i.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: i.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (gn.propTypes = Bo(gn.propTypes));
const Ts = {
  theme: void 0
};
function bf(e) {
  let t, r;
  return function(o) {
    let a = t;
    return (a === void 0 || o.theme !== r) && (Ts.theme = o.theme, a = Hl(e(Ts)), t = a, r = o.theme), a;
  };
}
const pa = "mode", fa = "color-scheme", xf = "data-color-scheme";
function Ef(e) {
  const {
    defaultMode: t = "system",
    defaultLightColorScheme: r = "light",
    defaultDarkColorScheme: n = "dark",
    modeStorageKey: o = pa,
    colorSchemeStorageKey: a = fa,
    attribute: s = xf,
    colorSchemeNode: l = "document.documentElement",
    nonce: c
  } = e || {};
  let u = "", p = s;
  if (s === "class" && (p = ".%s"), s === "data" && (p = "[data-%s]"), p.startsWith(".")) {
    const g = p.substring(1);
    u += `${l}.classList.remove('${g}'.replace('%s', light), '${g}'.replace('%s', dark));
      ${l}.classList.add('${g}'.replace('%s', colorScheme));`;
  }
  const f = p.match(/\[([^\]]+)\]/);
  if (f) {
    const [g, v] = f[1].split("=");
    v || (u += `${l}.removeAttribute('${g}'.replace('%s', light));
      ${l}.removeAttribute('${g}'.replace('%s', dark));`), u += `
      ${l}.setAttribute('${g}'.replace('%s', colorScheme), ${v ? `${v}.replace('%s', colorScheme)` : '""'});`;
  } else
    u += `${l}.setAttribute('${p}', colorScheme);`;
  return /* @__PURE__ */ w.jsx("script", {
    suppressHydrationWarning: !0,
    nonce: typeof window > "u" ? c : "",
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${o}') || '${t}';
  const dark = localStorage.getItem('${a}-dark') || '${n}';
  const light = localStorage.getItem('${a}-light') || '${r}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${u}
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function Cf() {
}
const Tf = ({
  key: e,
  storageWindow: t
}) => (!t && typeof window < "u" && (t = window), {
  get(r) {
    if (typeof window > "u")
      return;
    if (!t)
      return r;
    let n;
    try {
      n = t.localStorage.getItem(e);
    } catch {
    }
    return n || r;
  },
  set: (r) => {
    if (t)
      try {
        t.localStorage.setItem(e, r);
      } catch {
      }
  },
  subscribe: (r) => {
    if (!t)
      return Cf;
    const n = (o) => {
      const a = o.newValue;
      o.key === e && r(a);
    };
    return t.addEventListener("storage", n), () => {
      t.removeEventListener("storage", n);
    };
  }
});
function ci() {
}
function Ss(e) {
  if (typeof window < "u" && typeof window.matchMedia == "function" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function ec(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function Sf(e) {
  return ec(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function wf(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: r,
    defaultDarkColorScheme: n,
    supportedColorSchemes: o = [],
    modeStorageKey: a = pa,
    colorSchemeStorageKey: s = fa,
    storageWindow: l = typeof window > "u" ? void 0 : window,
    storageManager: c = Tf,
    noSsr: u = !1
  } = e, p = o.join(","), f = o.length > 1, g = h.useMemo(() => c == null ? void 0 : c({
    key: a,
    storageWindow: l
  }), [c, a, l]), v = h.useMemo(() => c == null ? void 0 : c({
    key: `${s}-light`,
    storageWindow: l
  }), [c, s, l]), y = h.useMemo(() => c == null ? void 0 : c({
    key: `${s}-dark`,
    storageWindow: l
  }), [c, s, l]), [d, x] = h.useState(() => {
    const k = (g == null ? void 0 : g.get(t)) || t, I = (v == null ? void 0 : v.get(r)) || r, m = (y == null ? void 0 : y.get(n)) || n;
    return {
      mode: k,
      systemMode: Ss(k),
      lightColorScheme: I,
      darkColorScheme: m
    };
  }), [b, O] = h.useState(u || !f);
  h.useEffect(() => {
    O(!0);
  }, []);
  const T = Sf(d), E = h.useCallback((k) => {
    x((I) => {
      if (k === I.mode)
        return I;
      const m = k ?? t;
      return g == null || g.set(m), {
        ...I,
        mode: m,
        systemMode: Ss(m)
      };
    });
  }, [g, t]), C = h.useCallback((k) => {
    k ? typeof k == "string" ? k && !p.includes(k) ? console.error(`\`${k}\` does not exist in \`theme.colorSchemes\`.`) : x((I) => {
      const m = {
        ...I
      };
      return ec(I, (R) => {
        R === "light" && (v == null || v.set(k), m.lightColorScheme = k), R === "dark" && (y == null || y.set(k), m.darkColorScheme = k);
      }), m;
    }) : x((I) => {
      const m = {
        ...I
      }, R = k.light === null ? r : k.light, _ = k.dark === null ? n : k.dark;
      return R && (p.includes(R) ? (m.lightColorScheme = R, v == null || v.set(R)) : console.error(`\`${R}\` does not exist in \`theme.colorSchemes\`.`)), _ && (p.includes(_) ? (m.darkColorScheme = _, y == null || y.set(_)) : console.error(`\`${_}\` does not exist in \`theme.colorSchemes\`.`)), m;
    }) : x((I) => (v == null || v.set(r), y == null || y.set(n), {
      ...I,
      lightColorScheme: r,
      darkColorScheme: n
    }));
  }, [p, v, y, r, n]), $ = h.useCallback((k) => {
    d.mode === "system" && x((I) => {
      const m = k != null && k.matches ? "dark" : "light";
      return I.systemMode === m ? I : {
        ...I,
        systemMode: m
      };
    });
  }, [d.mode]), P = h.useRef($);
  return P.current = $, h.useEffect(() => {
    if (typeof window.matchMedia != "function" || !f)
      return;
    const k = (...m) => P.current(...m), I = window.matchMedia("(prefers-color-scheme: dark)");
    return I.addListener(k), k(I), () => {
      I.removeListener(k);
    };
  }, [f]), h.useEffect(() => {
    if (f) {
      const k = (g == null ? void 0 : g.subscribe((R) => {
        (!R || ["light", "dark", "system"].includes(R)) && E(R || t);
      })) || ci, I = (v == null ? void 0 : v.subscribe((R) => {
        (!R || p.match(R)) && C({
          light: R
        });
      })) || ci, m = (y == null ? void 0 : y.subscribe((R) => {
        (!R || p.match(R)) && C({
          dark: R
        });
      })) || ci;
      return () => {
        k(), I(), m();
      };
    }
  }, [C, E, p, t, l, f, g, v, y]), {
    ...d,
    mode: b ? d.mode : void 0,
    systemMode: b ? d.systemMode : void 0,
    colorScheme: b ? T : void 0,
    setMode: E,
    setColorScheme: C
  };
}
const Of = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function Rf(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: r = {},
    modeStorageKey: n = pa,
    colorSchemeStorageKey: o = fa,
    disableTransitionOnChange: a = !1,
    defaultColorScheme: s,
    resolveTheme: l
  } = e, c = {
    allColorSchemes: [],
    colorScheme: void 0,
    darkColorScheme: void 0,
    lightColorScheme: void 0,
    mode: void 0,
    setColorScheme: () => {
    },
    setMode: () => {
    },
    systemMode: void 0
  }, u = /* @__PURE__ */ h.createContext(void 0);
  process.env.NODE_ENV !== "production" && (u.displayName = "ColorSchemeContext");
  const p = () => h.useContext(u) || c, f = {}, g = {};
  function v(b) {
    var $t, ht, qt, St;
    const {
      children: O,
      theme: T,
      modeStorageKey: E = n,
      colorSchemeStorageKey: C = o,
      disableTransitionOnChange: $ = a,
      storageManager: P,
      storageWindow: k = typeof window > "u" ? void 0 : window,
      documentNode: I = typeof document > "u" ? void 0 : document,
      colorSchemeNode: m = typeof document > "u" ? void 0 : document.documentElement,
      disableNestedContext: R = !1,
      disableStyleSheetGeneration: _ = !1,
      defaultMode: j = "system",
      forceThemeRerender: V = !1,
      noSsr: D
    } = b, M = h.useRef(!1), U = ua(), te = h.useContext(u), Y = !!te && !R, N = h.useMemo(() => T || (typeof r == "function" ? r() : r), [T]), B = N[t], H = B || N, {
      colorSchemes: q = f,
      components: G = g,
      cssVarPrefix: Q
    } = H, z = Object.keys(q).filter((Le) => !!q[Le]).join(","), K = h.useMemo(() => z.split(","), [z]), X = typeof s == "string" ? s : s.light, ie = typeof s == "string" ? s : s.dark, W = q[X] && q[ie] ? j : ((ht = ($t = q[H.defaultColorScheme]) == null ? void 0 : $t.palette) == null ? void 0 : ht.mode) || ((qt = H.palette) == null ? void 0 : qt.mode), {
      mode: ne,
      setMode: L,
      systemMode: de,
      lightColorScheme: Se,
      darkColorScheme: Ae,
      colorScheme: Je,
      setColorScheme: Ue
    } = wf({
      supportedColorSchemes: K,
      defaultLightColorScheme: X,
      defaultDarkColorScheme: ie,
      modeStorageKey: E,
      colorSchemeStorageKey: C,
      defaultMode: W,
      storageManager: P,
      storageWindow: k,
      noSsr: D
    });
    let Fe = ne, ve = Je;
    Y && (Fe = te.mode, ve = te.colorScheme), process.env.NODE_ENV !== "production" && V && !H.vars && console.warn(["MUI: The `forceThemeRerender` prop should only be used with CSS theme variables.", "Note that it will slow down the app when changing between modes, so only do this when you cannot find a better solution."].join(`
`));
    let De = ve || H.defaultColorScheme;
    H.vars && !V && (De = H.defaultColorScheme);
    const be = h.useMemo(() => {
      var rt;
      const Le = ((rt = H.generateThemeVars) == null ? void 0 : rt.call(H)) || H.vars, ce = {
        ...H,
        components: G,
        colorSchemes: q,
        cssVarPrefix: Q,
        vars: Le
      };
      if (typeof ce.generateSpacing == "function" && (ce.spacing = ce.generateSpacing()), De) {
        const qe = q[De];
        qe && typeof qe == "object" && Object.keys(qe).forEach((Me) => {
          qe[Me] && typeof qe[Me] == "object" ? ce[Me] = {
            ...ce[Me],
            ...qe[Me]
          } : ce[Me] = qe[Me];
        });
      }
      return l ? l(ce) : ce;
    }, [H, De, G, q, Q]), re = H.colorSchemeSelector;
    ir(() => {
      if (ve && m && re && re !== "media") {
        const Le = re;
        let ce = re;
        if (Le === "class" && (ce = ".%s"), Le === "data" && (ce = "[data-%s]"), Le != null && Le.startsWith("data-") && !Le.includes("%s") && (ce = `[${Le}="%s"]`), ce.startsWith("."))
          m.classList.remove(...K.map((rt) => ce.substring(1).replace("%s", rt))), m.classList.add(ce.substring(1).replace("%s", ve));
        else {
          const rt = ce.replace("%s", ve).match(/\[([^\]]+)\]/);
          if (rt) {
            const [qe, Me] = rt[1].split("=");
            Me || K.forEach((Vr) => {
              m.removeAttribute(qe.replace(ve, Vr));
            }), m.setAttribute(qe, Me ? Me.replace(/"|'/g, "") : "");
          } else
            m.setAttribute(ce, ve);
        }
      }
    }, [ve, re, m, K]), h.useEffect(() => {
      let Le;
      if ($ && M.current && I) {
        const ce = I.createElement("style");
        ce.appendChild(I.createTextNode(Of)), I.head.appendChild(ce), window.getComputedStyle(I.body), Le = setTimeout(() => {
          I.head.removeChild(ce);
        }, 1);
      }
      return () => {
        clearTimeout(Le);
      };
    }, [ve, $, I]), h.useEffect(() => (M.current = !0, () => {
      M.current = !1;
    }), []);
    const Yt = h.useMemo(() => ({
      allColorSchemes: K,
      colorScheme: ve,
      darkColorScheme: Ae,
      lightColorScheme: Se,
      mode: Fe,
      setColorScheme: Ue,
      setMode: process.env.NODE_ENV === "production" ? L : (Le) => {
        be.colorSchemeSelector === "media" && console.error(["MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).", "To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.", "To learn more, visit https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually"].join(`
`)), L(Le);
      },
      systemMode: de
    }), [K, ve, Ae, Se, Fe, Ue, L, de, be.colorSchemeSelector]);
    let Rt = !0;
    (_ || H.cssVariables === !1 || Y && (U == null ? void 0 : U.cssVarPrefix) === Q) && (Rt = !1);
    const Pt = /* @__PURE__ */ w.jsxs(h.Fragment, {
      children: [/* @__PURE__ */ w.jsx(gn, {
        themeId: B ? t : void 0,
        theme: be,
        children: O
      }), Rt && /* @__PURE__ */ w.jsx(na, {
        styles: ((St = be.generateStyleSheets) == null ? void 0 : St.call(be)) || []
      })]
    });
    return Y ? Pt : /* @__PURE__ */ w.jsx(u.Provider, {
      value: Yt,
      children: Pt
    });
  }
  process.env.NODE_ENV !== "production" && (v.propTypes = {
    /**
     * The component tree.
     */
    children: i.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: i.any,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: i.string,
    /**
     * The default mode when the storage is empty,
     * require the theme to have `colorSchemes` with light and dark.
     */
    defaultMode: i.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: i.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: i.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: i.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: i.any,
    /**
     * If `true`, theme values are recalculated when the mode changes.
     */
    forceThemeRerender: i.bool,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: i.string,
    /**
     * If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
     * You should use this option in conjuction with `InitColorSchemeScript` component.
     */
    noSsr: i.bool,
    /**
     * The storage manager to be used for storing the mode and color scheme
     * @default using `window.localStorage`
     */
    storageManager: i.func,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: i.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: i.object
  });
  const y = typeof s == "string" ? s : s.light, d = typeof s == "string" ? s : s.dark;
  return {
    CssVarsProvider: v,
    useColorScheme: p,
    getInitColorSchemeScript: (b) => Ef({
      colorSchemeStorageKey: o,
      defaultLightColorScheme: y,
      defaultDarkColorScheme: d,
      modeStorageKey: n,
      ...b
    })
  };
}
function Pf(e = "") {
  function t(...n) {
    if (!n.length)
      return "";
    const o = n[0];
    return typeof o == "string" && !o.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${o}${t(...n.slice(1))})` : `, ${o}`;
  }
  return (n, ...o) => `var(--${e ? `${e}-` : ""}${n}${t(...o)})`;
}
const ws = (e, t, r, n = []) => {
  let o = e;
  t.forEach((a, s) => {
    s === t.length - 1 ? Array.isArray(o) ? o[Number(a)] = r : o && typeof o == "object" && (o[a] = r) : o && typeof o == "object" && (o[a] || (o[a] = n.includes(a) ? [] : {}), o = o[a]);
  });
}, $f = (e, t, r) => {
  function n(o, a = [], s = []) {
    Object.entries(o).forEach(([l, c]) => {
      (!r || r && !r([...a, l])) && c != null && (typeof c == "object" && Object.keys(c).length > 0 ? n(c, [...a, l], Array.isArray(c) ? [...s, l] : s) : t([...a, l], c, s));
    });
  }
  n(e);
}, kf = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((n) => e.includes(n)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function ui(e, t) {
  const {
    prefix: r,
    shouldSkipGeneratingVar: n
  } = t || {}, o = {}, a = {}, s = {};
  return $f(
    e,
    (l, c, u) => {
      if ((typeof c == "string" || typeof c == "number") && (!n || !n(l, c))) {
        const p = `--${r ? `${r}-` : ""}${l.join("-")}`, f = kf(l, c);
        Object.assign(o, {
          [p]: f
        }), ws(a, l, `var(${p})`, u), ws(s, l, `var(${p}, ${f})`, u);
      }
    },
    (l) => l[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: o,
    vars: a,
    varsWithDefaults: s
  };
}
function If(e, t = {}) {
  const {
    getSelector: r = x,
    disableCssColorScheme: n,
    colorSchemeSelector: o
  } = t, {
    colorSchemes: a = {},
    components: s,
    defaultColorScheme: l = "light",
    ...c
  } = e, {
    vars: u,
    css: p,
    varsWithDefaults: f
  } = ui(c, t);
  let g = f;
  const v = {}, {
    [l]: y,
    ...d
  } = a;
  if (Object.entries(d || {}).forEach(([T, E]) => {
    const {
      vars: C,
      css: $,
      varsWithDefaults: P
    } = ui(E, t);
    g = it(g, P), v[T] = {
      css: $,
      vars: C
    };
  }), y) {
    const {
      css: T,
      vars: E,
      varsWithDefaults: C
    } = ui(y, t);
    g = it(g, C), v[l] = {
      css: T,
      vars: E
    };
  }
  function x(T, E) {
    var $, P;
    let C = o;
    if (o === "class" && (C = ".%s"), o === "data" && (C = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (C = `[${o}="%s"]`), T) {
      if (C === "media")
        return e.defaultColorScheme === T ? ":root" : {
          [`@media (prefers-color-scheme: ${((P = ($ = a[T]) == null ? void 0 : $.palette) == null ? void 0 : P.mode) || T})`]: {
            ":root": E
          }
        };
      if (C)
        return e.defaultColorScheme === T ? `:root, ${C.replace("%s", String(T))}` : C.replace("%s", String(T));
    }
    return ":root";
  }
  return {
    vars: g,
    generateThemeVars: () => {
      let T = {
        ...u
      };
      return Object.entries(v).forEach(([, {
        vars: E
      }]) => {
        T = it(T, E);
      }), T;
    },
    generateStyleSheets: () => {
      var k, I;
      const T = [], E = e.defaultColorScheme || "light";
      function C(m, R) {
        Object.keys(R).length && T.push(typeof m == "string" ? {
          [m]: {
            ...R
          }
        } : m);
      }
      C(r(void 0, {
        ...p
      }), p);
      const {
        [E]: $,
        ...P
      } = v;
      if ($) {
        const {
          css: m
        } = $, R = (I = (k = a[E]) == null ? void 0 : k.palette) == null ? void 0 : I.mode, _ = !n && R ? {
          colorScheme: R,
          ...m
        } : {
          ...m
        };
        C(r(E, {
          ..._
        }), _);
      }
      return Object.entries(P).forEach(([m, {
        css: R
      }]) => {
        var V, D;
        const _ = (D = (V = a[m]) == null ? void 0 : V.palette) == null ? void 0 : D.mode, j = !n && _ ? {
          colorScheme: _,
          ...R
        } : {
          ...R
        };
        C(r(m, {
          ...j
        }), j);
      }), T;
    }
  };
}
function Nf(e) {
  return function(r) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && r !== "light" && r !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${r}'.`), `@media (prefers-color-scheme: ${r})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${r}"] &` : e === "class" ? `.${r} &` : e === "data" ? `[data-${r}] &` : `${e.replace("%s", r)} &` : "&";
  };
}
function Te(e, t, r = void 0) {
  const n = {};
  for (const o in e) {
    const a = e[o];
    let s = "", l = !0;
    for (let c = 0; c < a.length; c += 1) {
      const u = a[c];
      u && (s += (l === !0 ? "" : " ") + t(u), l = !1, r && r[u] && (s += " " + r[u]));
    }
    n[o] = s;
  }
  return n;
}
function tc(e, t) {
  var r, n, o;
  return /* @__PURE__ */ h.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? ((o = (n = (r = e.type) == null ? void 0 : r._payload) == null ? void 0 : n.value) == null ? void 0 : o.muiName)
  ) !== -1;
}
const Af = _o(), Mf = sf("div", {
  name: "MuiStack",
  slot: "Root"
});
function jf(e) {
  return cf({
    props: e,
    name: "MuiStack",
    defaultTheme: Af
  });
}
function _f(e, t) {
  const r = h.Children.toArray(e).filter(Boolean);
  return r.reduce((n, o, a) => (n.push(o), a < r.length - 1 && n.push(/* @__PURE__ */ h.cloneElement(t, {
    key: `separator-${a}`
  })), n), []);
}
const Df = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], Lf = ({
  ownerState: e,
  theme: t
}) => {
  let r = {
    display: "flex",
    flexDirection: "column",
    ...Ot({
      theme: t
    }, si({
      values: e.direction,
      breakpoints: t.breakpoints.values
    }), (n) => ({
      flexDirection: n
    }))
  };
  if (e.spacing) {
    const n = ko(t), o = Object.keys(t.breakpoints.values).reduce((c, u) => ((typeof e.spacing == "object" && e.spacing[u] != null || typeof e.direction == "object" && e.direction[u] != null) && (c[u] = !0), c), {}), a = si({
      values: e.direction,
      base: o
    }), s = si({
      values: e.spacing,
      base: o
    });
    typeof a == "object" && Object.keys(a).forEach((c, u, p) => {
      if (!a[c]) {
        const g = u > 0 ? a[p[u - 1]] : "column";
        a[c] = g;
      }
    }), r = it(r, Ot({
      theme: t
    }, s, (c, u) => e.useFlexGap ? {
      gap: vr(n, c)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${Df(u ? a[u] : e.direction)}`]: vr(n, c)
      }
    }));
  }
  return r = np(t.breakpoints, r), r;
};
function Bf(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = Mf,
    useThemeProps: r = jf,
    componentName: n = "MuiStack"
  } = e, o = () => Te({
    root: ["root"]
  }, (c) => he(n, c), {}), a = t(Lf), s = /* @__PURE__ */ h.forwardRef(function(c, u) {
    const p = r(c), f = ia(p), {
      component: g = "div",
      direction: v = "column",
      spacing: y = 0,
      divider: d,
      children: x,
      className: b,
      useFlexGap: O = !1,
      ...T
    } = f, E = {
      direction: v,
      spacing: y,
      useFlexGap: O
    }, C = o();
    return /* @__PURE__ */ w.jsx(a, {
      as: g,
      ownerState: E,
      ref: u,
      className: oe(C.root, b),
      ...T,
      children: d ? _f(x, d) : x
    });
  });
  return process.env.NODE_ENV !== "production" && (s.propTypes = {
    children: i.node,
    direction: i.oneOfType([i.oneOf(["column-reverse", "column", "row-reverse", "row"]), i.arrayOf(i.oneOf(["column-reverse", "column", "row-reverse", "row"])), i.object]),
    divider: i.node,
    spacing: i.oneOfType([i.arrayOf(i.oneOfType([i.number, i.string])), i.number, i.object, i.string]),
    sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
  }), s;
}
const Dt = "$$material", yn = {
  black: "#000",
  white: "#fff"
}, Ff = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Cr = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, Tr = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, Gr = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, Sr = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, wr = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, Or = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function rc() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: yn.white,
      default: yn.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const Vf = rc();
function nc() {
  return {
    text: {
      primary: yn.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: yn.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const Os = nc();
function Rs(e, t, r, n) {
  const o = n.light || n, a = n.dark || n * 1.5;
  e[t] || (e.hasOwnProperty(r) ? e[t] = e[r] : t === "light" ? e.light = la(e.main, o) : t === "dark" && (e.dark = sa(e.main, a)));
}
function zf(e = "light") {
  return e === "dark" ? {
    main: Sr[200],
    light: Sr[50],
    dark: Sr[400]
  } : {
    main: Sr[700],
    light: Sr[400],
    dark: Sr[800]
  };
}
function Wf(e = "light") {
  return e === "dark" ? {
    main: Cr[200],
    light: Cr[50],
    dark: Cr[400]
  } : {
    main: Cr[500],
    light: Cr[300],
    dark: Cr[700]
  };
}
function Uf(e = "light") {
  return e === "dark" ? {
    main: Tr[500],
    light: Tr[300],
    dark: Tr[700]
  } : {
    main: Tr[700],
    light: Tr[400],
    dark: Tr[800]
  };
}
function Hf(e = "light") {
  return e === "dark" ? {
    main: wr[400],
    light: wr[300],
    dark: wr[700]
  } : {
    main: wr[700],
    light: wr[500],
    dark: wr[900]
  };
}
function Yf(e = "light") {
  return e === "dark" ? {
    main: Or[400],
    light: Or[300],
    dark: Or[700]
  } : {
    main: Or[800],
    light: Or[500],
    dark: Or[900]
  };
}
function qf(e = "light") {
  return e === "dark" ? {
    main: Gr[400],
    light: Gr[300],
    dark: Gr[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Gr[500],
    dark: Gr[900]
  };
}
function ma(e) {
  const {
    mode: t = "light",
    contrastThreshold: r = 3,
    tonalOffset: n = 0.2,
    ...o
  } = e, a = e.primary || zf(t), s = e.secondary || Wf(t), l = e.error || Uf(t), c = e.info || Hf(t), u = e.success || Yf(t), p = e.warning || qf(t);
  function f(d) {
    const x = xs(d, Os.text.primary) >= r ? Os.text.primary : Vf.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const b = xs(d, x);
      b < 3 && console.error([`MUI: The contrast ratio of ${b}:1 for ${x} on ${d}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return x;
  }
  const g = ({
    color: d,
    name: x,
    mainShade: b = 500,
    lightShade: O = 300,
    darkShade: T = 700
  }) => {
    if (d = {
      ...d
    }, !d.main && d[b] && (d.main = d[b]), !d.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${x ? ` (${x})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${b}\` property.` : nr(11, x ? ` (${x})` : "", b));
    if (typeof d.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${x ? ` (${x})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(d.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : nr(12, x ? ` (${x})` : "", JSON.stringify(d.main)));
    return Rs(d, "light", O, n), Rs(d, "dark", T, n), d.contrastText || (d.contrastText = f(d.main)), d;
  };
  let v;
  return t === "light" ? v = rc() : t === "dark" && (v = nc()), process.env.NODE_ENV !== "production" && (v || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), it({
    // A collection of common colors.
    common: {
      ...yn
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: g({
      color: a,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: g({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: g({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: g({
      color: p,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: g({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: g({
      color: u,
      name: "success"
    }),
    // The grey colors.
    grey: Ff,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: r,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: g,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n,
    // The light and dark mode object.
    ...v
  }, o);
}
function Kf(e) {
  const t = {};
  return Object.entries(e).forEach((n) => {
    const [o, a] = n;
    typeof a == "object" && (t[o] = `${a.fontStyle ? `${a.fontStyle} ` : ""}${a.fontVariant ? `${a.fontVariant} ` : ""}${a.fontWeight ? `${a.fontWeight} ` : ""}${a.fontStretch ? `${a.fontStretch} ` : ""}${a.fontSize || ""}${a.lineHeight ? `/${a.lineHeight} ` : ""}${a.fontFamily || ""}`);
  }), t;
}
function Gf(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function Xf(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Ps = {
  textTransform: "uppercase"
}, $s = '"Roboto", "Helvetica", "Arial", sans-serif';
function oc(e, t) {
  const {
    fontFamily: r = $s,
    // The default font size of the Material Specification.
    fontSize: n = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: a = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: l = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: c = 16,
    // Apply the CSS properties to all the variants.
    allVariants: u,
    pxToRem: p,
    ...f
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof n != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof c != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const g = n / 14, v = p || ((x) => `${x / c * g}rem`), y = (x, b, O, T, E) => ({
    fontFamily: r,
    fontWeight: x,
    fontSize: v(b),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: O,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...r === $s ? {
      letterSpacing: `${Xf(T / b)}em`
    } : {},
    ...E,
    ...u
  }), d = {
    h1: y(o, 96, 1.167, -1.5),
    h2: y(o, 60, 1.2, -0.5),
    h3: y(a, 48, 1.167, 0),
    h4: y(a, 34, 1.235, 0.25),
    h5: y(a, 24, 1.334, 0),
    h6: y(s, 20, 1.6, 0.15),
    subtitle1: y(a, 16, 1.75, 0.15),
    subtitle2: y(s, 14, 1.57, 0.1),
    body1: y(a, 16, 1.5, 0.15),
    body2: y(a, 14, 1.43, 0.15),
    button: y(s, 14, 1.75, 0.4, Ps),
    caption: y(a, 12, 1.66, 0.4),
    overline: y(a, 12, 2.66, 1, Ps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return it({
    htmlFontSize: c,
    pxToRem: v,
    fontFamily: r,
    fontSize: n,
    fontWeightLight: o,
    fontWeightRegular: a,
    fontWeightMedium: s,
    fontWeightBold: l,
    ...d
  }, f, {
    clone: !1
    // No need to clone deep
  });
}
const Jf = 0.2, Zf = 0.14, Qf = 0.12;
function je(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${Jf})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${Zf})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Qf})`].join(",");
}
const em = ["none", je(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), je(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), je(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), je(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), je(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), je(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), je(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), je(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), je(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), je(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), je(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), je(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), je(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), je(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), je(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), je(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), je(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), je(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), je(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), je(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), je(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), je(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), je(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), je(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], tm = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, rm = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function ks(e) {
  return `${Math.round(e)}ms`;
}
function nm(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function om(e) {
  const t = {
    ...tm,
    ...e.easing
  }, r = {
    ...rm,
    ...e.duration
  };
  return {
    getAutoHeightDuration: nm,
    create: (o = ["all"], a = {}) => {
      const {
        duration: s = r.standard,
        easing: l = t.easeInOut,
        delay: c = 0,
        ...u
      } = a;
      if (process.env.NODE_ENV !== "production") {
        const p = (g) => typeof g == "string", f = (g) => !Number.isNaN(parseFloat(g));
        !p(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !f(s) && !p(s) && console.error(`MUI: Argument "duration" must be a number or a string but found ${s}.`), p(l) || console.error('MUI: Argument "easing" must be a string.'), !f(c) && !p(c) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof a != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(u).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(u).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((p) => `${p} ${typeof s == "string" ? s : ks(s)} ${l} ${typeof c == "string" ? c : ks(c)}`).join(",");
    },
    ...e,
    easing: t,
    duration: r
  };
}
const im = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function am(e) {
  return At(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function ic(e = {}) {
  const t = {
    ...e
  };
  function r(n) {
    const o = Object.entries(n);
    for (let a = 0; a < o.length; a++) {
      const [s, l] = o[a];
      !am(l) || s.startsWith("unstable_") ? delete n[s] : At(l) && (n[s] = {
        ...l
      }, r(n[s]));
    }
  }
  return r(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function Pi(e = {}, ...t) {
  const {
    breakpoints: r,
    mixins: n = {},
    spacing: o,
    palette: a = {},
    transitions: s = {},
    typography: l = {},
    shape: c,
    ...u
  } = e;
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : nr(20));
  const p = ma(a), f = _o(e);
  let g = it(f, {
    mixins: Gf(f.breakpoints, n),
    palette: p,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: em.slice(),
    typography: oc(p, l),
    transitions: om(s),
    zIndex: {
      ...im
    }
  });
  if (g = it(g, u), g = t.reduce((v, y) => it(v, y), g), process.env.NODE_ENV !== "production") {
    const v = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], y = (d, x) => {
      let b;
      for (b in d) {
        const O = d[b];
        if (v.includes(b) && Object.keys(O).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const T = he("", b);
            console.error([`MUI: The \`${x}\` component increases the CSS specificity of the \`${b}\` internal state.`, "You can not override it like this: ", JSON.stringify(d, null, 2), "", `Instead, you need to use the '&.${T}' syntax:`, JSON.stringify({
              root: {
                [`&.${T}`]: O
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          d[b] = {};
        }
      }
    };
    Object.keys(g.components).forEach((d) => {
      const x = g.components[d].styleOverrides;
      x && d.startsWith("Mui") && y(x, d);
    });
  }
  return g.unstable_sxConfig = {
    ...Rn,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, g.unstable_sx = function(y) {
    return or({
      sx: y,
      theme: this
    });
  }, g.toRuntimeSource = ic, g;
}
function $i(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const sm = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const r = $i(t);
  return `linear-gradient(rgba(255 255 255 / ${r}), rgba(255 255 255 / ${r}))`;
});
function ac(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function sc(e) {
  return e === "dark" ? sm : [];
}
function lm(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: r,
    overlays: n,
    ...o
  } = e, a = ma(t);
  return {
    palette: a,
    opacity: {
      ...ac(a.mode),
      ...r
    },
    overlays: n || sc(a.mode),
    ...o
  };
}
function cm(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const um = (e) => [...[...Array(25)].map((t, r) => `--${e ? `${e}-` : ""}overlays-${r}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], dm = (e) => (t, r) => {
  const n = e.rootSelector || ":root", o = e.colorSchemeSelector;
  let a = o;
  if (o === "class" && (a = ".%s"), o === "data" && (a = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (a = `[${o}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const s = {};
      return um(e.cssVarPrefix).forEach((l) => {
        s[l] = r[l], delete r[l];
      }), a === "media" ? {
        [n]: r,
        "@media (prefers-color-scheme: dark)": {
          [n]: s
        }
      } : a ? {
        [a.replace("%s", t)]: s,
        [`${n}, ${a.replace("%s", t)}`]: r
      } : {
        [n]: {
          ...r,
          ...s
        }
      };
    }
    if (a && a !== "media")
      return `${n}, ${a.replace("%s", String(t))}`;
  } else if (t) {
    if (a === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [n]: r
        }
      };
    if (a)
      return a.replace("%s", String(t));
  }
  return n;
};
function pm(e, t) {
  t.forEach((r) => {
    e[r] || (e[r] = {});
  });
}
function A(e, t, r) {
  !e[t] && r && (e[t] = r);
}
function rn(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : Gl(e);
}
function Kt(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = tn(rn(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function fm(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const kt = (e) => {
  try {
    return e();
  } catch {
  }
}, mm = (e = "mui") => Pf(e);
function di(e, t, r, n) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const o = n === "dark" ? "dark" : "light";
  if (!r) {
    e[n] = lm({
      ...t,
      palette: {
        mode: o,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: a,
    ...s
  } = Pi({
    ...r,
    palette: {
      mode: o,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[n] = {
    ...t,
    palette: a,
    opacity: {
      ...ac(o),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || sc(o)
  }, s;
}
function hm(e = {}, ...t) {
  const {
    colorSchemes: r = {
      light: !0
    },
    defaultColorScheme: n,
    disableCssColorScheme: o = !1,
    cssVarPrefix: a = "mui",
    shouldSkipGeneratingVar: s = cm,
    colorSchemeSelector: l = r.light && r.dark ? "media" : void 0,
    rootSelector: c = ":root",
    ...u
  } = e, p = Object.keys(r)[0], f = n || (r.light && p !== "light" ? "light" : p), g = mm(a), {
    [f]: v,
    light: y,
    dark: d,
    ...x
  } = r, b = {
    ...x
  };
  let O = v;
  if ((f === "dark" && !("dark" in r) || f === "light" && !("light" in r)) && (O = !0), !O)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${f}\` option is either missing or invalid.` : nr(21, f));
  const T = di(b, O, u, f);
  y && !b.light && di(b, y, void 0, "light"), d && !b.dark && di(b, d, void 0, "dark");
  let E = {
    defaultColorScheme: f,
    ...T,
    cssVarPrefix: a,
    colorSchemeSelector: l,
    rootSelector: c,
    getCssVar: g,
    colorSchemes: b,
    font: {
      ...Kf(T.typography),
      ...T.font
    },
    spacing: fm(u.spacing)
  };
  Object.keys(E.colorSchemes).forEach((I) => {
    const m = E.colorSchemes[I].palette, R = (_) => {
      const j = _.split("-"), V = j[1], D = j[2];
      return g(_, m[V][D]);
    };
    if (m.mode === "light" && (A(m.common, "background", "#fff"), A(m.common, "onBackground", "#000")), m.mode === "dark" && (A(m.common, "background", "#000"), A(m.common, "onBackground", "#fff")), pm(m, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), m.mode === "light") {
      A(m.Alert, "errorColor", ke(m.error.light, 0.6)), A(m.Alert, "infoColor", ke(m.info.light, 0.6)), A(m.Alert, "successColor", ke(m.success.light, 0.6)), A(m.Alert, "warningColor", ke(m.warning.light, 0.6)), A(m.Alert, "errorFilledBg", R("palette-error-main")), A(m.Alert, "infoFilledBg", R("palette-info-main")), A(m.Alert, "successFilledBg", R("palette-success-main")), A(m.Alert, "warningFilledBg", R("palette-warning-main")), A(m.Alert, "errorFilledColor", kt(() => m.getContrastText(m.error.main))), A(m.Alert, "infoFilledColor", kt(() => m.getContrastText(m.info.main))), A(m.Alert, "successFilledColor", kt(() => m.getContrastText(m.success.main))), A(m.Alert, "warningFilledColor", kt(() => m.getContrastText(m.warning.main))), A(m.Alert, "errorStandardBg", Ie(m.error.light, 0.9)), A(m.Alert, "infoStandardBg", Ie(m.info.light, 0.9)), A(m.Alert, "successStandardBg", Ie(m.success.light, 0.9)), A(m.Alert, "warningStandardBg", Ie(m.warning.light, 0.9)), A(m.Alert, "errorIconColor", R("palette-error-main")), A(m.Alert, "infoIconColor", R("palette-info-main")), A(m.Alert, "successIconColor", R("palette-success-main")), A(m.Alert, "warningIconColor", R("palette-warning-main")), A(m.AppBar, "defaultBg", R("palette-grey-100")), A(m.Avatar, "defaultBg", R("palette-grey-400")), A(m.Button, "inheritContainedBg", R("palette-grey-300")), A(m.Button, "inheritContainedHoverBg", R("palette-grey-A100")), A(m.Chip, "defaultBorder", R("palette-grey-400")), A(m.Chip, "defaultAvatarColor", R("palette-grey-700")), A(m.Chip, "defaultIconColor", R("palette-grey-700")), A(m.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), A(m.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), A(m.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), A(m.LinearProgress, "primaryBg", Ie(m.primary.main, 0.62)), A(m.LinearProgress, "secondaryBg", Ie(m.secondary.main, 0.62)), A(m.LinearProgress, "errorBg", Ie(m.error.main, 0.62)), A(m.LinearProgress, "infoBg", Ie(m.info.main, 0.62)), A(m.LinearProgress, "successBg", Ie(m.success.main, 0.62)), A(m.LinearProgress, "warningBg", Ie(m.warning.main, 0.62)), A(m.Skeleton, "bg", `rgba(${R("palette-text-primaryChannel")} / 0.11)`), A(m.Slider, "primaryTrack", Ie(m.primary.main, 0.62)), A(m.Slider, "secondaryTrack", Ie(m.secondary.main, 0.62)), A(m.Slider, "errorTrack", Ie(m.error.main, 0.62)), A(m.Slider, "infoTrack", Ie(m.info.main, 0.62)), A(m.Slider, "successTrack", Ie(m.success.main, 0.62)), A(m.Slider, "warningTrack", Ie(m.warning.main, 0.62));
      const _ = Vn(m.background.default, 0.8);
      A(m.SnackbarContent, "bg", _), A(m.SnackbarContent, "color", kt(() => m.getContrastText(_))), A(m.SpeedDialAction, "fabHoverBg", Vn(m.background.paper, 0.15)), A(m.StepConnector, "border", R("palette-grey-400")), A(m.StepContent, "border", R("palette-grey-400")), A(m.Switch, "defaultColor", R("palette-common-white")), A(m.Switch, "defaultDisabledColor", R("palette-grey-100")), A(m.Switch, "primaryDisabledColor", Ie(m.primary.main, 0.62)), A(m.Switch, "secondaryDisabledColor", Ie(m.secondary.main, 0.62)), A(m.Switch, "errorDisabledColor", Ie(m.error.main, 0.62)), A(m.Switch, "infoDisabledColor", Ie(m.info.main, 0.62)), A(m.Switch, "successDisabledColor", Ie(m.success.main, 0.62)), A(m.Switch, "warningDisabledColor", Ie(m.warning.main, 0.62)), A(m.TableCell, "border", Ie(Fn(m.divider, 1), 0.88)), A(m.Tooltip, "bg", Fn(m.grey[700], 0.92));
    }
    if (m.mode === "dark") {
      A(m.Alert, "errorColor", Ie(m.error.light, 0.6)), A(m.Alert, "infoColor", Ie(m.info.light, 0.6)), A(m.Alert, "successColor", Ie(m.success.light, 0.6)), A(m.Alert, "warningColor", Ie(m.warning.light, 0.6)), A(m.Alert, "errorFilledBg", R("palette-error-dark")), A(m.Alert, "infoFilledBg", R("palette-info-dark")), A(m.Alert, "successFilledBg", R("palette-success-dark")), A(m.Alert, "warningFilledBg", R("palette-warning-dark")), A(m.Alert, "errorFilledColor", kt(() => m.getContrastText(m.error.dark))), A(m.Alert, "infoFilledColor", kt(() => m.getContrastText(m.info.dark))), A(m.Alert, "successFilledColor", kt(() => m.getContrastText(m.success.dark))), A(m.Alert, "warningFilledColor", kt(() => m.getContrastText(m.warning.dark))), A(m.Alert, "errorStandardBg", ke(m.error.light, 0.9)), A(m.Alert, "infoStandardBg", ke(m.info.light, 0.9)), A(m.Alert, "successStandardBg", ke(m.success.light, 0.9)), A(m.Alert, "warningStandardBg", ke(m.warning.light, 0.9)), A(m.Alert, "errorIconColor", R("palette-error-main")), A(m.Alert, "infoIconColor", R("palette-info-main")), A(m.Alert, "successIconColor", R("palette-success-main")), A(m.Alert, "warningIconColor", R("palette-warning-main")), A(m.AppBar, "defaultBg", R("palette-grey-900")), A(m.AppBar, "darkBg", R("palette-background-paper")), A(m.AppBar, "darkColor", R("palette-text-primary")), A(m.Avatar, "defaultBg", R("palette-grey-600")), A(m.Button, "inheritContainedBg", R("palette-grey-800")), A(m.Button, "inheritContainedHoverBg", R("palette-grey-700")), A(m.Chip, "defaultBorder", R("palette-grey-700")), A(m.Chip, "defaultAvatarColor", R("palette-grey-300")), A(m.Chip, "defaultIconColor", R("palette-grey-300")), A(m.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), A(m.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), A(m.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), A(m.LinearProgress, "primaryBg", ke(m.primary.main, 0.5)), A(m.LinearProgress, "secondaryBg", ke(m.secondary.main, 0.5)), A(m.LinearProgress, "errorBg", ke(m.error.main, 0.5)), A(m.LinearProgress, "infoBg", ke(m.info.main, 0.5)), A(m.LinearProgress, "successBg", ke(m.success.main, 0.5)), A(m.LinearProgress, "warningBg", ke(m.warning.main, 0.5)), A(m.Skeleton, "bg", `rgba(${R("palette-text-primaryChannel")} / 0.13)`), A(m.Slider, "primaryTrack", ke(m.primary.main, 0.5)), A(m.Slider, "secondaryTrack", ke(m.secondary.main, 0.5)), A(m.Slider, "errorTrack", ke(m.error.main, 0.5)), A(m.Slider, "infoTrack", ke(m.info.main, 0.5)), A(m.Slider, "successTrack", ke(m.success.main, 0.5)), A(m.Slider, "warningTrack", ke(m.warning.main, 0.5));
      const _ = Vn(m.background.default, 0.98);
      A(m.SnackbarContent, "bg", _), A(m.SnackbarContent, "color", kt(() => m.getContrastText(_))), A(m.SpeedDialAction, "fabHoverBg", Vn(m.background.paper, 0.15)), A(m.StepConnector, "border", R("palette-grey-600")), A(m.StepContent, "border", R("palette-grey-600")), A(m.Switch, "defaultColor", R("palette-grey-300")), A(m.Switch, "defaultDisabledColor", R("palette-grey-600")), A(m.Switch, "primaryDisabledColor", ke(m.primary.main, 0.55)), A(m.Switch, "secondaryDisabledColor", ke(m.secondary.main, 0.55)), A(m.Switch, "errorDisabledColor", ke(m.error.main, 0.55)), A(m.Switch, "infoDisabledColor", ke(m.info.main, 0.55)), A(m.Switch, "successDisabledColor", ke(m.success.main, 0.55)), A(m.Switch, "warningDisabledColor", ke(m.warning.main, 0.55)), A(m.TableCell, "border", ke(Fn(m.divider, 1), 0.68)), A(m.Tooltip, "bg", Fn(m.grey[700], 0.92));
    }
    Kt(m.background, "default"), Kt(m.background, "paper"), Kt(m.common, "background"), Kt(m.common, "onBackground"), Kt(m, "divider"), Object.keys(m).forEach((_) => {
      const j = m[_];
      _ !== "tonalOffset" && j && typeof j == "object" && (j.main && A(m[_], "mainChannel", tn(rn(j.main))), j.light && A(m[_], "lightChannel", tn(rn(j.light))), j.dark && A(m[_], "darkChannel", tn(rn(j.dark))), j.contrastText && A(m[_], "contrastTextChannel", tn(rn(j.contrastText))), _ === "text" && (Kt(m[_], "primary"), Kt(m[_], "secondary")), _ === "action" && (j.active && Kt(m[_], "active"), j.selected && Kt(m[_], "selected")));
    });
  }), E = t.reduce((I, m) => it(I, m), E);
  const C = {
    prefix: a,
    disableCssColorScheme: o,
    shouldSkipGeneratingVar: s,
    getSelector: dm(E)
  }, {
    vars: $,
    generateThemeVars: P,
    generateStyleSheets: k
  } = If(E, C);
  return E.vars = $, Object.entries(E.colorSchemes[E.defaultColorScheme]).forEach(([I, m]) => {
    E[I] = m;
  }), E.generateThemeVars = P, E.generateStyleSheets = k, E.generateSpacing = function() {
    return Bl(u.spacing, ko(this));
  }, E.getColorSchemeSelector = Nf(l), E.spacing = E.generateSpacing(), E.shouldSkipGeneratingVar = s, E.unstable_sxConfig = {
    ...Rn,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, E.unstable_sx = function(m) {
    return or({
      sx: m,
      theme: this
    });
  }, E.toRuntimeSource = ic, E;
}
function Is(e, t, r) {
  e.colorSchemes && r && (e.colorSchemes[t] = {
    ...r !== !0 && r,
    palette: ma({
      ...r === !0 ? {} : r.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function ha(e = {}, ...t) {
  const {
    palette: r,
    cssVariables: n = !1,
    colorSchemes: o = r ? void 0 : {
      light: !0
    },
    defaultColorScheme: a = r == null ? void 0 : r.mode,
    ...s
  } = e, l = a || "light", c = o == null ? void 0 : o[l], u = {
    ...o,
    ...r ? {
      [l]: {
        ...typeof c != "boolean" && c,
        palette: r
      }
    } : void 0
  };
  if (n === !1) {
    if (!("colorSchemes" in e))
      return Pi(e, ...t);
    let p = r;
    "palette" in e || u[l] && (u[l] !== !0 ? p = u[l].palette : l === "dark" && (p = {
      mode: "dark"
    }));
    const f = Pi({
      ...e,
      palette: p
    }, ...t);
    return f.defaultColorScheme = l, f.colorSchemes = u, f.palette.mode === "light" && (f.colorSchemes.light = {
      ...u.light !== !0 && u.light,
      palette: f.palette
    }, Is(f, "dark", u.dark)), f.palette.mode === "dark" && (f.colorSchemes.dark = {
      ...u.dark !== !0 && u.dark,
      palette: f.palette
    }, Is(f, "light", u.light)), f;
  }
  return !r && !("light" in u) && l === "light" && (u.light = !0), hm({
    ...s,
    colorSchemes: u,
    defaultColorScheme: l,
    ...typeof n != "boolean" && n
  }, ...t);
}
const ga = ha();
function Fo() {
  const e = Do(ga);
  return process.env.NODE_ENV !== "production" && h.useDebugValue(e), e[Dt] || e;
}
function gm(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Vo = (e) => gm(e) && e !== "classes", ee = ql({
  themeId: Dt,
  defaultTheme: ga,
  rootShouldForwardProp: Vo
});
function ym({
  theme: e,
  ...t
}) {
  const r = Dt in e ? e[Dt] : void 0;
  return /* @__PURE__ */ w.jsx(gn, {
    ...t,
    themeId: r ? Dt : void 0,
    theme: r || e
  });
}
const zn = {
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
};
process.env.NODE_ENV !== "production" && (i.string, i.string, i.string, i.string, i.string, i.oneOf(["dark", "light", "system"]), i.string, i.string);
const {
  CssVarsProvider: vm,
  useColorScheme: bm
} = Rf({
  themeId: Dt,
  // @ts-ignore ignore module augmentation tests
  theme: () => ha({
    cssVariables: !0
  }),
  colorSchemeStorageKey: zn.colorSchemeStorageKey,
  modeStorageKey: zn.modeStorageKey,
  defaultColorScheme: {
    light: zn.defaultLightColorScheme,
    dark: zn.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = {
      ...e,
      typography: oc(e.palette, e.typography)
    };
    return t.unstable_sx = function(n) {
      return or({
        sx: n,
        theme: this
      });
    }, t;
  }
}), xm = vm;
function Em({
  theme: e,
  ...t
}) {
  const r = h.useMemo(() => {
    if (typeof e == "function")
      return e;
    const n = Dt in e ? e[Dt] : e;
    return "colorSchemes" in n ? null : "vars" in n ? e : {
      ...e,
      vars: null
    };
  }, [e]);
  return r ? /* @__PURE__ */ w.jsx(ym, {
    theme: r,
    ...t
  }) : /* @__PURE__ */ w.jsx(xm, {
    theme: e,
    ...t
  });
}
const Cm = ge("MuiBox", ["root"]), Tm = ha(), Xe = Xp({
  themeId: Dt,
  defaultTheme: Tm,
  defaultClassName: Cm.root,
  generateClassName: zl.generate
});
process.env.NODE_ENV !== "production" && (Xe.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: i.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function lc(e) {
  return /* @__PURE__ */ w.jsx(Vl, {
    ...e,
    defaultTheme: ga,
    themeId: Dt
  });
}
process.env.NODE_ENV !== "production" && (lc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: i.oneOfType([i.array, i.func, i.number, i.object, i.string, i.bool])
});
function cc(e) {
  return function(r) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ w.jsx(lc, {
        styles: typeof e == "function" ? (n) => e({
          theme: n,
          ...r
        }) : e
      })
    );
  };
}
function Sm() {
  return ia;
}
const _e = bf;
process.env.NODE_ENV !== "production" && (i.node, i.object.isRequired);
function ye(e) {
  return vf(e);
}
function wm(e) {
  return he("MuiSvgIcon", e);
}
ge("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const Om = (e) => {
  const {
    color: t,
    fontSize: r,
    classes: n
  } = e, o = {
    root: ["root", t !== "inherit" && `color${Z(t)}`, `fontSize${Z(r)}`]
  };
  return Te(o, wm, n);
}, Rm = ee("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color !== "inherit" && t[`color${Z(r.color)}`], t[`fontSize${Z(r.fontSize)}`]];
  }
})(_e(({
  theme: e
}) => {
  var t, r, n, o, a, s, l, c, u, p, f, g, v, y;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (o = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : o.call(t, "fill", {
      duration: (n = (r = (e.vars ?? e).transitions) == null ? void 0 : r.duration) == null ? void 0 : n.shorter
    }),
    variants: [
      {
        props: (d) => !d.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((s = (a = e.typography) == null ? void 0 : a.pxToRem) == null ? void 0 : s.call(a, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((c = (l = e.typography) == null ? void 0 : l.pxToRem) == null ? void 0 : c.call(l, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((p = (u = e.typography) == null ? void 0 : u.pxToRem) == null ? void 0 : p.call(u, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, d]) => d && d.main).map(([d]) => {
        var x, b;
        return {
          props: {
            color: d
          },
          style: {
            color: (b = (x = (e.vars ?? e).palette) == null ? void 0 : x[d]) == null ? void 0 : b.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (g = (f = (e.vars ?? e).palette) == null ? void 0 : f.action) == null ? void 0 : g.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (y = (v = (e.vars ?? e).palette) == null ? void 0 : v.action) == null ? void 0 : y.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), uo = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: a,
    color: s = "inherit",
    component: l = "svg",
    fontSize: c = "medium",
    htmlColor: u,
    inheritViewBox: p = !1,
    titleAccess: f,
    viewBox: g = "0 0 24 24",
    ...v
  } = n, y = /* @__PURE__ */ h.isValidElement(o) && o.type === "svg", d = {
    ...n,
    color: s,
    component: l,
    fontSize: c,
    instanceFontSize: t.fontSize,
    inheritViewBox: p,
    viewBox: g,
    hasSvgAsChild: y
  }, x = {};
  p || (x.viewBox = g);
  const b = Om(d);
  return /* @__PURE__ */ w.jsxs(Rm, {
    as: l,
    className: oe(b.root, a),
    focusable: "false",
    color: u,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: r,
    ...x,
    ...v,
    ...y && o.props,
    ownerState: d,
    children: [y ? o.props.children : o, f ? /* @__PURE__ */ w.jsx("title", {
      children: f
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (uo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: i.oneOfType([i.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: i.oneOfType([i.oneOf(["inherit", "large", "medium", "small"]), i.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: i.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: i.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Reference/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: i.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: i.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: i.string
});
uo.muiName = "SvgIcon";
function dt(e, t) {
  function r(n, o) {
    return /* @__PURE__ */ w.jsx(uo, {
      "data-testid": process.env.NODE_ENV !== "production" ? `${t}Icon` : void 0,
      ref: o,
      ...n,
      children: e
    });
  }
  return process.env.NODE_ENV !== "production" && (r.displayName = `${t}Icon`), r.muiName = uo.muiName, /* @__PURE__ */ h.memo(/* @__PURE__ */ h.forwardRef(r));
}
const Pm = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function $m(e) {
  return he("MuiAvatar", e);
}
ge("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]);
function tt(...e) {
  const t = h.useRef(void 0), r = h.useCallback((n) => {
    const o = e.map((a) => {
      if (a == null)
        return null;
      if (typeof a == "function") {
        const s = a, l = s(n);
        return typeof l == "function" ? l : () => {
          s(null);
        };
      }
      return a.current = n, () => {
        a.current = null;
      };
    });
    return () => {
      o.forEach((a) => a == null ? void 0 : a());
    };
  }, e);
  return h.useMemo(() => e.every((n) => n == null) ? null : (n) => {
    t.current && (t.current(), t.current = void 0), n != null && (t.current = r(n));
  }, e);
}
function km(e) {
  return typeof e == "string";
}
function uc(e, t, r) {
  return e === void 0 || km(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...r
    }
  };
}
function dc(e, t, r) {
  return typeof e == "function" ? e(t, r) : e;
}
function pc(e, t = []) {
  if (e === void 0)
    return {};
  const r = {};
  return Object.keys(e).filter((n) => n.match(/^on[A-Z]/) && typeof e[n] == "function" && !t.includes(n)).forEach((n) => {
    r[n] = e[n];
  }), r;
}
function Ns(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((r) => !(r.match(/^on[A-Z]/) && typeof e[r] == "function")).forEach((r) => {
    t[r] = e[r];
  }), t;
}
function fc(e) {
  const {
    getSlotProps: t,
    additionalProps: r,
    externalSlotProps: n,
    externalForwardedProps: o,
    className: a
  } = e;
  if (!t) {
    const v = oe(r == null ? void 0 : r.className, a, o == null ? void 0 : o.className, n == null ? void 0 : n.className), y = {
      ...r == null ? void 0 : r.style,
      ...o == null ? void 0 : o.style,
      ...n == null ? void 0 : n.style
    }, d = {
      ...r,
      ...o,
      ...n
    };
    return v.length > 0 && (d.className = v), Object.keys(y).length > 0 && (d.style = y), {
      props: d,
      internalRef: void 0
    };
  }
  const s = pc({
    ...o,
    ...n
  }), l = Ns(n), c = Ns(o), u = t(s), p = oe(u == null ? void 0 : u.className, r == null ? void 0 : r.className, a, o == null ? void 0 : o.className, n == null ? void 0 : n.className), f = {
    ...u == null ? void 0 : u.style,
    ...r == null ? void 0 : r.style,
    ...o == null ? void 0 : o.style,
    ...n == null ? void 0 : n.style
  }, g = {
    ...u,
    ...r,
    ...c,
    ...l
  };
  return p.length > 0 && (g.className = p), Object.keys(f).length > 0 && (g.style = f), {
    props: g,
    internalRef: u.ref
  };
}
function Be(e, t) {
  const {
    className: r,
    elementType: n,
    ownerState: o,
    externalForwardedProps: a,
    internalForwardedProps: s,
    shouldForwardComponentProp: l = !1,
    ...c
  } = t, {
    component: u,
    slots: p = {
      [e]: void 0
    },
    slotProps: f = {
      [e]: void 0
    },
    ...g
  } = a, v = p[e] || n, y = dc(f[e], o), {
    props: {
      component: d,
      ...x
    },
    internalRef: b
  } = fc({
    className: r,
    ...c,
    externalForwardedProps: e === "root" ? g : void 0,
    externalSlotProps: y
  }), O = tt(b, y == null ? void 0 : y.ref, t.ref), T = e === "root" ? d || u : d, E = uc(v, {
    ...e === "root" && !u && !p[e] && s,
    ...e !== "root" && !p[e] && s,
    ...x,
    ...T && !l && {
      as: T
    },
    ...T && l && {
      component: T
    },
    ref: O
  }, o);
  return [v, E];
}
const Im = (e) => {
  const {
    classes: t,
    variant: r,
    colorDefault: n
  } = e;
  return Te({
    root: ["root", r, n && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, $m, t);
}, Nm = ee("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], r.colorDefault && t.colorDefault];
  }
})(_e(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none",
  variants: [{
    props: {
      variant: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "square"
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: !0
    },
    style: {
      color: (e.vars || e).palette.background.default,
      ...e.vars ? {
        backgroundColor: e.vars.palette.Avatar.defaultBg
      } : {
        backgroundColor: e.palette.grey[400],
        ...e.applyStyles("dark", {
          backgroundColor: e.palette.grey[600]
        })
      }
    }
  }]
}))), Am = ee("img", {
  name: "MuiAvatar",
  slot: "Img"
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), Mm = ee(Pm, {
  name: "MuiAvatar",
  slot: "Fallback"
})({
  width: "75%",
  height: "75%"
});
function jm({
  crossOrigin: e,
  referrerPolicy: t,
  src: r,
  srcSet: n
}) {
  const [o, a] = h.useState(!1);
  return h.useEffect(() => {
    if (!r && !n)
      return;
    a(!1);
    let s = !0;
    const l = new Image();
    return l.onload = () => {
      s && a("loaded");
    }, l.onerror = () => {
      s && a("error");
    }, l.crossOrigin = e, l.referrerPolicy = t, l.src = r, n && (l.srcset = n), () => {
      s = !1;
    };
  }, [e, t, r, n]), o;
}
const mc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiAvatar"
  }), {
    alt: o,
    children: a,
    className: s,
    component: l = "div",
    slots: c = {},
    slotProps: u = {},
    imgProps: p,
    sizes: f,
    src: g,
    srcSet: v,
    variant: y = "circular",
    ...d
  } = n;
  let x = null;
  const b = {
    ...n,
    component: l,
    variant: y
  }, O = jm({
    ...p,
    ...typeof u.img == "function" ? u.img(b) : u.img,
    src: g,
    srcSet: v
  }), T = g || v, E = T && O !== "error";
  b.colorDefault = !E, delete b.ownerState;
  const C = Im(b), [$, P] = Be("root", {
    ref: r,
    className: oe(C.root, s),
    elementType: Nm,
    externalForwardedProps: {
      slots: c,
      slotProps: u,
      component: l,
      ...d
    },
    ownerState: b
  }), [k, I] = Be("img", {
    className: C.img,
    elementType: Am,
    externalForwardedProps: {
      slots: c,
      slotProps: {
        img: {
          ...p,
          ...u.img
        }
      }
    },
    additionalProps: {
      alt: o,
      src: g,
      srcSet: v,
      sizes: f
    },
    ownerState: b
  }), [m, R] = Be("fallback", {
    className: C.fallback,
    elementType: Mm,
    externalForwardedProps: {
      slots: c,
      slotProps: u
    },
    shouldForwardComponentProp: !0,
    ownerState: b
  });
  return E ? x = /* @__PURE__ */ w.jsx(k, {
    ...I
  }) : a || a === 0 ? x = a : T && o ? x = o[0] : x = /* @__PURE__ */ w.jsx(m, {
    ...R
  }), /* @__PURE__ */ w.jsx($, {
    ...P,
    children: x
  });
});
process.env.NODE_ENV !== "production" && (mc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: i.string,
  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   * @deprecated Use `slotProps.img` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  imgProps: i.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: i.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    fallback: i.oneOfType([i.func, i.object]),
    img: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    fallback: i.elementType,
    img: i.elementType,
    root: i.elementType
  }),
  /**
   * The `src` attribute for the `img` element.
   */
  src: i.string,
  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: i.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The shape of the avatar.
   * @default 'circular'
   */
  variant: i.oneOfType([i.oneOf(["circular", "rounded", "square"]), i.string])
});
var ki = { exports: {} }, Re = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var As;
function _m() {
  if (As) return Re;
  As = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), g = Symbol.for("react.view_transition"), v = Symbol.for("react.client.reference");
  function y(d) {
    if (typeof d == "object" && d !== null) {
      var x = d.$$typeof;
      switch (x) {
        case e:
          switch (d = d.type, d) {
            case r:
            case o:
            case n:
            case c:
            case u:
            case g:
              return d;
            default:
              switch (d = d && d.$$typeof, d) {
                case s:
                case l:
                case f:
                case p:
                  return d;
                case a:
                  return d;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  return Re.ContextConsumer = a, Re.ContextProvider = s, Re.Element = e, Re.ForwardRef = l, Re.Fragment = r, Re.Lazy = f, Re.Memo = p, Re.Portal = t, Re.Profiler = o, Re.StrictMode = n, Re.Suspense = c, Re.SuspenseList = u, Re.isContextConsumer = function(d) {
    return y(d) === a;
  }, Re.isContextProvider = function(d) {
    return y(d) === s;
  }, Re.isElement = function(d) {
    return typeof d == "object" && d !== null && d.$$typeof === e;
  }, Re.isForwardRef = function(d) {
    return y(d) === l;
  }, Re.isFragment = function(d) {
    return y(d) === r;
  }, Re.isLazy = function(d) {
    return y(d) === f;
  }, Re.isMemo = function(d) {
    return y(d) === p;
  }, Re.isPortal = function(d) {
    return y(d) === t;
  }, Re.isProfiler = function(d) {
    return y(d) === o;
  }, Re.isStrictMode = function(d) {
    return y(d) === n;
  }, Re.isSuspense = function(d) {
    return y(d) === c;
  }, Re.isSuspenseList = function(d) {
    return y(d) === u;
  }, Re.isValidElementType = function(d) {
    return typeof d == "string" || typeof d == "function" || d === r || d === o || d === n || d === c || d === u || typeof d == "object" && d !== null && (d.$$typeof === f || d.$$typeof === p || d.$$typeof === s || d.$$typeof === a || d.$$typeof === l || d.$$typeof === v || d.getModuleId !== void 0);
  }, Re.typeOf = y, Re;
}
var Pe = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ms;
function Dm() {
  return Ms || (Ms = 1, process.env.NODE_ENV !== "production" && function() {
    function e(d) {
      if (typeof d == "object" && d !== null) {
        var x = d.$$typeof;
        switch (x) {
          case t:
            switch (d = d.type, d) {
              case n:
              case a:
              case o:
              case u:
              case p:
              case v:
                return d;
              default:
                switch (d = d && d.$$typeof, d) {
                  case l:
                  case c:
                  case g:
                  case f:
                    return d;
                  case s:
                    return d;
                  default:
                    return x;
                }
            }
          case r:
            return x;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), v = Symbol.for("react.view_transition"), y = Symbol.for("react.client.reference");
    Pe.ContextConsumer = s, Pe.ContextProvider = l, Pe.Element = t, Pe.ForwardRef = c, Pe.Fragment = n, Pe.Lazy = g, Pe.Memo = f, Pe.Portal = r, Pe.Profiler = a, Pe.StrictMode = o, Pe.Suspense = u, Pe.SuspenseList = p, Pe.isContextConsumer = function(d) {
      return e(d) === s;
    }, Pe.isContextProvider = function(d) {
      return e(d) === l;
    }, Pe.isElement = function(d) {
      return typeof d == "object" && d !== null && d.$$typeof === t;
    }, Pe.isForwardRef = function(d) {
      return e(d) === c;
    }, Pe.isFragment = function(d) {
      return e(d) === n;
    }, Pe.isLazy = function(d) {
      return e(d) === g;
    }, Pe.isMemo = function(d) {
      return e(d) === f;
    }, Pe.isPortal = function(d) {
      return e(d) === r;
    }, Pe.isProfiler = function(d) {
      return e(d) === a;
    }, Pe.isStrictMode = function(d) {
      return e(d) === o;
    }, Pe.isSuspense = function(d) {
      return e(d) === u;
    }, Pe.isSuspenseList = function(d) {
      return e(d) === p;
    }, Pe.isValidElementType = function(d) {
      return typeof d == "string" || typeof d == "function" || d === n || d === a || d === o || d === u || d === p || typeof d == "object" && d !== null && (d.$$typeof === g || d.$$typeof === f || d.$$typeof === l || d.$$typeof === s || d.$$typeof === c || d.$$typeof === y || d.getModuleId !== void 0);
    }, Pe.typeOf = e;
  }()), Pe;
}
process.env.NODE_ENV === "production" ? ki.exports = _m() : ki.exports = Dm();
var ya = ki.exports;
function Jt(e, t, r, n, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const a = e[t], s = o || t;
  return a == null ? null : a && a.nodeType !== 1 ? new Error(`Invalid ${n} \`${s}\` supplied to \`${r}\`. Expected an HTMLElement.`) : null;
}
function va(e) {
  var f;
  const {
    elementType: t,
    externalSlotProps: r,
    ownerState: n,
    skipResolvingSlotProps: o = !1,
    ...a
  } = e, s = o ? {} : dc(r, n), {
    props: l,
    internalRef: c
  } = fc({
    ...a,
    externalSlotProps: s
  }), u = tt(c, s == null ? void 0 : s.ref, (f = e.additionalProps) == null ? void 0 : f.ref);
  return uc(t, {
    ...l,
    ref: u
  }, n);
}
function xt(e) {
  return e && e.ownerDocument || document;
}
const Lt = /* @__PURE__ */ h.createContext({});
process.env.NODE_ENV !== "production" && (Lt.displayName = "ListContext");
function Lm(e) {
  return he("MuiList", e);
}
ge("MuiList", ["root", "padding", "dense", "subheader"]);
const Bm = (e) => {
  const {
    classes: t,
    disablePadding: r,
    dense: n,
    subheader: o
  } = e;
  return Te({
    root: ["root", !r && "padding", n && "dense", o && "subheader"]
  }, Lm, t);
}, Fm = ee("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.disablePadding && t.padding, r.dense && t.dense, r.subheader && t.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: e
    }) => e.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), ba = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiList"
  }), {
    children: o,
    className: a,
    component: s = "ul",
    dense: l = !1,
    disablePadding: c = !1,
    subheader: u,
    ...p
  } = n, f = h.useMemo(() => ({
    dense: l
  }), [l]), g = {
    ...n,
    component: s,
    dense: l,
    disablePadding: c
  }, v = Bm(g);
  return /* @__PURE__ */ w.jsx(Lt.Provider, {
    value: f,
    children: /* @__PURE__ */ w.jsxs(Fm, {
      as: s,
      className: oe(v.root, a),
      ref: r,
      ownerState: g,
      ...p,
      children: [u, o]
    })
  });
});
process.env.NODE_ENV !== "production" && (ba.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: i.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: i.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: i.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function hc(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
function js(...e) {
  return e.reduce((t, r) => r == null ? t : function(...o) {
    t.apply(this, o), r.apply(this, o);
  }, () => {
  });
}
function Vm(e, t = 166) {
  let r;
  function n(...o) {
    const a = () => {
      e.apply(this, o);
    };
    clearTimeout(r), r = setTimeout(a, t);
  }
  return n.clear = () => {
    clearTimeout(r);
  }, n;
}
function br(e) {
  return xt(e).defaultView || window;
}
function _s(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let Ds = 0;
function zm(e) {
  const [t, r] = h.useState(e), n = e || t;
  return h.useEffect(() => {
    t == null && (Ds += 1, r(`mui-${Ds}`));
  }, [t]), n;
}
const Wm = {
  ...h
}, Ls = Wm.useId;
function xa(e) {
  if (Ls !== void 0) {
    const t = Ls();
    return e ?? t;
  }
  return zm(e);
}
function Um(e, t, r, n, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const a = o || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${a}\` is not supported. Please remove it.`) : null;
}
function Hm(e) {
  const {
    controlled: t,
    default: r,
    name: n,
    state: o = "value"
  } = e, {
    current: a
  } = h.useRef(t !== void 0), [s, l] = h.useState(r), c = a ? t : s;
  if (process.env.NODE_ENV !== "production") {
    h.useEffect(() => {
      a !== (t !== void 0) && console.error([`MUI: A component is changing the ${a ? "" : "un"}controlled ${o} state of ${n} to be ${a ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, t]);
    const {
      current: p
    } = h.useRef(r);
    h.useEffect(() => {
      !a && !Object.is(p, r) && console.error([`MUI: A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(r)]);
  }
  const u = h.useCallback((p) => {
    a || l(p);
  }, []);
  return [c, u];
}
function rr(e) {
  const t = h.useRef(e);
  return ir(() => {
    t.current = e;
  }), h.useRef((...r) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...r)
  )).current;
}
function Ym(e, t) {
  const r = e.charCodeAt(2);
  return e[0] === "o" && e[1] === "n" && r >= 65 && r <= 90 && typeof t == "function";
}
function qm(e, t) {
  if (!e)
    return t;
  function r(s, l) {
    const c = {};
    return Object.keys(l).forEach((u) => {
      Ym(u, l[u]) && typeof s[u] == "function" && (c[u] = (...p) => {
        s[u](...p), l[u](...p);
      });
    }), c;
  }
  if (typeof e == "function" || typeof t == "function")
    return (s) => {
      const l = typeof t == "function" ? t(s) : t, c = typeof e == "function" ? e({
        ...s,
        ...l
      }) : e, u = oe(s == null ? void 0 : s.className, l == null ? void 0 : l.className, c == null ? void 0 : c.className), p = r(c, l);
      return {
        ...l,
        ...c,
        ...p,
        ...!!u && {
          className: u
        },
        ...(l == null ? void 0 : l.style) && (c == null ? void 0 : c.style) && {
          style: {
            ...l.style,
            ...c.style
          }
        },
        ...(l == null ? void 0 : l.sx) && (c == null ? void 0 : c.sx) && {
          sx: [...Array.isArray(l.sx) ? l.sx : [l.sx], ...Array.isArray(c.sx) ? c.sx : [c.sx]]
        }
      };
    };
  const n = t, o = r(e, n), a = oe(n == null ? void 0 : n.className, e == null ? void 0 : e.className);
  return {
    ...t,
    ...e,
    ...o,
    ...!!a && {
      className: a
    },
    ...(n == null ? void 0 : n.style) && (e == null ? void 0 : e.style) && {
      style: {
        ...n.style,
        ...e.style
      }
    },
    ...(n == null ? void 0 : n.sx) && (e == null ? void 0 : e.sx) && {
      sx: [...Array.isArray(n.sx) ? n.sx : [n.sx], ...Array.isArray(e.sx) ? e.sx : [e.sx]]
    }
  };
}
function pi(e, t, r) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : r ? null : e.firstChild;
}
function Bs(e, t, r) {
  return e === t ? r ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : r ? null : e.lastChild;
}
function gc(e, t) {
  if (t === void 0)
    return !0;
  let r = e.innerText;
  return r === void 0 && (r = e.textContent), r = r.trim().toLowerCase(), r.length === 0 ? !1 : t.repeating ? r[0] === t.keys[0] : r.startsWith(t.keys.join(""));
}
function Xr(e, t, r, n, o, a) {
  let s = !1, l = o(e, t, t ? r : !1);
  for (; l; ) {
    if (l === e.firstChild) {
      if (s)
        return !1;
      s = !0;
    }
    const c = n ? !1 : l.disabled || l.getAttribute("aria-disabled") === "true";
    if (!l.hasAttribute("tabindex") || !gc(l, a) || c)
      l = o(e, l, r);
    else
      return l.focus(), !0;
  }
  return !1;
}
const yc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: n,
    autoFocus: o = !1,
    autoFocusItem: a = !1,
    children: s,
    className: l,
    disabledItemsFocusable: c = !1,
    disableListWrap: u = !1,
    onKeyDown: p,
    variant: f = "selectedMenu",
    ...g
  } = t, v = h.useRef(null), y = h.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  ir(() => {
    o && v.current.focus();
  }, [o]), h.useImperativeHandle(n, () => ({
    adjustStyleForScrollbar: (T, {
      direction: E
    }) => {
      const C = !v.current.style.width;
      if (T.clientHeight < v.current.clientHeight && C) {
        const $ = `${hc(br(T))}px`;
        v.current.style[E === "rtl" ? "paddingLeft" : "paddingRight"] = $, v.current.style.width = `calc(100% + ${$})`;
      }
      return v.current;
    }
  }), []);
  const d = (T) => {
    const E = v.current, C = T.key;
    if (T.ctrlKey || T.metaKey || T.altKey) {
      p && p(T);
      return;
    }
    const P = xt(E).activeElement;
    if (C === "ArrowDown")
      T.preventDefault(), Xr(E, P, u, c, pi);
    else if (C === "ArrowUp")
      T.preventDefault(), Xr(E, P, u, c, Bs);
    else if (C === "Home")
      T.preventDefault(), Xr(E, null, u, c, pi);
    else if (C === "End")
      T.preventDefault(), Xr(E, null, u, c, Bs);
    else if (C.length === 1) {
      const k = y.current, I = C.toLowerCase(), m = performance.now();
      k.keys.length > 0 && (m - k.lastTime > 500 ? (k.keys = [], k.repeating = !0, k.previousKeyMatched = !0) : k.repeating && I !== k.keys[0] && (k.repeating = !1)), k.lastTime = m, k.keys.push(I);
      const R = P && !k.repeating && gc(P, k);
      k.previousKeyMatched && (R || Xr(E, P, !1, c, pi, k)) ? T.preventDefault() : k.previousKeyMatched = !1;
    }
    p && p(T);
  }, x = tt(v, r);
  let b = -1;
  h.Children.forEach(s, (T, E) => {
    if (!/* @__PURE__ */ h.isValidElement(T)) {
      b === E && (b += 1, b >= s.length && (b = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && ya.isFragment(T) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), T.props.disabled || (f === "selectedMenu" && T.props.selected || b === -1) && (b = E), b === E && (T.props.disabled || T.props.muiSkipListHighlight || T.type.muiSkipListHighlight) && (b += 1, b >= s.length && (b = -1));
  });
  const O = h.Children.map(s, (T, E) => {
    if (E === b) {
      const C = {};
      return a && (C.autoFocus = !0), T.props.tabIndex === void 0 && f === "selectedMenu" && (C.tabIndex = 0), /* @__PURE__ */ h.cloneElement(T, C);
    }
    return T;
  });
  return /* @__PURE__ */ w.jsx(ba, {
    role: "menu",
    ref: x,
    className: l,
    onKeyDown: d,
    tabIndex: o ? 0 : -1,
    ...g,
    children: O
  });
});
process.env.NODE_ENV !== "production" && (yc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: i.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: i.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: i.node,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: i.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: i.bool,
  /**
   * @ignore
   */
  onKeyDown: i.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: i.oneOf(["menu", "selectedMenu"])
});
const zo = i.oneOfType([i.func, i.object]);
function zt(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...n) {
    return e(...n) || t(...n);
  };
}
function Km(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function Gm(e, t, r, n, o) {
  const a = e[t], s = o || t;
  if (a == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  return typeof a == "function" && !Km(a) && (l = "Did you accidentally provide a plain function component instead?"), l !== void 0 ? new Error(`Invalid ${n} \`${s}\` supplied to \`${r}\`. Expected an element type that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Ea = zt(i.elementType, Gm);
function Xm(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function vc(e, t, r, n) {
  const o = e[t];
  if (o == null || !Number.isInteger(o)) {
    const a = Xm(o);
    return new RangeError(`Invalid ${n} \`${t}\` of type \`${a}\` supplied to \`${r}\`, expected \`integer\`.`);
  }
  return null;
}
function bc(e, t, r, n) {
  return e[t] === void 0 ? null : vc(e, t, r, n);
}
function Ii() {
  return null;
}
bc.isRequired = vc;
Ii.isRequired = Ii;
const sn = process.env.NODE_ENV === "production" ? Ii : bc;
function Ni(e) {
  return typeof e == "string";
}
const Fs = {};
function xc(e, t) {
  const r = h.useRef(Fs);
  return r.current === Fs && (r.current = e(t)), r;
}
const Jm = [];
function Zm(e) {
  h.useEffect(e, Jm);
}
class Wo {
  constructor() {
    Hr(this, "currentId", null);
    Hr(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    Hr(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new Wo();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, r) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, r();
    }, t);
  }
}
function $r() {
  const e = xc(Wo.create).current;
  return Zm(e.disposeEffect), e;
}
function Qm(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function Ec(e, t, r, n, o) {
  const a = e[t], s = o || t;
  if (a == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  const c = a.type;
  return typeof c == "function" && !Qm(c) && (l = "Did you accidentally use a plain function component for an element instead?"), l !== void 0 ? new Error(`Invalid ${n} \`${s}\` supplied to \`${r}\`. Expected an element that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Br = zt(i.element, Ec);
Br.isRequired = zt(i.element.isRequired, Ec);
function Pn(e) {
  var t;
  return parseInt(h.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
function Cc(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function Ai(e, t) {
  return Ai = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Ai(e, t);
}
function Tc(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Ai(e, t);
}
const Vs = {
  disabled: !1
};
var eh = process.env.NODE_ENV !== "production" ? i.oneOfType([i.number, i.shape({
  enter: i.number,
  exit: i.number,
  appear: i.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && i.oneOfType([i.string, i.shape({
  enter: i.string,
  exit: i.string,
  active: i.string
}), i.shape({
  enter: i.string,
  enterDone: i.string,
  enterActive: i.string,
  exit: i.string,
  exitDone: i.string,
  exitActive: i.string
})]);
const po = ot.createContext(null);
var th = function(t) {
  return t.scrollTop;
}, nn = "unmounted", mr = "exited", hr = "entering", Pr = "entered", Mi = "exiting", Wt = /* @__PURE__ */ function(e) {
  Tc(t, e);
  function t(n, o) {
    var a;
    a = e.call(this, n, o) || this;
    var s = o, l = s && !s.isMounting ? n.enter : n.appear, c;
    return a.appearStatus = null, n.in ? l ? (c = mr, a.appearStatus = hr) : c = Pr : n.unmountOnExit || n.mountOnEnter ? c = nn : c = mr, a.state = {
      status: c
    }, a.nextCallback = null, a;
  }
  t.getDerivedStateFromProps = function(o, a) {
    var s = o.in;
    return s && a.status === nn ? {
      status: mr
    } : null;
  };
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, r.componentDidUpdate = function(o) {
    var a = null;
    if (o !== this.props) {
      var s = this.state.status;
      this.props.in ? s !== hr && s !== Pr && (a = hr) : (s === hr || s === Pr) && (a = Mi);
    }
    this.updateStatus(!1, a);
  }, r.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, r.getTimeouts = function() {
    var o = this.props.timeout, a, s, l;
    return a = s = l = o, o != null && typeof o != "number" && (a = o.exit, s = o.enter, l = o.appear !== void 0 ? o.appear : s), {
      exit: a,
      enter: s,
      appear: l
    };
  }, r.updateStatus = function(o, a) {
    if (o === void 0 && (o = !1), a !== null)
      if (this.cancelNextCallback(), a === hr) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var s = this.props.nodeRef ? this.props.nodeRef.current : Dn.findDOMNode(this);
          s && th(s);
        }
        this.performEnter(o);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === mr && this.setState({
      status: nn
    });
  }, r.performEnter = function(o) {
    var a = this, s = this.props.enter, l = this.context ? this.context.isMounting : o, c = this.props.nodeRef ? [l] : [Dn.findDOMNode(this), l], u = c[0], p = c[1], f = this.getTimeouts(), g = l ? f.appear : f.enter;
    if (!o && !s || Vs.disabled) {
      this.safeSetState({
        status: Pr
      }, function() {
        a.props.onEntered(u);
      });
      return;
    }
    this.props.onEnter(u, p), this.safeSetState({
      status: hr
    }, function() {
      a.props.onEntering(u, p), a.onTransitionEnd(g, function() {
        a.safeSetState({
          status: Pr
        }, function() {
          a.props.onEntered(u, p);
        });
      });
    });
  }, r.performExit = function() {
    var o = this, a = this.props.exit, s = this.getTimeouts(), l = this.props.nodeRef ? void 0 : Dn.findDOMNode(this);
    if (!a || Vs.disabled) {
      this.safeSetState({
        status: mr
      }, function() {
        o.props.onExited(l);
      });
      return;
    }
    this.props.onExit(l), this.safeSetState({
      status: Mi
    }, function() {
      o.props.onExiting(l), o.onTransitionEnd(s.exit, function() {
        o.safeSetState({
          status: mr
        }, function() {
          o.props.onExited(l);
        });
      });
    });
  }, r.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, r.safeSetState = function(o, a) {
    a = this.setNextCallback(a), this.setState(o, a);
  }, r.setNextCallback = function(o) {
    var a = this, s = !0;
    return this.nextCallback = function(l) {
      s && (s = !1, a.nextCallback = null, o(l));
    }, this.nextCallback.cancel = function() {
      s = !1;
    }, this.nextCallback;
  }, r.onTransitionEnd = function(o, a) {
    this.setNextCallback(a);
    var s = this.props.nodeRef ? this.props.nodeRef.current : Dn.findDOMNode(this), l = o == null && !this.props.addEndListener;
    if (!s || l) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var c = this.props.nodeRef ? [this.nextCallback] : [s, this.nextCallback], u = c[0], p = c[1];
      this.props.addEndListener(u, p);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, r.render = function() {
    var o = this.state.status;
    if (o === nn)
      return null;
    var a = this.props, s = a.children;
    a.in, a.mountOnEnter, a.unmountOnExit, a.appear, a.enter, a.exit, a.timeout, a.addEndListener, a.onEnter, a.onEntering, a.onEntered, a.onExit, a.onExiting, a.onExited, a.nodeRef;
    var l = Cc(a, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ ot.createElement(po.Provider, {
        value: null
      }, typeof s == "function" ? s(o, l) : ot.cloneElement(ot.Children.only(s), l))
    );
  }, t;
}(ot.Component);
Wt.contextType = po;
Wt.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: i.shape({
    current: typeof Element > "u" ? i.any : function(e, t, r, n, o, a) {
      var s = e[t];
      return i.instanceOf(s && "ownerDocument" in s ? s.ownerDocument.defaultView.Element : Element)(e, t, r, n, o, a);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: i.oneOfType([i.func.isRequired, i.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: i.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: i.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: i.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: i.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: i.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: i.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var r = eh;
    t.addEndListener || (r = r.isRequired);
    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      o[a - 1] = arguments[a];
    return r.apply(void 0, [t].concat(o));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: i.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: i.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: i.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: i.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: i.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: i.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: i.func
} : {};
function Rr() {
}
Wt.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Rr,
  onEntering: Rr,
  onEntered: Rr,
  onExit: Rr,
  onExiting: Rr,
  onExited: Rr
};
Wt.UNMOUNTED = nn;
Wt.EXITED = mr;
Wt.ENTERING = hr;
Wt.ENTERED = Pr;
Wt.EXITING = Mi;
function rh(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ca(e, t) {
  var r = function(a) {
    return t && Kn(a) ? t(a) : a;
  }, n = /* @__PURE__ */ Object.create(null);
  return e && Au.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    n[o.key] = r(o);
  }), n;
}
function nh(e, t) {
  e = e || {}, t = t || {};
  function r(p) {
    return p in t ? t[p] : e[p];
  }
  var n = /* @__PURE__ */ Object.create(null), o = [];
  for (var a in e)
    a in t ? o.length && (n[a] = o, o = []) : o.push(a);
  var s, l = {};
  for (var c in t) {
    if (n[c])
      for (s = 0; s < n[c].length; s++) {
        var u = n[c][s];
        l[n[c][s]] = r(u);
      }
    l[c] = r(c);
  }
  for (s = 0; s < o.length; s++)
    l[o[s]] = r(o[s]);
  return l;
}
function gr(e, t, r) {
  return r[t] != null ? r[t] : e.props[t];
}
function oh(e, t) {
  return Ca(e.children, function(r) {
    return Gn(r, {
      onExited: t.bind(null, r),
      in: !0,
      appear: gr(r, "appear", e),
      enter: gr(r, "enter", e),
      exit: gr(r, "exit", e)
    });
  });
}
function ih(e, t, r) {
  var n = Ca(e.children), o = nh(t, n);
  return Object.keys(o).forEach(function(a) {
    var s = o[a];
    if (Kn(s)) {
      var l = a in t, c = a in n, u = t[a], p = Kn(u) && !u.props.in;
      c && (!l || p) ? o[a] = Gn(s, {
        onExited: r.bind(null, s),
        in: !0,
        exit: gr(s, "exit", e),
        enter: gr(s, "enter", e)
      }) : !c && l && !p ? o[a] = Gn(s, {
        in: !1
      }) : c && l && Kn(u) && (o[a] = Gn(s, {
        onExited: r.bind(null, s),
        in: u.props.in,
        exit: gr(s, "exit", e),
        enter: gr(s, "enter", e)
      }));
    }
  }), o;
}
var ah = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, sh = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, Ta = /* @__PURE__ */ function(e) {
  Tc(t, e);
  function t(n, o) {
    var a;
    a = e.call(this, n, o) || this;
    var s = a.handleExited.bind(rh(a));
    return a.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, a;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, r.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(o, a) {
    var s = a.children, l = a.handleExited, c = a.firstRender;
    return {
      children: c ? oh(o, l) : ih(o, s, l),
      firstRender: !1
    };
  }, r.handleExited = function(o, a) {
    var s = Ca(this.props.children);
    o.key in s || (o.props.onExited && o.props.onExited(a), this.mounted && this.setState(function(l) {
      var c = io({}, l.children);
      return delete c[o.key], {
        children: c
      };
    }));
  }, r.render = function() {
    var o = this.props, a = o.component, s = o.childFactory, l = Cc(o, ["component", "childFactory"]), c = this.state.contextValue, u = ah(this.state.children).map(s);
    return delete l.appear, delete l.enter, delete l.exit, a === null ? /* @__PURE__ */ ot.createElement(po.Provider, {
      value: c
    }, u) : /* @__PURE__ */ ot.createElement(po.Provider, {
      value: c
    }, /* @__PURE__ */ ot.createElement(a, l, u));
  }, t;
}(ot.Component);
Ta.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: i.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: i.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: i.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: i.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: i.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: i.func
} : {};
Ta.defaultProps = sh;
const Sc = (e) => e.scrollTop;
function fo(e, t) {
  const {
    timeout: r,
    easing: n,
    style: o = {}
  } = e;
  return {
    duration: o.transitionDuration ?? (typeof r == "number" ? r : r[t.mode] || 0),
    easing: o.transitionTimingFunction ?? (typeof n == "object" ? n[t.mode] : n),
    delay: o.transitionDelay
  };
}
function ji(e) {
  return `scale(${e}, ${e ** 2})`;
}
const lh = {
  entering: {
    opacity: 1,
    transform: ji(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, fi = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), vn = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const {
    addEndListener: n,
    appear: o = !0,
    children: a,
    easing: s,
    in: l,
    onEnter: c,
    onEntered: u,
    onEntering: p,
    onExit: f,
    onExited: g,
    onExiting: v,
    style: y,
    timeout: d = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: x = Wt,
    ...b
  } = t, O = $r(), T = h.useRef(), E = Fo(), C = h.useRef(null), $ = tt(C, Pn(a), r), P = (D) => (M) => {
    if (D) {
      const U = C.current;
      M === void 0 ? D(U) : D(U, M);
    }
  }, k = P(p), I = P((D, M) => {
    Sc(D);
    const {
      duration: U,
      delay: te,
      easing: Y
    } = fo({
      style: y,
      timeout: d,
      easing: s
    }, {
      mode: "enter"
    });
    let N;
    d === "auto" ? (N = E.transitions.getAutoHeightDuration(D.clientHeight), T.current = N) : N = U, D.style.transition = [E.transitions.create("opacity", {
      duration: N,
      delay: te
    }), E.transitions.create("transform", {
      duration: fi ? N : N * 0.666,
      delay: te,
      easing: Y
    })].join(","), c && c(D, M);
  }), m = P(u), R = P(v), _ = P((D) => {
    const {
      duration: M,
      delay: U,
      easing: te
    } = fo({
      style: y,
      timeout: d,
      easing: s
    }, {
      mode: "exit"
    });
    let Y;
    d === "auto" ? (Y = E.transitions.getAutoHeightDuration(D.clientHeight), T.current = Y) : Y = M, D.style.transition = [E.transitions.create("opacity", {
      duration: Y,
      delay: U
    }), E.transitions.create("transform", {
      duration: fi ? Y : Y * 0.666,
      delay: fi ? U : U || Y * 0.333,
      easing: te
    })].join(","), D.style.opacity = 0, D.style.transform = ji(0.75), f && f(D);
  }), j = P(g), V = (D) => {
    d === "auto" && O.start(T.current || 0, D), n && n(C.current, D);
  };
  return /* @__PURE__ */ w.jsx(x, {
    appear: o,
    in: l,
    nodeRef: C,
    onEnter: I,
    onEntered: m,
    onEntering: k,
    onExit: _,
    onExited: j,
    onExiting: R,
    addEndListener: V,
    timeout: d === "auto" ? null : d,
    ...b,
    children: (D, {
      ownerState: M,
      ...U
    }) => /* @__PURE__ */ h.cloneElement(a, {
      style: {
        opacity: 0,
        transform: ji(0.75),
        visibility: D === "exited" && !l ? "hidden" : void 0,
        ...lh[D],
        ...y,
        ...a.props.style
      },
      ref: $,
      ...U
    })
  });
});
process.env.NODE_ENV !== "production" && (vn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: i.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: i.bool,
  /**
   * A single child content element.
   */
  children: Br.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: i.oneOfType([i.shape({
    enter: i.string,
    exit: i.string
  }), i.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: i.bool,
  /**
   * @ignore
   */
  onEnter: i.func,
  /**
   * @ignore
   */
  onEntered: i.func,
  /**
   * @ignore
   */
  onEntering: i.func,
  /**
   * @ignore
   */
  onExit: i.func,
  /**
   * @ignore
   */
  onExited: i.func,
  /**
   * @ignore
   */
  onExiting: i.func,
  /**
   * @ignore
   */
  style: i.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: i.oneOfType([i.oneOf(["auto"]), i.number, i.shape({
    appear: i.number,
    enter: i.number,
    exit: i.number
  })])
});
vn && (vn.muiSupportAuto = !0);
function ch(e) {
  const t = xt(e);
  return t.body === e ? br(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function ln(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function zs(e) {
  return parseInt(br(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function uh(e) {
  const r = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), n = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return r || n;
}
function Ws(e, t, r, n, o) {
  const a = [t, r, ...n];
  [].forEach.call(e.children, (s) => {
    const l = !a.includes(s), c = !uh(s);
    l && c && ln(s, o);
  });
}
function mi(e, t) {
  let r = -1;
  return e.some((n, o) => t(n) ? (r = o, !0) : !1), r;
}
function dh(e, t) {
  const r = [], n = e.container;
  if (!t.disableScrollLock) {
    if (ch(n)) {
      const s = hc(br(n));
      r.push({
        value: n.style.paddingRight,
        property: "padding-right",
        el: n
      }), n.style.paddingRight = `${zs(n) + s}px`;
      const l = xt(n).querySelectorAll(".mui-fixed");
      [].forEach.call(l, (c) => {
        r.push({
          value: c.style.paddingRight,
          property: "padding-right",
          el: c
        }), c.style.paddingRight = `${zs(c) + s}px`;
      });
    }
    let a;
    if (n.parentNode instanceof DocumentFragment)
      a = xt(n).body;
    else {
      const s = n.parentElement, l = br(n);
      a = (s == null ? void 0 : s.nodeName) === "HTML" && l.getComputedStyle(s).overflowY === "scroll" ? s : n;
    }
    r.push({
      value: a.style.overflow,
      property: "overflow",
      el: a
    }, {
      value: a.style.overflowX,
      property: "overflow-x",
      el: a
    }, {
      value: a.style.overflowY,
      property: "overflow-y",
      el: a
    }), a.style.overflow = "hidden";
  }
  return () => {
    r.forEach(({
      value: a,
      el: s,
      property: l
    }) => {
      a ? s.style.setProperty(l, a) : s.style.removeProperty(l);
    });
  };
}
function ph(e) {
  const t = [];
  return [].forEach.call(e.children, (r) => {
    r.getAttribute("aria-hidden") === "true" && t.push(r);
  }), t;
}
class fh {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, r) {
    let n = this.modals.indexOf(t);
    if (n !== -1)
      return n;
    n = this.modals.length, this.modals.push(t), t.modalRef && ln(t.modalRef, !1);
    const o = ph(r);
    Ws(r, t.mount, t.modalRef, o, !0);
    const a = mi(this.containers, (s) => s.container === r);
    return a !== -1 ? (this.containers[a].modals.push(t), n) : (this.containers.push({
      modals: [t],
      container: r,
      restore: null,
      hiddenSiblings: o
    }), n);
  }
  mount(t, r) {
    const n = mi(this.containers, (a) => a.modals.includes(t)), o = this.containers[n];
    o.restore || (o.restore = dh(o, r));
  }
  remove(t, r = !0) {
    const n = this.modals.indexOf(t);
    if (n === -1)
      return n;
    const o = mi(this.containers, (s) => s.modals.includes(t)), a = this.containers[o];
    if (a.modals.splice(a.modals.indexOf(t), 1), this.modals.splice(n, 1), a.modals.length === 0)
      a.restore && a.restore(), t.modalRef && ln(t.modalRef, r), Ws(a.container, t.mount, t.modalRef, a.hiddenSiblings, !1), this.containers.splice(o, 1);
    else {
      const s = a.modals[a.modals.length - 1];
      s.modalRef && ln(s.modalRef, !1);
    }
    return n;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const mh = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function hh(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function gh(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (n) => e.ownerDocument.querySelector(`input[type="radio"]${n}`);
  let r = t(`[name="${e.name}"]:checked`);
  return r || (r = t(`[name="${e.name}"]`)), r !== e;
}
function yh(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || gh(e));
}
function vh(e) {
  const t = [], r = [];
  return Array.from(e.querySelectorAll(mh)).forEach((n, o) => {
    const a = hh(n);
    a === -1 || !yh(n) || (a === 0 ? t.push(n) : r.push({
      documentOrder: o,
      tabIndex: a,
      node: n
    }));
  }), r.sort((n, o) => n.tabIndex === o.tabIndex ? n.documentOrder - o.documentOrder : n.tabIndex - o.tabIndex).map((n) => n.node).concat(t);
}
function bh() {
  return !0;
}
function mo(e) {
  const {
    children: t,
    disableAutoFocus: r = !1,
    disableEnforceFocus: n = !1,
    disableRestoreFocus: o = !1,
    getTabbable: a = vh,
    isEnabled: s = bh,
    open: l
  } = e, c = h.useRef(!1), u = h.useRef(null), p = h.useRef(null), f = h.useRef(null), g = h.useRef(null), v = h.useRef(!1), y = h.useRef(null), d = tt(Pn(t), y), x = h.useRef(null);
  h.useEffect(() => {
    !l || !y.current || (v.current = !r);
  }, [r, l]), h.useEffect(() => {
    if (!l || !y.current)
      return;
    const T = xt(y.current);
    return y.current.contains(T.activeElement) || (y.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), y.current.setAttribute("tabIndex", "-1")), v.current && y.current.focus()), () => {
      o || (f.current && f.current.focus && (c.current = !0, f.current.focus()), f.current = null);
    };
  }, [l]), h.useEffect(() => {
    if (!l || !y.current)
      return;
    const T = xt(y.current), E = (P) => {
      x.current = P, !(n || !s() || P.key !== "Tab") && T.activeElement === y.current && P.shiftKey && (c.current = !0, p.current && p.current.focus());
    }, C = () => {
      var I, m;
      const P = y.current;
      if (P === null)
        return;
      if (!T.hasFocus() || !s() || c.current) {
        c.current = !1;
        return;
      }
      if (P.contains(T.activeElement) || n && T.activeElement !== u.current && T.activeElement !== p.current)
        return;
      if (T.activeElement !== g.current)
        g.current = null;
      else if (g.current !== null)
        return;
      if (!v.current)
        return;
      let k = [];
      if ((T.activeElement === u.current || T.activeElement === p.current) && (k = a(y.current)), k.length > 0) {
        const R = !!((I = x.current) != null && I.shiftKey && ((m = x.current) == null ? void 0 : m.key) === "Tab"), _ = k[0], j = k[k.length - 1];
        typeof _ != "string" && typeof j != "string" && (R ? j.focus() : _.focus());
      } else
        P.focus();
    };
    T.addEventListener("focusin", C), T.addEventListener("keydown", E, !0);
    const $ = setInterval(() => {
      T.activeElement && T.activeElement.tagName === "BODY" && C();
    }, 50);
    return () => {
      clearInterval($), T.removeEventListener("focusin", C), T.removeEventListener("keydown", E, !0);
    };
  }, [r, n, o, s, l, a]);
  const b = (T) => {
    f.current === null && (f.current = T.relatedTarget), v.current = !0, g.current = T.target;
    const E = t.props.onFocus;
    E && E(T);
  }, O = (T) => {
    f.current === null && (f.current = T.relatedTarget), v.current = !0;
  };
  return /* @__PURE__ */ w.jsxs(h.Fragment, {
    children: [/* @__PURE__ */ w.jsx("div", {
      tabIndex: l ? 0 : -1,
      onFocus: O,
      ref: u,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ h.cloneElement(t, {
      ref: d,
      onFocus: b
    }), /* @__PURE__ */ w.jsx("div", {
      tabIndex: l ? 0 : -1,
      onFocus: O,
      ref: p,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (mo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: Br,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: i.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: i.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: i.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: i.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: i.func,
  /**
   * If `true`, focus is locked.
   */
  open: i.bool.isRequired
});
process.env.NODE_ENV !== "production" && (mo.propTypes = Bo(mo.propTypes));
function xh(e) {
  return typeof e == "function" ? e() : e;
}
const bn = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const {
    children: n,
    container: o,
    disablePortal: a = !1
  } = t, [s, l] = h.useState(null), c = tt(/* @__PURE__ */ h.isValidElement(n) ? Pn(n) : null, r);
  if (ir(() => {
    a || l(xh(o) || document.body);
  }, [o, a]), ir(() => {
    if (s && !a)
      return _s(r, s), () => {
        _s(r, null);
      };
  }, [r, s, a]), a) {
    if (/* @__PURE__ */ h.isValidElement(n)) {
      const u = {
        ref: c
      };
      return /* @__PURE__ */ h.cloneElement(n, u);
    }
    return n;
  }
  return s && /* @__PURE__ */ ju.createPortal(n, s);
});
process.env.NODE_ENV !== "production" && (bn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: i.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: i.oneOfType([Jt, i.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: i.bool
});
process.env.NODE_ENV !== "production" && (bn.propTypes = Bo(bn.propTypes));
const Eh = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, wc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = Fo(), o = {
    enter: n.transitions.duration.enteringScreen,
    exit: n.transitions.duration.leavingScreen
  }, {
    addEndListener: a,
    appear: s = !0,
    children: l,
    easing: c,
    in: u,
    onEnter: p,
    onEntered: f,
    onEntering: g,
    onExit: v,
    onExited: y,
    onExiting: d,
    style: x,
    timeout: b = o,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: O = Wt,
    ...T
  } = t, E = h.useRef(null), C = tt(E, Pn(l), r), $ = (V) => (D) => {
    if (V) {
      const M = E.current;
      D === void 0 ? V(M) : V(M, D);
    }
  }, P = $(g), k = $((V, D) => {
    Sc(V);
    const M = fo({
      style: x,
      timeout: b,
      easing: c
    }, {
      mode: "enter"
    });
    V.style.webkitTransition = n.transitions.create("opacity", M), V.style.transition = n.transitions.create("opacity", M), p && p(V, D);
  }), I = $(f), m = $(d), R = $((V) => {
    const D = fo({
      style: x,
      timeout: b,
      easing: c
    }, {
      mode: "exit"
    });
    V.style.webkitTransition = n.transitions.create("opacity", D), V.style.transition = n.transitions.create("opacity", D), v && v(V);
  }), _ = $(y), j = (V) => {
    a && a(E.current, V);
  };
  return /* @__PURE__ */ w.jsx(O, {
    appear: s,
    in: u,
    nodeRef: E,
    onEnter: k,
    onEntered: I,
    onEntering: P,
    onExit: R,
    onExited: _,
    onExiting: m,
    addEndListener: j,
    timeout: b,
    ...T,
    children: (V, {
      ownerState: D,
      ...M
    }) => /* @__PURE__ */ h.cloneElement(l, {
      style: {
        opacity: 0,
        visibility: V === "exited" && !u ? "hidden" : void 0,
        ...Eh[V],
        ...x,
        ...l.props.style
      },
      ref: C,
      ...M
    })
  });
});
process.env.NODE_ENV !== "production" && (wc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: i.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: i.bool,
  /**
   * A single child content element.
   */
  children: Br.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: i.oneOfType([i.shape({
    enter: i.string,
    exit: i.string
  }), i.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: i.bool,
  /**
   * @ignore
   */
  onEnter: i.func,
  /**
   * @ignore
   */
  onEntered: i.func,
  /**
   * @ignore
   */
  onEntering: i.func,
  /**
   * @ignore
   */
  onExit: i.func,
  /**
   * @ignore
   */
  onExited: i.func,
  /**
   * @ignore
   */
  onExiting: i.func,
  /**
   * @ignore
   */
  style: i.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: i.oneOfType([i.number, i.shape({
    appear: i.number,
    enter: i.number,
    exit: i.number
  })])
});
function Ch(e) {
  return he("MuiBackdrop", e);
}
ge("MuiBackdrop", ["root", "invisible"]);
const Th = (e) => {
  const {
    classes: t,
    invisible: r
  } = e;
  return Te({
    root: ["root", r && "invisible"]
  }, Ch, t);
}, Sh = ee("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.invisible && t.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), Oc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: o,
    className: a,
    component: s = "div",
    invisible: l = !1,
    open: c,
    components: u = {},
    componentsProps: p = {},
    slotProps: f = {},
    slots: g = {},
    TransitionComponent: v,
    transitionDuration: y,
    ...d
  } = n, x = {
    ...n,
    component: s,
    invisible: l
  }, b = Th(x), O = {
    transition: v,
    root: u.Root,
    ...g
  }, T = {
    ...p,
    ...f
  }, E = {
    slots: O,
    slotProps: T
  }, [C, $] = Be("root", {
    elementType: Sh,
    externalForwardedProps: E,
    className: oe(b.root, a),
    ownerState: x
  }), [P, k] = Be("transition", {
    elementType: wc,
    externalForwardedProps: E,
    ownerState: x
  });
  return /* @__PURE__ */ w.jsx(P, {
    in: c,
    timeout: y,
    ...d,
    ...k,
    children: /* @__PURE__ */ w.jsx(C, {
      "aria-hidden": !0,
      ...$,
      classes: b,
      ref: r,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (Oc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: i.shape({
    Root: i.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: i.shape({
    root: i.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: i.bool,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    root: i.oneOfType([i.func, i.object]),
    transition: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    root: i.elementType,
    transition: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: i.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: i.oneOfType([i.number, i.shape({
    appear: i.number,
    enter: i.number,
    exit: i.number
  })])
});
function wh(e) {
  return typeof e == "function" ? e() : e;
}
function Oh(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const Us = () => {
}, Wn = new fh();
function Rh(e) {
  const {
    container: t,
    disableEscapeKeyDown: r = !1,
    disableScrollLock: n = !1,
    closeAfterTransition: o = !1,
    onTransitionEnter: a,
    onTransitionExited: s,
    children: l,
    onClose: c,
    open: u,
    rootRef: p
  } = e, f = h.useRef({}), g = h.useRef(null), v = h.useRef(null), y = tt(v, p), [d, x] = h.useState(!u), b = Oh(l);
  let O = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (O = !1);
  const T = () => xt(g.current), E = () => (f.current.modalRef = v.current, f.current.mount = g.current, f.current), C = () => {
    Wn.mount(E(), {
      disableScrollLock: n
    }), v.current && (v.current.scrollTop = 0);
  }, $ = rr(() => {
    const D = wh(t) || T().body;
    Wn.add(E(), D), v.current && C();
  }), P = () => Wn.isTopModal(E()), k = rr((D) => {
    g.current = D, D && (u && P() ? C() : v.current && ln(v.current, O));
  }), I = h.useCallback(() => {
    Wn.remove(E(), O);
  }, [O]);
  h.useEffect(() => () => {
    I();
  }, [I]), h.useEffect(() => {
    u ? $() : (!b || !o) && I();
  }, [u, I, b, o, $]);
  const m = (D) => (M) => {
    var U;
    (U = D.onKeyDown) == null || U.call(D, M), !(M.key !== "Escape" || M.which === 229 || // Wait until IME is settled.
    !P()) && (r || (M.stopPropagation(), c && c(M, "escapeKeyDown")));
  }, R = (D) => (M) => {
    var U;
    (U = D.onClick) == null || U.call(D, M), M.target === M.currentTarget && c && c(M, "backdropClick");
  };
  return {
    getRootProps: (D = {}) => {
      const M = pc(e);
      delete M.onTransitionEnter, delete M.onTransitionExited;
      const U = {
        ...M,
        ...D
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...U,
        onKeyDown: m(U),
        ref: y
      };
    },
    getBackdropProps: (D = {}) => {
      const M = D;
      return {
        "aria-hidden": !0,
        ...M,
        onClick: R(M),
        open: u
      };
    },
    getTransitionProps: () => {
      const D = () => {
        x(!1), a && a();
      }, M = () => {
        x(!0), s && s(), o && I();
      };
      return {
        onEnter: js(D, (l == null ? void 0 : l.props.onEnter) ?? Us),
        onExited: js(M, (l == null ? void 0 : l.props.onExited) ?? Us)
      };
    },
    rootRef: y,
    portalRef: k,
    isTopModal: P,
    exited: d,
    hasTransition: b
  };
}
function Ph(e) {
  return he("MuiModal", e);
}
ge("MuiModal", ["root", "hidden", "backdrop"]);
const $h = (e) => {
  const {
    open: t,
    exited: r,
    classes: n
  } = e;
  return Te({
    root: ["root", !t && r && "hidden"],
    backdrop: ["backdrop"]
  }, Ph, n);
}, kh = ee("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.open && r.exited && t.hidden];
  }
})(_e(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open && t.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), Ih = ee(Oc, {
  name: "MuiModal",
  slot: "Backdrop"
})({
  zIndex: -1
}), Rc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: o = Ih,
    BackdropProps: a,
    classes: s,
    className: l,
    closeAfterTransition: c = !1,
    children: u,
    container: p,
    component: f,
    components: g = {},
    componentsProps: v = {},
    disableAutoFocus: y = !1,
    disableEnforceFocus: d = !1,
    disableEscapeKeyDown: x = !1,
    disablePortal: b = !1,
    disableRestoreFocus: O = !1,
    disableScrollLock: T = !1,
    hideBackdrop: E = !1,
    keepMounted: C = !1,
    onClose: $,
    onTransitionEnter: P,
    onTransitionExited: k,
    open: I,
    slotProps: m = {},
    slots: R = {},
    // eslint-disable-next-line react/prop-types
    theme: _,
    ...j
  } = n, V = {
    ...n,
    closeAfterTransition: c,
    disableAutoFocus: y,
    disableEnforceFocus: d,
    disableEscapeKeyDown: x,
    disablePortal: b,
    disableRestoreFocus: O,
    disableScrollLock: T,
    hideBackdrop: E,
    keepMounted: C
  }, {
    getRootProps: D,
    getBackdropProps: M,
    getTransitionProps: U,
    portalRef: te,
    isTopModal: Y,
    exited: N,
    hasTransition: B
  } = Rh({
    ...V,
    rootRef: r
  }), H = {
    ...V,
    exited: N
  }, q = $h(H), G = {};
  if (u.props.tabIndex === void 0 && (G.tabIndex = "-1"), B) {
    const {
      onEnter: W,
      onExited: ne
    } = U();
    G.onEnter = W, G.onExited = ne;
  }
  const Q = {
    slots: {
      root: g.Root,
      backdrop: g.Backdrop,
      ...R
    },
    slotProps: {
      ...v,
      ...m
    }
  }, [z, K] = Be("root", {
    ref: r,
    elementType: kh,
    externalForwardedProps: {
      ...Q,
      ...j,
      component: f
    },
    getSlotProps: D,
    ownerState: H,
    className: oe(l, q == null ? void 0 : q.root, !H.open && H.exited && (q == null ? void 0 : q.hidden))
  }), [X, ie] = Be("backdrop", {
    ref: a == null ? void 0 : a.ref,
    elementType: o,
    externalForwardedProps: Q,
    shouldForwardComponentProp: !0,
    additionalProps: a,
    getSlotProps: (W) => M({
      ...W,
      onClick: (ne) => {
        W != null && W.onClick && W.onClick(ne);
      }
    }),
    className: oe(a == null ? void 0 : a.className, q == null ? void 0 : q.backdrop),
    ownerState: H
  });
  return !C && !I && (!B || N) ? null : /* @__PURE__ */ w.jsx(bn, {
    ref: te,
    container: p,
    disablePortal: b,
    children: /* @__PURE__ */ w.jsxs(z, {
      ...K,
      children: [!E && o ? /* @__PURE__ */ w.jsx(X, {
        ...ie
      }) : null, /* @__PURE__ */ w.jsx(mo, {
        disableEnforceFocus: d,
        disableAutoFocus: y,
        disableRestoreFocus: O,
        isEnabled: Y,
        open: I,
        children: /* @__PURE__ */ h.cloneElement(u, G)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (Rc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: i.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: i.object,
  /**
   * A single child content element.
   */
  children: Br.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: i.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: i.shape({
    Backdrop: i.elementType,
    Root: i.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: i.shape({
    backdrop: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: i.oneOfType([Jt, i.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: i.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: i.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: i.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: i.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: i.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: i.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: i.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: i.bool,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: i.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: i.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: i.func,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: i.shape({
    backdrop: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: i.shape({
    backdrop: i.elementType,
    root: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function Nh(e) {
  return he("MuiPaper", e);
}
ge("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const Ah = (e) => {
  const {
    square: t,
    elevation: r,
    variant: n,
    classes: o
  } = e, a = {
    root: ["root", n, !t && "rounded", n === "elevation" && `elevation${r}`]
  };
  return Te(a, Nh, o);
}, Mh = ee("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], !r.square && t.rounded, r.variant === "elevation" && t[`elevation${r.elevation}`]];
  }
})(_e(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), Uo = /* @__PURE__ */ h.forwardRef(function(t, r) {
  var v;
  const n = ye({
    props: t,
    name: "MuiPaper"
  }), o = Fo(), {
    className: a,
    component: s = "div",
    elevation: l = 1,
    square: c = !1,
    variant: u = "elevation",
    ...p
  } = n, f = {
    ...n,
    component: s,
    elevation: l,
    square: c,
    variant: u
  }, g = Ah(f);
  return process.env.NODE_ENV !== "production" && o.shadows[l] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${l}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${l}]\` is defined.`].join(`
`)), /* @__PURE__ */ w.jsx(Mh, {
    as: s,
    ownerState: f,
    className: oe(g.root, a),
    ref: r,
    ...p,
    style: {
      ...u === "elevation" && {
        "--Paper-shadow": (o.vars || o).shadows[l],
        ...o.vars && {
          "--Paper-overlay": (v = o.vars.overlays) == null ? void 0 : v[l]
        },
        ...!o.vars && o.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${Ne("#fff", $i(l))}, ${Ne("#fff", $i(l))})`
        }
      },
      ...p.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Uo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: zt(sn, (e) => {
    const {
      elevation: t,
      variant: r
    } = e;
    return t > 0 && r === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${r}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: i.bool,
  /**
   * @ignore
   */
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: i.oneOfType([i.oneOf(["elevation", "outlined"]), i.string])
});
function jh(e) {
  return he("MuiPopover", e);
}
ge("MuiPopover", ["root", "paper"]);
function Hs(e, t) {
  let r = 0;
  return typeof t == "number" ? r = t : t === "center" ? r = e.height / 2 : t === "bottom" && (r = e.height), r;
}
function Ys(e, t) {
  let r = 0;
  return typeof t == "number" ? r = t : t === "center" ? r = e.width / 2 : t === "right" && (r = e.width), r;
}
function qs(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function on(e) {
  return typeof e == "function" ? e() : e;
}
const _h = (e) => {
  const {
    classes: t
  } = e;
  return Te({
    root: ["root"],
    paper: ["paper"]
  }, jh, t);
}, Dh = ee(Rc, {
  name: "MuiPopover",
  slot: "Root"
})({}), Pc = ee(Uo, {
  name: "MuiPopover",
  slot: "Paper"
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), $c = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiPopover"
  }), {
    action: o,
    anchorEl: a,
    anchorOrigin: s = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: l,
    anchorReference: c = "anchorEl",
    children: u,
    className: p,
    container: f,
    elevation: g = 8,
    marginThreshold: v = 16,
    open: y,
    PaperProps: d = {},
    // TODO: remove in v7
    slots: x = {},
    slotProps: b = {},
    transformOrigin: O = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: T,
    // TODO: remove in v7
    transitionDuration: E = "auto",
    TransitionProps: C = {},
    // TODO: remove in v7
    disableScrollLock: $ = !1,
    ...P
  } = n, k = h.useRef(), I = {
    ...n,
    anchorOrigin: s,
    anchorReference: c,
    elevation: g,
    marginThreshold: v,
    transformOrigin: O,
    TransitionComponent: T,
    transitionDuration: E,
    TransitionProps: C
  }, m = _h(I), R = h.useCallback(() => {
    if (c === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (l || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), l;
    const W = on(a), ne = W && W.nodeType === 1 ? W : xt(k.current).body, L = ne.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const de = ne.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && de.top === 0 && de.left === 0 && de.right === 0 && de.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: L.top + Hs(L, s.vertical),
      left: L.left + Ys(L, s.horizontal)
    };
  }, [a, s.horizontal, s.vertical, l, c]), _ = h.useCallback((W) => ({
    vertical: Hs(W, O.vertical),
    horizontal: Ys(W, O.horizontal)
  }), [O.horizontal, O.vertical]), j = h.useCallback((W) => {
    const ne = {
      width: W.offsetWidth,
      height: W.offsetHeight
    }, L = _(ne);
    if (c === "none")
      return {
        top: null,
        left: null,
        transformOrigin: qs(L)
      };
    const de = R();
    let Se = de.top - L.vertical, Ae = de.left - L.horizontal;
    const Je = Se + ne.height, Ue = Ae + ne.width, Fe = br(on(a)), ve = Fe.innerHeight - v, De = Fe.innerWidth - v;
    if (v !== null && Se < v) {
      const be = Se - v;
      Se -= be, L.vertical += be;
    } else if (v !== null && Je > ve) {
      const be = Je - ve;
      Se -= be, L.vertical += be;
    }
    if (process.env.NODE_ENV !== "production" && ne.height > ve && ne.height && ve && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${ne.height - ve}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), v !== null && Ae < v) {
      const be = Ae - v;
      Ae -= be, L.horizontal += be;
    } else if (Ue > De) {
      const be = Ue - De;
      Ae -= be, L.horizontal += be;
    }
    return {
      top: `${Math.round(Se)}px`,
      left: `${Math.round(Ae)}px`,
      transformOrigin: qs(L)
    };
  }, [a, c, R, _, v]), [V, D] = h.useState(y), M = h.useCallback(() => {
    const W = k.current;
    if (!W)
      return;
    const ne = j(W);
    ne.top !== null && W.style.setProperty("top", ne.top), ne.left !== null && (W.style.left = ne.left), W.style.transformOrigin = ne.transformOrigin, D(!0);
  }, [j]);
  h.useEffect(() => ($ && window.addEventListener("scroll", M), () => window.removeEventListener("scroll", M)), [a, $, M]);
  const U = () => {
    M();
  }, te = () => {
    D(!1);
  };
  h.useEffect(() => {
    y && M();
  }), h.useImperativeHandle(o, () => y ? {
    updatePosition: () => {
      M();
    }
  } : null, [y, M]), h.useEffect(() => {
    if (!y)
      return;
    const W = Vm(() => {
      M();
    }), ne = br(on(a));
    return ne.addEventListener("resize", W), () => {
      W.clear(), ne.removeEventListener("resize", W);
    };
  }, [a, y, M]);
  let Y = E;
  const N = {
    slots: {
      transition: T,
      ...x
    },
    slotProps: {
      transition: C,
      paper: d,
      ...b
    }
  }, [B, H] = Be("transition", {
    elementType: vn,
    externalForwardedProps: N,
    ownerState: I,
    getSlotProps: (W) => ({
      ...W,
      onEntering: (ne, L) => {
        var de;
        (de = W.onEntering) == null || de.call(W, ne, L), U();
      },
      onExited: (ne) => {
        var L;
        (L = W.onExited) == null || L.call(W, ne), te();
      }
    }),
    additionalProps: {
      appear: !0,
      in: y
    }
  });
  E === "auto" && !B.muiSupportAuto && (Y = void 0);
  const q = f || (a ? xt(on(a)).body : void 0), [G, {
    slots: Q,
    slotProps: z,
    ...K
  }] = Be("root", {
    ref: r,
    elementType: Dh,
    externalForwardedProps: {
      ...N,
      ...P
    },
    shouldForwardComponentProp: !0,
    additionalProps: {
      slots: {
        backdrop: x.backdrop
      },
      slotProps: {
        backdrop: qm(typeof b.backdrop == "function" ? b.backdrop(I) : b.backdrop, {
          invisible: !0
        })
      },
      container: q,
      open: y
    },
    ownerState: I,
    className: oe(m.root, p)
  }), [X, ie] = Be("paper", {
    ref: k,
    className: m.paper,
    elementType: Pc,
    externalForwardedProps: N,
    shouldForwardComponentProp: !0,
    additionalProps: {
      elevation: g,
      style: V ? void 0 : {
        opacity: 0
      }
    },
    ownerState: I
  });
  return /* @__PURE__ */ w.jsx(G, {
    ...K,
    ...!Ni(G) && {
      slots: Q,
      slotProps: z,
      disableScrollLock: $
    },
    children: /* @__PURE__ */ w.jsx(B, {
      ...H,
      timeout: Y,
      children: /* @__PURE__ */ w.jsx(X, {
        ...ie,
        children: u
      })
    })
  });
});
process.env.NODE_ENV !== "production" && ($c.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: zo,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: zt(i.oneOfType([Jt, i.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = on(e.anchorEl);
      if (t && t.nodeType === 1) {
        const r = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: i.shape({
    horizontal: i.oneOfType([i.oneOf(["center", "left", "right"]), i.number]).isRequired,
    vertical: i.oneOfType([i.oneOf(["bottom", "center", "top"]), i.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: i.shape({
    left: i.number.isRequired,
    top: i.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: i.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: i.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  BackdropProps: i.object,
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: i.oneOfType([Jt, i.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: i.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: sn,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: i.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: i.func,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: i.shape({
    component: Ea
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    backdrop: i.oneOfType([i.func, i.object]),
    paper: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object]),
    transition: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    backdrop: i.elementType,
    paper: i.elementType,
    root: i.elementType,
    transition: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: i.shape({
    horizontal: i.oneOfType([i.oneOf(["center", "left", "right"]), i.number]).isRequired,
    vertical: i.oneOfType([i.oneOf(["bottom", "center", "top"]), i.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: i.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: i.oneOfType([i.oneOf(["auto"]), i.number, i.shape({
    appear: i.number,
    enter: i.number,
    exit: i.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: i.object
});
function Lh(e) {
  return he("MuiMenu", e);
}
ge("MuiMenu", ["root", "paper", "list"]);
const Bh = {
  vertical: "top",
  horizontal: "right"
}, Fh = {
  vertical: "top",
  horizontal: "left"
}, Vh = (e) => {
  const {
    classes: t
  } = e;
  return Te({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, Lh, t);
}, zh = ee($c, {
  shouldForwardProp: (e) => Vo(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root"
})({}), Wh = ee(Pc, {
  name: "MuiMenu",
  slot: "Paper"
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), Uh = ee(yc, {
  name: "MuiMenu",
  slot: "List"
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), kc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: o = !0,
    children: a,
    className: s,
    disableAutoFocusItem: l = !1,
    MenuListProps: c = {},
    onClose: u,
    open: p,
    PaperProps: f = {},
    PopoverClasses: g,
    transitionDuration: v = "auto",
    TransitionProps: {
      onEntering: y,
      ...d
    } = {},
    variant: x = "selectedMenu",
    slots: b = {},
    slotProps: O = {},
    ...T
  } = n, E = da(), C = {
    ...n,
    autoFocus: o,
    disableAutoFocusItem: l,
    MenuListProps: c,
    onEntering: y,
    PaperProps: f,
    transitionDuration: v,
    TransitionProps: d,
    variant: x
  }, $ = Vh(C), P = o && !l && p, k = h.useRef(null), I = (Y, N) => {
    k.current && k.current.adjustStyleForScrollbar(Y, {
      direction: E ? "rtl" : "ltr"
    }), y && y(Y, N);
  }, m = (Y) => {
    Y.key === "Tab" && (Y.preventDefault(), u && u(Y, "tabKeyDown"));
  };
  let R = -1;
  h.Children.map(a, (Y, N) => {
    /* @__PURE__ */ h.isValidElement(Y) && (process.env.NODE_ENV !== "production" && ya.isFragment(Y) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), Y.props.disabled || (x === "selectedMenu" && Y.props.selected || R === -1) && (R = N));
  });
  const _ = {
    slots: b,
    slotProps: {
      list: c,
      transition: d,
      paper: f,
      ...O
    }
  }, j = va({
    elementType: b.root,
    externalSlotProps: O.root,
    ownerState: C,
    className: [$.root, s]
  }), [V, D] = Be("paper", {
    className: $.paper,
    elementType: Wh,
    externalForwardedProps: _,
    shouldForwardComponentProp: !0,
    ownerState: C
  }), [M, U] = Be("list", {
    className: oe($.list, c.className),
    elementType: Uh,
    shouldForwardComponentProp: !0,
    externalForwardedProps: _,
    getSlotProps: (Y) => ({
      ...Y,
      onKeyDown: (N) => {
        var B;
        m(N), (B = Y.onKeyDown) == null || B.call(Y, N);
      }
    }),
    ownerState: C
  }), te = typeof _.slotProps.transition == "function" ? _.slotProps.transition(C) : _.slotProps.transition;
  return /* @__PURE__ */ w.jsx(zh, {
    onClose: u,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: E ? "right" : "left"
    },
    transformOrigin: E ? Bh : Fh,
    slots: {
      root: b.root,
      paper: V,
      backdrop: b.backdrop,
      ...b.transition && {
        // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
        transition: b.transition
      }
    },
    slotProps: {
      root: j,
      paper: D,
      backdrop: typeof O.backdrop == "function" ? O.backdrop(C) : O.backdrop,
      transition: {
        ...te,
        onEntering: (...Y) => {
          var N;
          I(...Y), (N = te == null ? void 0 : te.onEntering) == null || N.call(te, ...Y);
        }
      }
    },
    open: p,
    ref: r,
    transitionDuration: v,
    ownerState: C,
    ...T,
    classes: g,
    children: /* @__PURE__ */ w.jsx(M, {
      actions: k,
      autoFocus: o && (R === -1 || l),
      autoFocusItem: P,
      variant: x,
      ...U,
      children: a
    })
  });
});
process.env.NODE_ENV !== "production" && (kc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: i.oneOfType([Jt, i.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: i.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: i.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  MenuListProps: i.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: i.func,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: i.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: i.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    backdrop: i.oneOfType([i.func, i.object]),
    list: i.oneOfType([i.func, i.object]),
    paper: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object]),
    transition: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    backdrop: i.elementType,
    list: i.elementType,
    paper: i.elementType,
    root: i.elementType,
    transition: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: i.oneOfType([i.oneOf(["auto"]), i.number, i.shape({
    appear: i.number,
    enter: i.number,
    exit: i.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: i.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: i.oneOf(["menu", "selectedMenu"])
});
function ho(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
class go {
  constructor() {
    Hr(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new go();
  }
  static use() {
    const t = xc(go.create).current, [r, n] = h.useState(!1);
    return t.shouldMount = r, t.setShouldMount = n, h.useEffect(t.mountEffect, [r]), t;
  }
  mount() {
    return this.mounted || (this.mounted = Yh(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var r;
      return (r = this.ref.current) == null ? void 0 : r.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var r;
      return (r = this.ref.current) == null ? void 0 : r.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var r;
      return (r = this.ref.current) == null ? void 0 : r.pulsate(...t);
    });
  }
}
function Hh() {
  return go.use();
}
function Yh() {
  let e, t;
  const r = new Promise((n, o) => {
    e = n, t = o;
  });
  return r.resolve = e, r.reject = t, r;
}
function Ic(e) {
  const {
    className: t,
    classes: r,
    pulsate: n = !1,
    rippleX: o,
    rippleY: a,
    rippleSize: s,
    in: l,
    onExited: c,
    timeout: u
  } = e, [p, f] = h.useState(!1), g = oe(t, r.ripple, r.rippleVisible, n && r.ripplePulsate), v = {
    width: s,
    height: s,
    top: -(s / 2) + a,
    left: -(s / 2) + o
  }, y = oe(r.child, p && r.childLeaving, n && r.childPulsate);
  return !l && !p && f(!0), h.useEffect(() => {
    if (!l && c != null) {
      const d = setTimeout(c, u);
      return () => {
        clearTimeout(d);
      };
    }
  }, [c, l, u]), /* @__PURE__ */ w.jsx("span", {
    className: g,
    style: v,
    children: /* @__PURE__ */ w.jsx("span", {
      className: y
    })
  });
}
process.env.NODE_ENV !== "production" && (Ic.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object.isRequired,
  className: i.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: i.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: i.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: i.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: i.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: i.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: i.number,
  /**
   * exit delay
   */
  timeout: i.number.isRequired
});
const yt = ge("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), _i = 550, qh = 80, Kh = wn`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, Gh = wn`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, Xh = wn`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, Jh = ee("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), Zh = ee(Ic, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${yt.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${Kh};
    animation-duration: ${_i}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${yt.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${yt.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${yt.childLeaving} {
    opacity: 0;
    animation-name: ${Gh};
    animation-duration: ${_i}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${yt.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${Xh};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, Nc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: a = {},
    className: s,
    ...l
  } = n, [c, u] = h.useState([]), p = h.useRef(0), f = h.useRef(null);
  h.useEffect(() => {
    f.current && (f.current(), f.current = null);
  }, [c]);
  const g = h.useRef(!1), v = $r(), y = h.useRef(null), d = h.useRef(null), x = h.useCallback((E) => {
    const {
      pulsate: C,
      rippleX: $,
      rippleY: P,
      rippleSize: k,
      cb: I
    } = E;
    u((m) => [...m, /* @__PURE__ */ w.jsx(Zh, {
      classes: {
        ripple: oe(a.ripple, yt.ripple),
        rippleVisible: oe(a.rippleVisible, yt.rippleVisible),
        ripplePulsate: oe(a.ripplePulsate, yt.ripplePulsate),
        child: oe(a.child, yt.child),
        childLeaving: oe(a.childLeaving, yt.childLeaving),
        childPulsate: oe(a.childPulsate, yt.childPulsate)
      },
      timeout: _i,
      pulsate: C,
      rippleX: $,
      rippleY: P,
      rippleSize: k
    }, p.current)]), p.current += 1, f.current = I;
  }, [a]), b = h.useCallback((E = {}, C = {}, $ = () => {
  }) => {
    const {
      pulsate: P = !1,
      center: k = o || C.pulsate,
      fakeElement: I = !1
      // For test purposes
    } = C;
    if ((E == null ? void 0 : E.type) === "mousedown" && g.current) {
      g.current = !1;
      return;
    }
    (E == null ? void 0 : E.type) === "touchstart" && (g.current = !0);
    const m = I ? null : d.current, R = m ? m.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let _, j, V;
    if (k || E === void 0 || E.clientX === 0 && E.clientY === 0 || !E.clientX && !E.touches)
      _ = Math.round(R.width / 2), j = Math.round(R.height / 2);
    else {
      const {
        clientX: D,
        clientY: M
      } = E.touches && E.touches.length > 0 ? E.touches[0] : E;
      _ = Math.round(D - R.left), j = Math.round(M - R.top);
    }
    if (k)
      V = Math.sqrt((2 * R.width ** 2 + R.height ** 2) / 3), V % 2 === 0 && (V += 1);
    else {
      const D = Math.max(Math.abs((m ? m.clientWidth : 0) - _), _) * 2 + 2, M = Math.max(Math.abs((m ? m.clientHeight : 0) - j), j) * 2 + 2;
      V = Math.sqrt(D ** 2 + M ** 2);
    }
    E != null && E.touches ? y.current === null && (y.current = () => {
      x({
        pulsate: P,
        rippleX: _,
        rippleY: j,
        rippleSize: V,
        cb: $
      });
    }, v.start(qh, () => {
      y.current && (y.current(), y.current = null);
    })) : x({
      pulsate: P,
      rippleX: _,
      rippleY: j,
      rippleSize: V,
      cb: $
    });
  }, [o, x, v]), O = h.useCallback(() => {
    b({}, {
      pulsate: !0
    });
  }, [b]), T = h.useCallback((E, C) => {
    if (v.clear(), (E == null ? void 0 : E.type) === "touchend" && y.current) {
      y.current(), y.current = null, v.start(0, () => {
        T(E, C);
      });
      return;
    }
    y.current = null, u(($) => $.length > 0 ? $.slice(1) : $), f.current = C;
  }, [v]);
  return h.useImperativeHandle(r, () => ({
    pulsate: O,
    start: b,
    stop: T
  }), [O, b, T]), /* @__PURE__ */ w.jsx(Jh, {
    className: oe(yt.root, a.root, s),
    ref: d,
    ...l,
    children: /* @__PURE__ */ w.jsx(Ta, {
      component: null,
      exit: !0,
      children: c
    })
  });
});
process.env.NODE_ENV !== "production" && (Nc.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: i.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string
});
function Qh(e) {
  return he("MuiButtonBase", e);
}
const eg = ge("MuiButtonBase", ["root", "disabled", "focusVisible"]), tg = (e) => {
  const {
    disabled: t,
    focusVisible: r,
    focusVisibleClassName: n,
    classes: o
  } = e, s = Te({
    root: ["root", t && "disabled", r && "focusVisible"]
  }, Qh, o);
  return r && n && (s.root += ` ${n}`), s;
}, rg = ee("button", {
  name: "MuiButtonBase",
  slot: "Root"
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${eg.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), sr = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: a = !1,
    children: s,
    className: l,
    component: c = "button",
    disabled: u = !1,
    disableRipple: p = !1,
    disableTouchRipple: f = !1,
    focusRipple: g = !1,
    focusVisibleClassName: v,
    LinkComponent: y = "a",
    onBlur: d,
    onClick: x,
    onContextMenu: b,
    onDragLeave: O,
    onFocus: T,
    onFocusVisible: E,
    onKeyDown: C,
    onKeyUp: $,
    onMouseDown: P,
    onMouseLeave: k,
    onMouseUp: I,
    onTouchEnd: m,
    onTouchMove: R,
    onTouchStart: _,
    tabIndex: j = 0,
    TouchRippleProps: V,
    touchRippleRef: D,
    type: M,
    ...U
  } = n, te = h.useRef(null), Y = Hh(), N = tt(Y.ref, D), [B, H] = h.useState(!1);
  u && B && H(!1), h.useImperativeHandle(o, () => ({
    focusVisible: () => {
      H(!0), te.current.focus();
    }
  }), []);
  const q = Y.shouldMount && !p && !u;
  h.useEffect(() => {
    B && g && !p && Y.pulsate();
  }, [p, g, B, Y]);
  const G = Gt(Y, "start", P, f), Q = Gt(Y, "stop", b, f), z = Gt(Y, "stop", O, f), K = Gt(Y, "stop", I, f), X = Gt(Y, "stop", (re) => {
    B && re.preventDefault(), k && k(re);
  }, f), ie = Gt(Y, "start", _, f), W = Gt(Y, "stop", m, f), ne = Gt(Y, "stop", R, f), L = Gt(Y, "stop", (re) => {
    ho(re.target) || H(!1), d && d(re);
  }, !1), de = rr((re) => {
    te.current || (te.current = re.currentTarget), ho(re.target) && (H(!0), E && E(re)), T && T(re);
  }), Se = () => {
    const re = te.current;
    return c && c !== "button" && !(re.tagName === "A" && re.href);
  }, Ae = rr((re) => {
    g && !re.repeat && B && re.key === " " && Y.stop(re, () => {
      Y.start(re);
    }), re.target === re.currentTarget && Se() && re.key === " " && re.preventDefault(), C && C(re), re.target === re.currentTarget && Se() && re.key === "Enter" && !u && (re.preventDefault(), x && x(re));
  }), Je = rr((re) => {
    g && re.key === " " && B && !re.defaultPrevented && Y.stop(re, () => {
      Y.pulsate(re);
    }), $ && $(re), x && re.target === re.currentTarget && Se() && re.key === " " && !re.defaultPrevented && x(re);
  });
  let Ue = c;
  Ue === "button" && (U.href || U.to) && (Ue = y);
  const Fe = {};
  Ue === "button" ? (Fe.type = M === void 0 ? "button" : M, Fe.disabled = u) : (!U.href && !U.to && (Fe.role = "button"), u && (Fe["aria-disabled"] = u));
  const ve = tt(r, te), De = {
    ...n,
    centerRipple: a,
    component: c,
    disabled: u,
    disableRipple: p,
    disableTouchRipple: f,
    focusRipple: g,
    tabIndex: j,
    focusVisible: B
  }, be = tg(De);
  return /* @__PURE__ */ w.jsxs(rg, {
    as: Ue,
    className: oe(be.root, l),
    ownerState: De,
    onBlur: L,
    onClick: x,
    onContextMenu: Q,
    onFocus: de,
    onKeyDown: Ae,
    onKeyUp: Je,
    onMouseDown: G,
    onMouseLeave: X,
    onMouseUp: K,
    onDragLeave: z,
    onTouchEnd: W,
    onTouchMove: ne,
    onTouchStart: ie,
    ref: ve,
    tabIndex: u ? -1 : j,
    type: M,
    ...Fe,
    ...U,
    children: [s, q ? /* @__PURE__ */ w.jsx(Nc, {
      ref: N,
      center: a,
      ...V
    }) : null]
  });
});
function Gt(e, t, r, n = !1) {
  return rr((o) => (r && r(o), n || e[t](o), !0));
}
process.env.NODE_ENV !== "production" && (sr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: zo,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: i.bool,
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Ea,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: i.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: i.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: i.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: i.string,
  /**
   * @ignore
   */
  href: i.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: i.elementType,
  /**
   * @ignore
   */
  onBlur: i.func,
  /**
   * @ignore
   */
  onClick: i.func,
  /**
   * @ignore
   */
  onContextMenu: i.func,
  /**
   * @ignore
   */
  onDragLeave: i.func,
  /**
   * @ignore
   */
  onFocus: i.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: i.func,
  /**
   * @ignore
   */
  onKeyDown: i.func,
  /**
   * @ignore
   */
  onKeyUp: i.func,
  /**
   * @ignore
   */
  onMouseDown: i.func,
  /**
   * @ignore
   */
  onMouseLeave: i.func,
  /**
   * @ignore
   */
  onMouseUp: i.func,
  /**
   * @ignore
   */
  onTouchEnd: i.func,
  /**
   * @ignore
   */
  onTouchMove: i.func,
  /**
   * @ignore
   */
  onTouchStart: i.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * @default 0
   */
  tabIndex: i.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: i.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: i.oneOfType([i.func, i.shape({
    current: i.shape({
      pulsate: i.func.isRequired,
      start: i.func.isRequired,
      stop: i.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: i.oneOfType([i.oneOf(["button", "reset", "submit"]), i.string])
});
function ng(e) {
  return he("MuiDivider", e);
}
const Ks = ge("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), og = (e) => {
  const {
    absolute: t,
    children: r,
    classes: n,
    flexItem: o,
    light: a,
    orientation: s,
    textAlign: l,
    variant: c
  } = e;
  return Te({
    root: ["root", t && "absolute", c, a && "light", s === "vertical" && "vertical", o && "flexItem", r && "withChildren", r && s === "vertical" && "withChildrenVertical", l === "right" && s !== "vertical" && "textAlignRight", l === "left" && s !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", s === "vertical" && "wrapperVertical"]
  }, ng, n);
}, ig = ee("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.absolute && t.absolute, t[r.variant], r.light && t.light, r.orientation === "vertical" && t.vertical, r.flexItem && t.flexItem, r.children && t.withChildren, r.children && r.orientation === "vertical" && t.withChildrenVertical, r.textAlign === "right" && r.orientation !== "vertical" && t.textAlignRight, r.textAlign === "left" && r.orientation !== "vertical" && t.textAlignLeft];
  }
})(_e(({
  theme: e
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : Ne(e.palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: e.spacing(2),
      marginRight: e.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: e.spacing(1),
      marginBottom: e.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.children && t.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(e.vars || e).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.orientation === "vertical" && t.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "right" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "left" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), ag = ee("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.wrapper, r.orientation === "vertical" && t.wrapperVertical];
  }
})(_e(({
  theme: e
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${e.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${e.spacing(1)} * 1.2)`
    }
  }]
}))), yo = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: o = !1,
    children: a,
    className: s,
    orientation: l = "horizontal",
    component: c = a || l === "vertical" ? "div" : "hr",
    flexItem: u = !1,
    light: p = !1,
    role: f = c !== "hr" ? "separator" : void 0,
    textAlign: g = "center",
    variant: v = "fullWidth",
    ...y
  } = n, d = {
    ...n,
    absolute: o,
    component: c,
    flexItem: u,
    light: p,
    orientation: l,
    role: f,
    textAlign: g,
    variant: v
  }, x = og(d);
  return /* @__PURE__ */ w.jsx(ig, {
    as: c,
    className: oe(x.root, s),
    role: f,
    ref: r,
    ownerState: d,
    "aria-orientation": f === "separator" && (c !== "hr" || l === "vertical") ? l : void 0,
    ...y,
    children: a ? /* @__PURE__ */ w.jsx(ag, {
      className: x.wrapper,
      ownerState: d,
      children: a
    }) : null
  });
});
yo && (yo.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (yo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: i.bool,
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: i.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: i.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: i.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: i.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: i.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: i.oneOfType([i.oneOf(["fullWidth", "inset", "middle"]), i.string])
});
function sg(e) {
  return he("MuiListItemIcon", e);
}
const Gs = ge("MuiListItemIcon", ["root", "alignItemsFlexStart"]), lg = (e) => {
  const {
    alignItems: t,
    classes: r
  } = e;
  return Te({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, sg, r);
}, cg = ee("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(_e(({
  theme: e
}) => ({
  minWidth: 56,
  color: (e.vars || e).palette.action.active,
  flexShrink: 0,
  display: "inline-flex",
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
}))), vo = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiListItemIcon"
  }), {
    className: o,
    ...a
  } = n, s = h.useContext(Lt), l = {
    ...n,
    alignItems: s.alignItems
  }, c = lg(l);
  return /* @__PURE__ */ w.jsx(cg, {
    className: oe(c.root, o),
    ownerState: l,
    ref: r,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (vo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function ug(e) {
  return typeof e.main == "string";
}
function dg(e, t = []) {
  if (!ug(e))
    return !1;
  for (const r of t)
    if (!e.hasOwnProperty(r) || typeof e[r] != "string")
      return !1;
  return !0;
}
function Mt(e = []) {
  return ([, t]) => t && dg(t, e);
}
function pg(e) {
  return he("MuiTypography", e);
}
const Xs = ge("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), fg = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, mg = Sm(), hg = (e) => {
  const {
    align: t,
    gutterBottom: r,
    noWrap: n,
    paragraph: o,
    variant: a,
    classes: s
  } = e, l = {
    root: ["root", a, e.align !== "inherit" && `align${Z(t)}`, r && "gutterBottom", n && "noWrap", o && "paragraph"]
  };
  return Te(l, pg, s);
}, gg = ee("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.variant && t[r.variant], r.align !== "inherit" && t[`align${Z(r.align)}`], r.noWrap && t.noWrap, r.gutterBottom && t.gutterBottom, r.paragraph && t.paragraph];
  }
})(_e(({
  theme: e
}) => {
  var t;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(e.typography).filter(([r, n]) => r !== "inherit" && n && typeof n == "object").map(([r, n]) => ({
      props: {
        variant: r
      },
      style: n
    })), ...Object.entries(e.palette).filter(Mt()).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        color: (e.vars || e).palette[r].main
      }
    })), ...Object.entries(((t = e.palette) == null ? void 0 : t.text) || {}).filter(([, r]) => typeof r == "string").map(([r]) => ({
      props: {
        color: `text${Z(r)}`
      },
      style: {
        color: (e.vars || e).palette.text[r]
      }
    })), {
      props: ({
        ownerState: r
      }) => r.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: r
      }) => r.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: r
      }) => r.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: r
      }) => r.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), Js = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, jt = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const {
    color: n,
    ...o
  } = ye({
    props: t,
    name: "MuiTypography"
  }), a = !fg[n], s = mg({
    ...o,
    ...a && {
      color: n
    }
  }), {
    align: l = "inherit",
    className: c,
    component: u,
    gutterBottom: p = !1,
    noWrap: f = !1,
    paragraph: g = !1,
    variant: v = "body1",
    variantMapping: y = Js,
    ...d
  } = s, x = {
    ...s,
    align: l,
    color: n,
    className: c,
    component: u,
    gutterBottom: p,
    noWrap: f,
    paragraph: g,
    variant: v,
    variantMapping: y
  }, b = u || (g ? "p" : y[v] || Js[v]) || "span", O = hg(x);
  return /* @__PURE__ */ w.jsx(gg, {
    as: b,
    ref: r,
    className: oe(O.root, c),
    ...d,
    ownerState: x,
    style: {
      ...l !== "inherit" && {
        "--Typography-textAlign": l
      },
      ...d.style
    }
  });
});
process.env.NODE_ENV !== "production" && (jt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: i.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: i.oneOfType([i.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), i.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: i.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: i.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: i.bool,
  /**
   * @ignore
   */
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: i.oneOfType([i.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), i.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: i.object
});
function yg(e) {
  return he("MuiListItemText", e);
}
const kr = ge("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), vg = (e) => {
  const {
    classes: t,
    inset: r,
    primary: n,
    secondary: o,
    dense: a
  } = e;
  return Te({
    root: ["root", r && "inset", a && "dense", n && o && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, yg, t);
}, bg = ee("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${kr.primary}`]: t.primary
    }, {
      [`& .${kr.secondary}`]: t.secondary
    }, t.root, r.inset && t.inset, r.primary && r.secondary && t.multiline, r.dense && t.dense];
  }
})({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4,
  [`.${Xs.root}:where(& .${kr.primary})`]: {
    display: "block"
  },
  [`.${Xs.root}:where(& .${kr.secondary})`]: {
    display: "block"
  },
  variants: [{
    props: ({
      ownerState: e
    }) => e.primary && e.secondary,
    style: {
      marginTop: 6,
      marginBottom: 6
    }
  }, {
    props: ({
      ownerState: e
    }) => e.inset,
    style: {
      paddingLeft: 56
    }
  }]
}), Ac = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiListItemText"
  }), {
    children: o,
    className: a,
    disableTypography: s = !1,
    inset: l = !1,
    primary: c,
    primaryTypographyProps: u,
    secondary: p,
    secondaryTypographyProps: f,
    slots: g = {},
    slotProps: v = {},
    ...y
  } = n, {
    dense: d
  } = h.useContext(Lt);
  let x = c ?? o, b = p;
  const O = {
    ...n,
    disableTypography: s,
    inset: l,
    primary: !!x,
    secondary: !!b,
    dense: d
  }, T = vg(O), E = {
    slots: g,
    slotProps: {
      primary: u,
      secondary: f,
      ...v
    }
  }, [C, $] = Be("root", {
    className: oe(T.root, a),
    elementType: bg,
    externalForwardedProps: {
      ...E,
      ...y
    },
    ownerState: O,
    ref: r
  }), [P, k] = Be("primary", {
    className: T.primary,
    elementType: jt,
    externalForwardedProps: E,
    ownerState: O
  }), [I, m] = Be("secondary", {
    className: T.secondary,
    elementType: jt,
    externalForwardedProps: E,
    ownerState: O
  });
  return x != null && x.type !== jt && !s && (x = /* @__PURE__ */ w.jsx(P, {
    variant: d ? "body2" : "body1",
    component: k != null && k.variant ? void 0 : "span",
    ...k,
    children: x
  })), b != null && b.type !== jt && !s && (b = /* @__PURE__ */ w.jsx(I, {
    variant: "body2",
    color: "textSecondary",
    ...m,
    children: b
  })), /* @__PURE__ */ w.jsxs(C, {
    ...$,
    children: [x, b]
  });
});
process.env.NODE_ENV !== "production" && (Ac.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: i.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: i.bool,
  /**
   * The main content element.
   */
  primary: i.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.primary` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  primaryTypographyProps: i.object,
  /**
   * The secondary content element.
   */
  secondary: i.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.secondary` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  secondaryTypographyProps: i.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    primary: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object]),
    secondary: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    primary: i.elementType,
    root: i.elementType,
    secondary: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function xg(e) {
  return he("MuiMenuItem", e);
}
const Jr = ge("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), Eg = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, r.dense && t.dense, r.divider && t.divider, !r.disableGutters && t.gutters];
}, Cg = (e) => {
  const {
    disabled: t,
    dense: r,
    divider: n,
    disableGutters: o,
    selected: a,
    classes: s
  } = e, c = Te({
    root: ["root", r && "dense", t && "disabled", !o && "gutters", n && "divider", a && "selected"]
  }, xg, s);
  return {
    ...s,
    ...c
  };
}, Tg = ee(sr, {
  shouldForwardProp: (e) => Vo(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: Eg
})(_e(({
  theme: e
}) => ({
  ...e.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Jr.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Ne(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Jr.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Ne(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Jr.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Ne(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Ne(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Jr.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Jr.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${Ks.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${Ks.inset}`]: {
    marginLeft: 52
  },
  [`& .${kr.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${kr.inset}`]: {
    paddingLeft: 36
  },
  [`& .${Gs.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dense,
    style: {
      [e.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...e.typography.body2,
      [`& .${Gs.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), Di = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: o = !1,
    component: a = "li",
    dense: s = !1,
    divider: l = !1,
    disableGutters: c = !1,
    focusVisibleClassName: u,
    role: p = "menuitem",
    tabIndex: f,
    className: g,
    ...v
  } = n, y = h.useContext(Lt), d = h.useMemo(() => ({
    dense: s || y.dense || !1,
    disableGutters: c
  }), [y.dense, s, c]), x = h.useRef(null);
  ir(() => {
    o && (x.current ? x.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [o]);
  const b = {
    ...n,
    dense: d.dense,
    divider: l,
    disableGutters: c
  }, O = Cg(n), T = tt(x, r);
  let E;
  return n.disabled || (E = f !== void 0 ? f : -1), /* @__PURE__ */ w.jsx(Lt.Provider, {
    value: d,
    children: /* @__PURE__ */ w.jsx(Tg, {
      ref: T,
      role: p,
      tabIndex: E,
      component: a,
      focusVisibleClassName: oe(O.focusVisible, u),
      className: oe(O.root, g),
      ...v,
      ownerState: b,
      classes: O
    })
  });
});
process.env.NODE_ENV !== "production" && (Di.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: i.bool,
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: i.bool,
  /**
   * @ignore
   */
  disabled: i.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: i.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: i.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: i.string,
  /**
   * @ignore
   */
  role: i.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * @default 0
   */
  tabIndex: i.number
});
function Sg(e) {
  return he("MuiCircularProgress", e);
}
ge("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const tr = 44, Li = wn`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, Bi = wn`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, wg = typeof Li != "string" ? ta`
        animation: ${Li} 1.4s linear infinite;
      ` : null, Og = typeof Bi != "string" ? ta`
        animation: ${Bi} 1.4s ease-in-out infinite;
      ` : null, Rg = (e) => {
  const {
    classes: t,
    variant: r,
    color: n,
    disableShrink: o
  } = e, a = {
    root: ["root", r, `color${Z(n)}`],
    svg: ["svg"],
    circle: ["circle", `circle${Z(r)}`, o && "circleDisableShrink"]
  };
  return Te(a, Sg, t);
}, Pg = ee("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], t[`color${Z(r.color)}`]];
  }
})(_e(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: wg || {
      animation: `${Li} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(Mt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), $g = ee("svg", {
  name: "MuiCircularProgress",
  slot: "Svg"
})({
  display: "block"
  // Keeps the progress centered
}), kg = ee("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.circle, t[`circle${Z(r.variant)}`], r.disableShrink && t.circleDisableShrink];
  }
})(_e(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: Og || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${Bi} 1.4s ease-in-out infinite`
    }
  }]
}))), Ho = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: o,
    color: a = "primary",
    disableShrink: s = !1,
    size: l = 40,
    style: c,
    thickness: u = 3.6,
    value: p = 0,
    variant: f = "indeterminate",
    ...g
  } = n, v = {
    ...n,
    color: a,
    disableShrink: s,
    size: l,
    thickness: u,
    value: p,
    variant: f
  }, y = Rg(v), d = {}, x = {}, b = {};
  if (f === "determinate") {
    const O = 2 * Math.PI * ((tr - u) / 2);
    d.strokeDasharray = O.toFixed(3), b["aria-valuenow"] = Math.round(p), d.strokeDashoffset = `${((100 - p) / 100 * O).toFixed(3)}px`, x.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ w.jsx(Pg, {
    className: oe(y.root, o),
    style: {
      width: l,
      height: l,
      ...x,
      ...c
    },
    ownerState: v,
    ref: r,
    role: "progressbar",
    ...b,
    ...g,
    children: /* @__PURE__ */ w.jsx($g, {
      className: y.svg,
      ownerState: v,
      viewBox: `${tr / 2} ${tr / 2} ${tr} ${tr}`,
      children: /* @__PURE__ */ w.jsx(kg, {
        className: y.circle,
        style: d,
        ownerState: v,
        cx: tr,
        cy: tr,
        r: (tr - u) / 2,
        fill: "none",
        strokeWidth: u
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Ho.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: i.oneOfType([i.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: zt(i.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: i.oneOfType([i.number, i.string]),
  /**
   * @ignore
   */
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: i.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: i.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: i.oneOf(["determinate", "indeterminate"])
});
function Ig(e) {
  return he("MuiIconButton", e);
}
const Zs = ge("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]), Ng = (e) => {
  const {
    classes: t,
    disabled: r,
    color: n,
    edge: o,
    size: a,
    loading: s
  } = e, l = {
    root: ["root", s && "loading", r && "disabled", n !== "default" && `color${Z(n)}`, o && `edge${Z(o)}`, `size${Z(a)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return Te(l, Ig, t);
}, Ag = ee(sr, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.loading && t.loading, r.color !== "default" && t[`color${Z(r.color)}`], r.edge && t[`edge${Z(r.edge)}`], t[`size${Z(r.size)}`]];
  }
})(_e(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Ne(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), _e(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(Mt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(Mt()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Ne((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${Zs.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  },
  [`&.${Zs.loading}`]: {
    color: "transparent"
  }
}))), Mg = ee("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator"
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (e.vars || e).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), bo = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: o = !1,
    children: a,
    className: s,
    color: l = "default",
    disabled: c = !1,
    disableFocusRipple: u = !1,
    size: p = "medium",
    id: f,
    loading: g = null,
    loadingIndicator: v,
    ...y
  } = n, d = xa(f), x = v ?? /* @__PURE__ */ w.jsx(Ho, {
    "aria-labelledby": d,
    color: "inherit",
    size: 16
  }), b = {
    ...n,
    edge: o,
    color: l,
    disabled: c,
    disableFocusRipple: u,
    loading: g,
    loadingIndicator: x,
    size: p
  }, O = Ng(b);
  return /* @__PURE__ */ w.jsxs(Ag, {
    id: g ? d : f,
    className: oe(O.root, s),
    centerRipple: !0,
    focusRipple: !u,
    disabled: c || g,
    ref: r,
    ...y,
    ownerState: b,
    children: [typeof g == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ w.jsx("span", {
      className: O.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ w.jsx(Mg, {
        className: O.loadingIndicator,
        ownerState: b,
        children: g && x
      })
    }), a]
  });
});
process.env.NODE_ENV !== "production" && (bo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: zt(i.node, (e) => h.Children.toArray(e.children).some((r) => /* @__PURE__ */ h.isValidElement(r) && r.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: i.oneOfType([i.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: i.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: i.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: i.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: i.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: i.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: i.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: i.oneOfType([i.oneOf(["small", "medium", "large"]), i.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
var lt = "top", Et = "bottom", Ct = "right", ct = "left", Sa = "auto", $n = [lt, Et, Ct, ct], Mr = "start", xn = "end", jg = "clippingParents", Mc = "viewport", Zr = "popper", _g = "reference", Qs = /* @__PURE__ */ $n.reduce(function(e, t) {
  return e.concat([t + "-" + Mr, t + "-" + xn]);
}, []), jc = /* @__PURE__ */ [].concat($n, [Sa]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Mr, t + "-" + xn]);
}, []), Dg = "beforeRead", Lg = "read", Bg = "afterRead", Fg = "beforeMain", Vg = "main", zg = "afterMain", Wg = "beforeWrite", Ug = "write", Hg = "afterWrite", Yg = [Dg, Lg, Bg, Fg, Vg, zg, Wg, Ug, Hg];
function Ft(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function mt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function xr(e) {
  var t = mt(e).Element;
  return e instanceof t || e instanceof Element;
}
function bt(e) {
  var t = mt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function wa(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = mt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function qg(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, o = t.attributes[r] || {}, a = t.elements[r];
    !bt(a) || !Ft(a) || (Object.assign(a.style, n), Object.keys(o).forEach(function(s) {
      var l = o[s];
      l === !1 ? a.removeAttribute(s) : a.setAttribute(s, l === !0 ? "" : l);
    }));
  });
}
function Kg(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var o = t.elements[n], a = t.attributes[n] || {}, s = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), l = s.reduce(function(c, u) {
        return c[u] = "", c;
      }, {});
      !bt(o) || !Ft(o) || (Object.assign(o.style, l), Object.keys(a).forEach(function(c) {
        o.removeAttribute(c);
      }));
    });
  };
}
const Gg = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: qg,
  effect: Kg,
  requires: ["computeStyles"]
};
function Bt(e) {
  return e.split("-")[0];
}
var yr = Math.max, xo = Math.min, jr = Math.round;
function Fi() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function _c() {
  return !/^((?!chrome|android).)*safari/i.test(Fi());
}
function _r(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), o = 1, a = 1;
  t && bt(e) && (o = e.offsetWidth > 0 && jr(n.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && jr(n.height) / e.offsetHeight || 1);
  var s = xr(e) ? mt(e) : window, l = s.visualViewport, c = !_c() && r, u = (n.left + (c && l ? l.offsetLeft : 0)) / o, p = (n.top + (c && l ? l.offsetTop : 0)) / a, f = n.width / o, g = n.height / a;
  return {
    width: f,
    height: g,
    top: p,
    right: u + f,
    bottom: p + g,
    left: u,
    x: u,
    y: p
  };
}
function Oa(e) {
  var t = _r(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function Dc(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && wa(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Zt(e) {
  return mt(e).getComputedStyle(e);
}
function Xg(e) {
  return ["table", "td", "th"].indexOf(Ft(e)) >= 0;
}
function ur(e) {
  return ((xr(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Yo(e) {
  return Ft(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (wa(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ur(e)
  );
}
function el(e) {
  return !bt(e) || // https://github.com/popperjs/popper-core/issues/837
  Zt(e).position === "fixed" ? null : e.offsetParent;
}
function Jg(e) {
  var t = /firefox/i.test(Fi()), r = /Trident/i.test(Fi());
  if (r && bt(e)) {
    var n = Zt(e);
    if (n.position === "fixed")
      return null;
  }
  var o = Yo(e);
  for (wa(o) && (o = o.host); bt(o) && ["html", "body"].indexOf(Ft(o)) < 0; ) {
    var a = Zt(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function kn(e) {
  for (var t = mt(e), r = el(e); r && Xg(r) && Zt(r).position === "static"; )
    r = el(r);
  return r && (Ft(r) === "html" || Ft(r) === "body" && Zt(r).position === "static") ? t : r || Jg(e) || t;
}
function Ra(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function cn(e, t, r) {
  return yr(e, xo(t, r));
}
function Zg(e, t, r) {
  var n = cn(e, t, r);
  return n > r ? r : n;
}
function Lc() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Bc(e) {
  return Object.assign({}, Lc(), e);
}
function Fc(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var Qg = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Bc(typeof t != "number" ? t : Fc(t, $n));
};
function ey(e) {
  var t, r = e.state, n = e.name, o = e.options, a = r.elements.arrow, s = r.modifiersData.popperOffsets, l = Bt(r.placement), c = Ra(l), u = [ct, Ct].indexOf(l) >= 0, p = u ? "height" : "width";
  if (!(!a || !s)) {
    var f = Qg(o.padding, r), g = Oa(a), v = c === "y" ? lt : ct, y = c === "y" ? Et : Ct, d = r.rects.reference[p] + r.rects.reference[c] - s[c] - r.rects.popper[p], x = s[c] - r.rects.reference[c], b = kn(a), O = b ? c === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, T = d / 2 - x / 2, E = f[v], C = O - g[p] - f[y], $ = O / 2 - g[p] / 2 + T, P = cn(E, $, C), k = c;
    r.modifiersData[n] = (t = {}, t[k] = P, t.centerOffset = P - $, t);
  }
}
function ty(e) {
  var t = e.state, r = e.options, n = r.element, o = n === void 0 ? "[data-popper-arrow]" : n;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || Dc(t.elements.popper, o) && (t.elements.arrow = o));
}
const ry = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: ey,
  effect: ty,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Dr(e) {
  return e.split("-")[1];
}
var ny = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function oy(e, t) {
  var r = e.x, n = e.y, o = t.devicePixelRatio || 1;
  return {
    x: jr(r * o) / o || 0,
    y: jr(n * o) / o || 0
  };
}
function tl(e) {
  var t, r = e.popper, n = e.popperRect, o = e.placement, a = e.variation, s = e.offsets, l = e.position, c = e.gpuAcceleration, u = e.adaptive, p = e.roundOffsets, f = e.isFixed, g = s.x, v = g === void 0 ? 0 : g, y = s.y, d = y === void 0 ? 0 : y, x = typeof p == "function" ? p({
    x: v,
    y: d
  }) : {
    x: v,
    y: d
  };
  v = x.x, d = x.y;
  var b = s.hasOwnProperty("x"), O = s.hasOwnProperty("y"), T = ct, E = lt, C = window;
  if (u) {
    var $ = kn(r), P = "clientHeight", k = "clientWidth";
    if ($ === mt(r) && ($ = ur(r), Zt($).position !== "static" && l === "absolute" && (P = "scrollHeight", k = "scrollWidth")), $ = $, o === lt || (o === ct || o === Ct) && a === xn) {
      E = Et;
      var I = f && $ === C && C.visualViewport ? C.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        $[P]
      );
      d -= I - n.height, d *= c ? 1 : -1;
    }
    if (o === ct || (o === lt || o === Et) && a === xn) {
      T = Ct;
      var m = f && $ === C && C.visualViewport ? C.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        $[k]
      );
      v -= m - n.width, v *= c ? 1 : -1;
    }
  }
  var R = Object.assign({
    position: l
  }, u && ny), _ = p === !0 ? oy({
    x: v,
    y: d
  }, mt(r)) : {
    x: v,
    y: d
  };
  if (v = _.x, d = _.y, c) {
    var j;
    return Object.assign({}, R, (j = {}, j[E] = O ? "0" : "", j[T] = b ? "0" : "", j.transform = (C.devicePixelRatio || 1) <= 1 ? "translate(" + v + "px, " + d + "px)" : "translate3d(" + v + "px, " + d + "px, 0)", j));
  }
  return Object.assign({}, R, (t = {}, t[E] = O ? d + "px" : "", t[T] = b ? v + "px" : "", t.transform = "", t));
}
function iy(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, o = n === void 0 ? !0 : n, a = r.adaptive, s = a === void 0 ? !0 : a, l = r.roundOffsets, c = l === void 0 ? !0 : l, u = {
    placement: Bt(t.placement),
    variation: Dr(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, tl(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, tl(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const ay = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: iy,
  data: {}
};
var Un = {
  passive: !0
};
function sy(e) {
  var t = e.state, r = e.instance, n = e.options, o = n.scroll, a = o === void 0 ? !0 : o, s = n.resize, l = s === void 0 ? !0 : s, c = mt(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && u.forEach(function(p) {
    p.addEventListener("scroll", r.update, Un);
  }), l && c.addEventListener("resize", r.update, Un), function() {
    a && u.forEach(function(p) {
      p.removeEventListener("scroll", r.update, Un);
    }), l && c.removeEventListener("resize", r.update, Un);
  };
}
const ly = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: sy,
  data: {}
};
var cy = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function eo(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return cy[t];
  });
}
var uy = {
  start: "end",
  end: "start"
};
function rl(e) {
  return e.replace(/start|end/g, function(t) {
    return uy[t];
  });
}
function Pa(e) {
  var t = mt(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function $a(e) {
  return _r(ur(e)).left + Pa(e).scrollLeft;
}
function dy(e, t) {
  var r = mt(e), n = ur(e), o = r.visualViewport, a = n.clientWidth, s = n.clientHeight, l = 0, c = 0;
  if (o) {
    a = o.width, s = o.height;
    var u = _c();
    (u || !u && t === "fixed") && (l = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: a,
    height: s,
    x: l + $a(e),
    y: c
  };
}
function py(e) {
  var t, r = ur(e), n = Pa(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, a = yr(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), s = yr(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -n.scrollLeft + $a(e), c = -n.scrollTop;
  return Zt(o || r).direction === "rtl" && (l += yr(r.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function ka(e) {
  var t = Zt(e), r = t.overflow, n = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + n);
}
function Vc(e) {
  return ["html", "body", "#document"].indexOf(Ft(e)) >= 0 ? e.ownerDocument.body : bt(e) && ka(e) ? e : Vc(Yo(e));
}
function un(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = Vc(e), o = n === ((r = e.ownerDocument) == null ? void 0 : r.body), a = mt(n), s = o ? [a].concat(a.visualViewport || [], ka(n) ? n : []) : n, l = t.concat(s);
  return o ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(un(Yo(s)))
  );
}
function Vi(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function fy(e, t) {
  var r = _r(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function nl(e, t, r) {
  return t === Mc ? Vi(dy(e, r)) : xr(t) ? fy(t, r) : Vi(py(ur(e)));
}
function my(e) {
  var t = un(Yo(e)), r = ["absolute", "fixed"].indexOf(Zt(e).position) >= 0, n = r && bt(e) ? kn(e) : e;
  return xr(n) ? t.filter(function(o) {
    return xr(o) && Dc(o, n) && Ft(o) !== "body";
  }) : [];
}
function hy(e, t, r, n) {
  var o = t === "clippingParents" ? my(e) : [].concat(t), a = [].concat(o, [r]), s = a[0], l = a.reduce(function(c, u) {
    var p = nl(e, u, n);
    return c.top = yr(p.top, c.top), c.right = xo(p.right, c.right), c.bottom = xo(p.bottom, c.bottom), c.left = yr(p.left, c.left), c;
  }, nl(e, s, n));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function zc(e) {
  var t = e.reference, r = e.element, n = e.placement, o = n ? Bt(n) : null, a = n ? Dr(n) : null, s = t.x + t.width / 2 - r.width / 2, l = t.y + t.height / 2 - r.height / 2, c;
  switch (o) {
    case lt:
      c = {
        x: s,
        y: t.y - r.height
      };
      break;
    case Et:
      c = {
        x: s,
        y: t.y + t.height
      };
      break;
    case Ct:
      c = {
        x: t.x + t.width,
        y: l
      };
      break;
    case ct:
      c = {
        x: t.x - r.width,
        y: l
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var u = o ? Ra(o) : null;
  if (u != null) {
    var p = u === "y" ? "height" : "width";
    switch (a) {
      case Mr:
        c[u] = c[u] - (t[p] / 2 - r[p] / 2);
        break;
      case xn:
        c[u] = c[u] + (t[p] / 2 - r[p] / 2);
        break;
    }
  }
  return c;
}
function En(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = n === void 0 ? e.placement : n, a = r.strategy, s = a === void 0 ? e.strategy : a, l = r.boundary, c = l === void 0 ? jg : l, u = r.rootBoundary, p = u === void 0 ? Mc : u, f = r.elementContext, g = f === void 0 ? Zr : f, v = r.altBoundary, y = v === void 0 ? !1 : v, d = r.padding, x = d === void 0 ? 0 : d, b = Bc(typeof x != "number" ? x : Fc(x, $n)), O = g === Zr ? _g : Zr, T = e.rects.popper, E = e.elements[y ? O : g], C = hy(xr(E) ? E : E.contextElement || ur(e.elements.popper), c, p, s), $ = _r(e.elements.reference), P = zc({
    reference: $,
    element: T,
    placement: o
  }), k = Vi(Object.assign({}, T, P)), I = g === Zr ? k : $, m = {
    top: C.top - I.top + b.top,
    bottom: I.bottom - C.bottom + b.bottom,
    left: C.left - I.left + b.left,
    right: I.right - C.right + b.right
  }, R = e.modifiersData.offset;
  if (g === Zr && R) {
    var _ = R[o];
    Object.keys(m).forEach(function(j) {
      var V = [Ct, Et].indexOf(j) >= 0 ? 1 : -1, D = [lt, Et].indexOf(j) >= 0 ? "y" : "x";
      m[j] += _[D] * V;
    });
  }
  return m;
}
function gy(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = r.boundary, a = r.rootBoundary, s = r.padding, l = r.flipVariations, c = r.allowedAutoPlacements, u = c === void 0 ? jc : c, p = Dr(n), f = p ? l ? Qs : Qs.filter(function(y) {
    return Dr(y) === p;
  }) : $n, g = f.filter(function(y) {
    return u.indexOf(y) >= 0;
  });
  g.length === 0 && (g = f);
  var v = g.reduce(function(y, d) {
    return y[d] = En(e, {
      placement: d,
      boundary: o,
      rootBoundary: a,
      padding: s
    })[Bt(d)], y;
  }, {});
  return Object.keys(v).sort(function(y, d) {
    return v[y] - v[d];
  });
}
function yy(e) {
  if (Bt(e) === Sa)
    return [];
  var t = eo(e);
  return [rl(e), t, rl(t)];
}
function vy(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var o = r.mainAxis, a = o === void 0 ? !0 : o, s = r.altAxis, l = s === void 0 ? !0 : s, c = r.fallbackPlacements, u = r.padding, p = r.boundary, f = r.rootBoundary, g = r.altBoundary, v = r.flipVariations, y = v === void 0 ? !0 : v, d = r.allowedAutoPlacements, x = t.options.placement, b = Bt(x), O = b === x, T = c || (O || !y ? [eo(x)] : yy(x)), E = [x].concat(T).reduce(function(G, Q) {
      return G.concat(Bt(Q) === Sa ? gy(t, {
        placement: Q,
        boundary: p,
        rootBoundary: f,
        padding: u,
        flipVariations: y,
        allowedAutoPlacements: d
      }) : Q);
    }, []), C = t.rects.reference, $ = t.rects.popper, P = /* @__PURE__ */ new Map(), k = !0, I = E[0], m = 0; m < E.length; m++) {
      var R = E[m], _ = Bt(R), j = Dr(R) === Mr, V = [lt, Et].indexOf(_) >= 0, D = V ? "width" : "height", M = En(t, {
        placement: R,
        boundary: p,
        rootBoundary: f,
        altBoundary: g,
        padding: u
      }), U = V ? j ? Ct : ct : j ? Et : lt;
      C[D] > $[D] && (U = eo(U));
      var te = eo(U), Y = [];
      if (a && Y.push(M[_] <= 0), l && Y.push(M[U] <= 0, M[te] <= 0), Y.every(function(G) {
        return G;
      })) {
        I = R, k = !1;
        break;
      }
      P.set(R, Y);
    }
    if (k)
      for (var N = y ? 3 : 1, B = function(Q) {
        var z = E.find(function(K) {
          var X = P.get(K);
          if (X)
            return X.slice(0, Q).every(function(ie) {
              return ie;
            });
        });
        if (z)
          return I = z, "break";
      }, H = N; H > 0; H--) {
        var q = B(H);
        if (q === "break") break;
      }
    t.placement !== I && (t.modifiersData[n]._skip = !0, t.placement = I, t.reset = !0);
  }
}
const by = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: vy,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ol(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function il(e) {
  return [lt, Ct, Et, ct].some(function(t) {
    return e[t] >= 0;
  });
}
function xy(e) {
  var t = e.state, r = e.name, n = t.rects.reference, o = t.rects.popper, a = t.modifiersData.preventOverflow, s = En(t, {
    elementContext: "reference"
  }), l = En(t, {
    altBoundary: !0
  }), c = ol(s, n), u = ol(l, o, a), p = il(c), f = il(u);
  t.modifiersData[r] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: u,
    isReferenceHidden: p,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": p,
    "data-popper-escaped": f
  });
}
const Ey = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: xy
};
function Cy(e, t, r) {
  var n = Bt(e), o = [ct, lt].indexOf(n) >= 0 ? -1 : 1, a = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, s = a[0], l = a[1];
  return s = s || 0, l = (l || 0) * o, [ct, Ct].indexOf(n) >= 0 ? {
    x: l,
    y: s
  } : {
    x: s,
    y: l
  };
}
function Ty(e) {
  var t = e.state, r = e.options, n = e.name, o = r.offset, a = o === void 0 ? [0, 0] : o, s = jc.reduce(function(p, f) {
    return p[f] = Cy(f, t.rects, a), p;
  }, {}), l = s[t.placement], c = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] = s;
}
const Sy = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Ty
};
function wy(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = zc({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const Oy = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: wy,
  data: {}
};
function Ry(e) {
  return e === "x" ? "y" : "x";
}
function Py(e) {
  var t = e.state, r = e.options, n = e.name, o = r.mainAxis, a = o === void 0 ? !0 : o, s = r.altAxis, l = s === void 0 ? !1 : s, c = r.boundary, u = r.rootBoundary, p = r.altBoundary, f = r.padding, g = r.tether, v = g === void 0 ? !0 : g, y = r.tetherOffset, d = y === void 0 ? 0 : y, x = En(t, {
    boundary: c,
    rootBoundary: u,
    padding: f,
    altBoundary: p
  }), b = Bt(t.placement), O = Dr(t.placement), T = !O, E = Ra(b), C = Ry(E), $ = t.modifiersData.popperOffsets, P = t.rects.reference, k = t.rects.popper, I = typeof d == "function" ? d(Object.assign({}, t.rects, {
    placement: t.placement
  })) : d, m = typeof I == "number" ? {
    mainAxis: I,
    altAxis: I
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, I), R = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, _ = {
    x: 0,
    y: 0
  };
  if ($) {
    if (a) {
      var j, V = E === "y" ? lt : ct, D = E === "y" ? Et : Ct, M = E === "y" ? "height" : "width", U = $[E], te = U + x[V], Y = U - x[D], N = v ? -k[M] / 2 : 0, B = O === Mr ? P[M] : k[M], H = O === Mr ? -k[M] : -P[M], q = t.elements.arrow, G = v && q ? Oa(q) : {
        width: 0,
        height: 0
      }, Q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Lc(), z = Q[V], K = Q[D], X = cn(0, P[M], G[M]), ie = T ? P[M] / 2 - N - X - z - m.mainAxis : B - X - z - m.mainAxis, W = T ? -P[M] / 2 + N + X + K + m.mainAxis : H + X + K + m.mainAxis, ne = t.elements.arrow && kn(t.elements.arrow), L = ne ? E === "y" ? ne.clientTop || 0 : ne.clientLeft || 0 : 0, de = (j = R == null ? void 0 : R[E]) != null ? j : 0, Se = U + ie - de - L, Ae = U + W - de, Je = cn(v ? xo(te, Se) : te, U, v ? yr(Y, Ae) : Y);
      $[E] = Je, _[E] = Je - U;
    }
    if (l) {
      var Ue, Fe = E === "x" ? lt : ct, ve = E === "x" ? Et : Ct, De = $[C], be = C === "y" ? "height" : "width", re = De + x[Fe], Yt = De - x[ve], Rt = [lt, ct].indexOf(b) !== -1, Pt = (Ue = R == null ? void 0 : R[C]) != null ? Ue : 0, $t = Rt ? re : De - P[be] - k[be] - Pt + m.altAxis, ht = Rt ? De + P[be] + k[be] - Pt - m.altAxis : Yt, qt = v && Rt ? Zg($t, De, ht) : cn(v ? $t : re, De, v ? ht : Yt);
      $[C] = qt, _[C] = qt - De;
    }
    t.modifiersData[n] = _;
  }
}
const $y = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Py,
  requiresIfExists: ["offset"]
};
function ky(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Iy(e) {
  return e === mt(e) || !bt(e) ? Pa(e) : ky(e);
}
function Ny(e) {
  var t = e.getBoundingClientRect(), r = jr(t.width) / e.offsetWidth || 1, n = jr(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function Ay(e, t, r) {
  r === void 0 && (r = !1);
  var n = bt(t), o = bt(t) && Ny(t), a = ur(t), s = _r(e, o, r), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Ft(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  ka(a)) && (l = Iy(t)), bt(t) ? (c = _r(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : a && (c.x = $a(a))), {
    x: s.left + l.scrollLeft - c.x,
    y: s.top + l.scrollTop - c.y,
    width: s.width,
    height: s.height
  };
}
function My(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function o(a) {
    r.add(a.name);
    var s = [].concat(a.requires || [], a.requiresIfExists || []);
    s.forEach(function(l) {
      if (!r.has(l)) {
        var c = t.get(l);
        c && o(c);
      }
    }), n.push(a);
  }
  return e.forEach(function(a) {
    r.has(a.name) || o(a);
  }), n;
}
function jy(e) {
  var t = My(e);
  return Yg.reduce(function(r, n) {
    return r.concat(t.filter(function(o) {
      return o.phase === n;
    }));
  }, []);
}
function _y(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function Dy(e) {
  var t = e.reduce(function(r, n) {
    var o = r[n.name];
    return r[n.name] = o ? Object.assign({}, o, n, {
      options: Object.assign({}, o.options, n.options),
      data: Object.assign({}, o.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var al = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function sl() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Ly(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, o = t.defaultOptions, a = o === void 0 ? al : o;
  return function(l, c, u) {
    u === void 0 && (u = a);
    var p = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, al, a),
      modifiersData: {},
      elements: {
        reference: l,
        popper: c
      },
      attributes: {},
      styles: {}
    }, f = [], g = !1, v = {
      state: p,
      setOptions: function(b) {
        var O = typeof b == "function" ? b(p.options) : b;
        d(), p.options = Object.assign({}, a, p.options, O), p.scrollParents = {
          reference: xr(l) ? un(l) : l.contextElement ? un(l.contextElement) : [],
          popper: un(c)
        };
        var T = jy(Dy([].concat(n, p.options.modifiers)));
        return p.orderedModifiers = T.filter(function(E) {
          return E.enabled;
        }), y(), v.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var b = p.elements, O = b.reference, T = b.popper;
          if (sl(O, T)) {
            p.rects = {
              reference: Ay(O, kn(T), p.options.strategy === "fixed"),
              popper: Oa(T)
            }, p.reset = !1, p.placement = p.options.placement, p.orderedModifiers.forEach(function(m) {
              return p.modifiersData[m.name] = Object.assign({}, m.data);
            });
            for (var E = 0; E < p.orderedModifiers.length; E++) {
              if (p.reset === !0) {
                p.reset = !1, E = -1;
                continue;
              }
              var C = p.orderedModifiers[E], $ = C.fn, P = C.options, k = P === void 0 ? {} : P, I = C.name;
              typeof $ == "function" && (p = $({
                state: p,
                options: k,
                name: I,
                instance: v
              }) || p);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: _y(function() {
        return new Promise(function(x) {
          v.forceUpdate(), x(p);
        });
      }),
      destroy: function() {
        d(), g = !0;
      }
    };
    if (!sl(l, c))
      return v;
    v.setOptions(u).then(function(x) {
      !g && u.onFirstUpdate && u.onFirstUpdate(x);
    });
    function y() {
      p.orderedModifiers.forEach(function(x) {
        var b = x.name, O = x.options, T = O === void 0 ? {} : O, E = x.effect;
        if (typeof E == "function") {
          var C = E({
            state: p,
            name: b,
            instance: v,
            options: T
          }), $ = function() {
          };
          f.push(C || $);
        }
      });
    }
    function d() {
      f.forEach(function(x) {
        return x();
      }), f = [];
    }
    return v;
  };
}
var By = [ly, Oy, ay, Gg, Sy, by, $y, ry, Ey], Fy = /* @__PURE__ */ Ly({
  defaultModifiers: By
});
function Vy(e) {
  return he("MuiPopper", e);
}
ge("MuiPopper", ["root"]);
function zy(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Eo(e) {
  return typeof e == "function" ? e() : e;
}
function qo(e) {
  return e.nodeType !== void 0;
}
function Wy(e) {
  return !qo(e);
}
const Uy = (e) => {
  const {
    classes: t
  } = e;
  return Te({
    root: ["root"]
  }, Vy, t);
}, Hy = {}, Yy = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const {
    anchorEl: n,
    children: o,
    direction: a,
    disablePortal: s,
    modifiers: l,
    open: c,
    placement: u,
    popperOptions: p,
    popperRef: f,
    slotProps: g = {},
    slots: v = {},
    TransitionProps: y,
    // @ts-ignore internal logic
    ownerState: d,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...x
  } = t, b = h.useRef(null), O = tt(b, r), T = h.useRef(null), E = tt(T, f), C = h.useRef(E);
  ir(() => {
    C.current = E;
  }, [E]), h.useImperativeHandle(f, () => T.current, []);
  const $ = zy(u, a), [P, k] = h.useState($), [I, m] = h.useState(Eo(n));
  h.useEffect(() => {
    T.current && T.current.forceUpdate();
  }), h.useEffect(() => {
    n && m(Eo(n));
  }, [n]), ir(() => {
    if (!I || !c)
      return;
    const D = (te) => {
      k(te.placement);
    };
    if (process.env.NODE_ENV !== "production" && I && qo(I) && I.nodeType === 1) {
      const te = I.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && te.top === 0 && te.left === 0 && te.right === 0 && te.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let M = [{
      name: "preventOverflow",
      options: {
        altBoundary: s
      }
    }, {
      name: "flip",
      options: {
        altBoundary: s
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: te
      }) => {
        D(te);
      }
    }];
    l != null && (M = M.concat(l)), p && p.modifiers != null && (M = M.concat(p.modifiers));
    const U = Fy(I, b.current, {
      placement: $,
      ...p,
      modifiers: M
    });
    return C.current(U), () => {
      U.destroy(), C.current(null);
    };
  }, [I, s, l, c, p, $]);
  const R = {
    placement: P
  };
  y !== null && (R.TransitionProps = y);
  const _ = Uy(t), j = v.root ?? "div", V = va({
    elementType: j,
    externalSlotProps: g.root,
    externalForwardedProps: x,
    additionalProps: {
      role: "tooltip",
      ref: O
    },
    ownerState: t,
    className: _.root
  });
  return /* @__PURE__ */ w.jsx(j, {
    ...V,
    children: typeof o == "function" ? o(R) : o
  });
}), Wc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const {
    anchorEl: n,
    children: o,
    container: a,
    direction: s = "ltr",
    disablePortal: l = !1,
    keepMounted: c = !1,
    modifiers: u,
    open: p,
    placement: f = "bottom",
    popperOptions: g = Hy,
    popperRef: v,
    style: y,
    transition: d = !1,
    slotProps: x = {},
    slots: b = {},
    ...O
  } = t, [T, E] = h.useState(!0), C = () => {
    E(!1);
  }, $ = () => {
    E(!0);
  };
  if (!c && !p && (!d || T))
    return null;
  let P;
  if (a)
    P = a;
  else if (n) {
    const m = Eo(n);
    P = m && qo(m) ? xt(m).body : xt(null).body;
  }
  const k = !p && c && (!d || T) ? "none" : void 0, I = d ? {
    in: p,
    onEnter: C,
    onExited: $
  } : void 0;
  return /* @__PURE__ */ w.jsx(bn, {
    disablePortal: l,
    container: P,
    children: /* @__PURE__ */ w.jsx(Yy, {
      anchorEl: n,
      direction: s,
      disablePortal: l,
      modifiers: u,
      ref: r,
      open: d ? !T : p,
      placement: f,
      popperOptions: g,
      popperRef: v,
      slotProps: x,
      slots: b,
      ...O,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: k,
        ...y
      },
      TransitionProps: I,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (Wc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: zt(i.oneOfType([Jt, i.object, i.func]), (e) => {
    if (e.open) {
      const t = Eo(e.anchorEl);
      if (t && qo(t) && t.nodeType === 1) {
        const r = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || Wy(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: i.oneOfType([i.node, i.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: i.oneOfType([Jt, i.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: i.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: i.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: i.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: i.arrayOf(i.shape({
    data: i.object,
    effect: i.func,
    enabled: i.bool,
    fn: i.func,
    name: i.any,
    options: i.object,
    phase: i.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: i.arrayOf(i.string),
    requiresIfExists: i.arrayOf(i.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: i.shape({
    modifiers: i.array,
    onFirstUpdate: i.func,
    placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: i.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: zo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: i.shape({
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: i.shape({
    root: i.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: i.bool
});
const qy = ee(Wc, {
  name: "MuiPopper",
  slot: "Root"
})({}), Ia = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = da(), o = ye({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: a,
    component: s,
    components: l,
    componentsProps: c,
    container: u,
    disablePortal: p,
    keepMounted: f,
    modifiers: g,
    open: v,
    placement: y,
    popperOptions: d,
    popperRef: x,
    transition: b,
    slots: O,
    slotProps: T,
    ...E
  } = o, C = (O == null ? void 0 : O.root) ?? (l == null ? void 0 : l.Root), $ = {
    anchorEl: a,
    container: u,
    disablePortal: p,
    keepMounted: f,
    modifiers: g,
    open: v,
    placement: y,
    popperOptions: d,
    popperRef: x,
    transition: b,
    ...E
  };
  return /* @__PURE__ */ w.jsx(qy, {
    as: s,
    direction: n ? "rtl" : "ltr",
    slots: {
      root: C
    },
    slotProps: T ?? c,
    ...$,
    ref: r
  });
});
process.env.NODE_ENV !== "production" && (Ia.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: i.oneOfType([Jt, i.object, i.func]),
  /**
   * Popper render function or node.
   */
  children: i.oneOfType([i.node, i.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: i.shape({
    Root: i.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: i.shape({
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: i.oneOfType([Jt, i.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: i.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: i.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: i.arrayOf(i.shape({
    data: i.object,
    effect: i.func,
    enabled: i.bool,
    fn: i.func,
    name: i.any,
    options: i.object,
    phase: i.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: i.arrayOf(i.string),
    requiresIfExists: i.arrayOf(i.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: i.shape({
    modifiers: i.array,
    onFirstUpdate: i.func,
    placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: i.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: zo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: i.shape({
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: i.shape({
    root: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: i.bool
});
function Ky(e) {
  return he("MuiTooltip", e);
}
const We = ge("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
function Gy(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Xy = (e) => {
  const {
    classes: t,
    disableInteractive: r,
    arrow: n,
    touch: o,
    placement: a
  } = e, s = {
    popper: ["popper", !r && "popperInteractive", n && "popperArrow"],
    tooltip: ["tooltip", n && "tooltipArrow", o && "touch", `tooltipPlacement${Z(a.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Te(s, Ky, t);
}, Jy = ee(Ia, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.popper, !r.disableInteractive && t.popperInteractive, r.arrow && t.popperArrow, !r.open && t.popperClose];
  }
})(_e(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableInteractive,
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: ({
      open: t
    }) => !t,
    style: {
      pointerEvents: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      [`&[data-popper-placement*="bottom"] .${We.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${We.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${We.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${We.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${We.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${We.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${We.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${We.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
}))), Zy = ee("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.tooltip, r.touch && t.touch, r.arrow && t.tooltipArrow, t[`tooltipPlacement${Z(r.placement.split("-")[0])}`]];
  }
})(_e(({
  theme: e
}) => ({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : Ne(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium,
  [`.${We.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${We.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${We.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${We.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      padding: "8px 16px",
      fontSize: e.typography.pxToRem(14),
      lineHeight: `${Gy(16 / 14)}em`,
      fontWeight: e.typography.fontWeightRegular
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl,
    style: {
      [`.${We.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${We.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl && t.touch,
    style: {
      [`.${We.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${We.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl,
    style: {
      [`.${We.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${We.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl && t.touch,
    style: {
      [`.${We.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${We.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${We.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${We.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
}))), Qy = ee("span", {
  name: "MuiTooltip",
  slot: "Arrow"
})(_e(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : Ne(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let Hn = !1;
const ll = new Wo();
let Qr = {
  x: 0,
  y: 0
};
function Yn(e, t) {
  return (r, ...n) => {
    t && t(r, ...n), e(r, ...n);
  };
}
const Uc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: o = !1,
    children: a,
    classes: s,
    components: l = {},
    componentsProps: c = {},
    describeChild: u = !1,
    disableFocusListener: p = !1,
    disableHoverListener: f = !1,
    disableInteractive: g = !1,
    disableTouchListener: v = !1,
    enterDelay: y = 100,
    enterNextDelay: d = 0,
    enterTouchDelay: x = 700,
    followCursor: b = !1,
    id: O,
    leaveDelay: T = 0,
    leaveTouchDelay: E = 1500,
    onClose: C,
    onOpen: $,
    open: P,
    placement: k = "bottom",
    PopperComponent: I,
    PopperProps: m = {},
    slotProps: R = {},
    slots: _ = {},
    title: j,
    TransitionComponent: V,
    TransitionProps: D,
    ...M
  } = n, U = /* @__PURE__ */ h.isValidElement(a) ? a : /* @__PURE__ */ w.jsx("span", {
    children: a
  }), te = Fo(), Y = da(), [N, B] = h.useState(), [H, q] = h.useState(null), G = h.useRef(!1), Q = g || b, z = $r(), K = $r(), X = $r(), ie = $r(), [W, ne] = Hm({
    controlled: P,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let L = W;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: se
    } = h.useRef(P !== void 0);
    h.useEffect(() => {
      N && N.disabled && !se && j !== "" && N.tagName.toLowerCase() === "button" && console.warn(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [j, N, se]);
  }
  const de = xa(O), Se = h.useRef(), Ae = rr(() => {
    Se.current !== void 0 && (document.body.style.WebkitUserSelect = Se.current, Se.current = void 0), ie.clear();
  });
  h.useEffect(() => Ae, [Ae]);
  const Je = (se) => {
    ll.clear(), Hn = !0, ne(!0), $ && !L && $(se);
  }, Ue = rr(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (se) => {
      ll.start(800 + T, () => {
        Hn = !1;
      }), ne(!1), C && L && C(se), z.start(te.transitions.duration.shortest, () => {
        G.current = !1;
      });
    }
  ), Fe = (se) => {
    G.current && se.type !== "touchstart" || (N && N.removeAttribute("title"), K.clear(), X.clear(), y || Hn && d ? K.start(Hn ? d : y, () => {
      Je(se);
    }) : Je(se));
  }, ve = (se) => {
    K.clear(), X.start(T, () => {
      Ue(se);
    });
  }, [, De] = h.useState(!1), be = (se) => {
    ho(se.target) || (De(!1), ve(se));
  }, re = (se) => {
    N || B(se.currentTarget), ho(se.target) && (De(!0), Fe(se));
  }, Yt = (se) => {
    G.current = !0;
    const at = U.props;
    at.onTouchStart && at.onTouchStart(se);
  }, Rt = (se) => {
    Yt(se), X.clear(), z.clear(), Ae(), Se.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", ie.start(x, () => {
      document.body.style.WebkitUserSelect = Se.current, Fe(se);
    });
  }, Pt = (se) => {
    U.props.onTouchEnd && U.props.onTouchEnd(se), Ae(), X.start(E, () => {
      Ue(se);
    });
  };
  h.useEffect(() => {
    if (!L)
      return;
    function se(at) {
      at.key === "Escape" && Ue(at);
    }
    return document.addEventListener("keydown", se), () => {
      document.removeEventListener("keydown", se);
    };
  }, [Ue, L]);
  const $t = tt(Pn(U), B, r);
  !j && j !== 0 && (L = !1);
  const ht = h.useRef(), qt = (se) => {
    const at = U.props;
    at.onMouseMove && at.onMouseMove(se), Qr = {
      x: se.clientX,
      y: se.clientY
    }, ht.current && ht.current.update();
  }, St = {}, Le = typeof j == "string";
  u ? (St.title = !L && Le && !f ? j : null, St["aria-describedby"] = L ? de : null) : (St["aria-label"] = Le ? j : null, St["aria-labelledby"] = L && !Le ? de : null);
  const ce = {
    ...St,
    ...M,
    ...U.props,
    className: oe(M.className, U.props.className),
    onTouchStart: Yt,
    ref: $t,
    ...b ? {
      onMouseMove: qt
    } : {}
  };
  process.env.NODE_ENV !== "production" && (ce["data-mui-internal-clone-element"] = !0, h.useEffect(() => {
    N && !N.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [N]));
  const rt = {};
  v || (ce.onTouchStart = Rt, ce.onTouchEnd = Pt), f || (ce.onMouseOver = Yn(Fe, ce.onMouseOver), ce.onMouseLeave = Yn(ve, ce.onMouseLeave), Q || (rt.onMouseOver = Fe, rt.onMouseLeave = ve)), p || (ce.onFocus = Yn(re, ce.onFocus), ce.onBlur = Yn(be, ce.onBlur), Q || (rt.onFocus = re, rt.onBlur = be)), process.env.NODE_ENV !== "production" && U.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${U.props.title}\` or the Tooltip component.`].join(`
`));
  const qe = {
    ...n,
    isRtl: Y,
    arrow: o,
    disableInteractive: Q,
    placement: k,
    PopperComponentProp: I,
    touch: G.current
  }, Me = typeof R.popper == "function" ? R.popper(qe) : R.popper, Vr = h.useMemo(() => {
    var at, _n;
    let se = [{
      name: "arrow",
      enabled: !!H,
      options: {
        element: H,
        padding: 4
      }
    }];
    return (at = m.popperOptions) != null && at.modifiers && (se = se.concat(m.popperOptions.modifiers)), (_n = Me == null ? void 0 : Me.popperOptions) != null && _n.modifiers && (se = se.concat(Me.popperOptions.modifiers)), {
      ...m.popperOptions,
      ...Me == null ? void 0 : Me.popperOptions,
      modifiers: se
    };
  }, [H, m.popperOptions, Me == null ? void 0 : Me.popperOptions]), zr = Xy(qe), Xo = typeof R.transition == "function" ? R.transition(qe) : R.transition, Qt = {
    slots: {
      popper: l.Popper,
      transition: l.Transition ?? V,
      tooltip: l.Tooltip,
      arrow: l.Arrow,
      ..._
    },
    slotProps: {
      arrow: R.arrow ?? c.arrow,
      popper: {
        ...m,
        ...Me ?? c.popper
      },
      // resolvedPopperProps can be spread because it's already an object
      tooltip: R.tooltip ?? c.tooltip,
      transition: {
        ...D,
        ...Xo ?? c.transition
      }
    }
  }, [An, er] = Be("popper", {
    elementType: Jy,
    externalForwardedProps: Qt,
    ownerState: qe,
    className: oe(zr.popper, m == null ? void 0 : m.className)
  }), [Wr, Ur] = Be("transition", {
    elementType: vn,
    externalForwardedProps: Qt,
    ownerState: qe
  }), [Mn, Jo] = Be("tooltip", {
    elementType: Zy,
    className: zr.tooltip,
    externalForwardedProps: Qt,
    ownerState: qe
  }), [jn, Zo] = Be("arrow", {
    elementType: Qy,
    className: zr.arrow,
    externalForwardedProps: Qt,
    ownerState: qe,
    ref: q
  });
  return /* @__PURE__ */ w.jsxs(h.Fragment, {
    children: [/* @__PURE__ */ h.cloneElement(U, ce), /* @__PURE__ */ w.jsx(An, {
      as: I ?? Ia,
      placement: k,
      anchorEl: b ? {
        getBoundingClientRect: () => ({
          top: Qr.y,
          left: Qr.x,
          right: Qr.x,
          bottom: Qr.y,
          width: 0,
          height: 0
        })
      } : N,
      popperRef: ht,
      open: N ? L : !1,
      id: de,
      transition: !0,
      ...rt,
      ...er,
      popperOptions: Vr,
      children: ({
        TransitionProps: se
      }) => /* @__PURE__ */ w.jsx(Wr, {
        timeout: te.transitions.duration.shorter,
        ...se,
        ...Ur,
        children: /* @__PURE__ */ w.jsxs(Mn, {
          ...Jo,
          children: [j, o ? /* @__PURE__ */ w.jsx(jn, {
            ...Zo
          }) : null]
        })
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (Uc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: i.bool,
  /**
   * Tooltip reference element.
   */
  children: Br.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: i.shape({
    Arrow: i.elementType,
    Popper: i.elementType,
    Tooltip: i.elementType,
    Transition: i.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: i.shape({
    arrow: i.object,
    popper: i.object,
    tooltip: i.object,
    transition: i.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: i.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: i.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: i.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: i.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: i.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: i.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: i.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: i.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: i.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: i.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: i.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: i.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: i.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: i.func,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: i.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: i.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    arrow: i.oneOfType([i.func, i.object]),
    popper: i.oneOfType([i.func, i.object]),
    tooltip: i.oneOfType([i.func, i.object]),
    transition: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    arrow: i.elementType,
    popper: i.elementType,
    tooltip: i.elementType,
    transition: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: i.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: i.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: i.object
});
const ev = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), "Person");
function H0({ menuItems: e }) {
  const [t, r] = h.useState(null), n = !!t, o = (s) => {
    r(s.currentTarget);
  }, a = () => {
    r(null);
  };
  return /* @__PURE__ */ w.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ w.jsx(Xe, { sx: { display: "flex", alignItems: "center", textAlign: "center" }, children: /* @__PURE__ */ w.jsx(Uc, { title: "Account settings", children: /* @__PURE__ */ w.jsx(
      bo,
      {
        onClick: o,
        size: "small",
        sx: { ml: 2 },
        "aria-controls": n ? "account-menu" : void 0,
        "aria-haspopup": "true",
        "aria-expanded": n ? "true" : void 0,
        children: /* @__PURE__ */ w.jsx(mc, { sx: { width: 32, height: 32 }, children: /* @__PURE__ */ w.jsx(ev, {}) })
      }
    ) }) }),
    /* @__PURE__ */ w.jsx(
      kc,
      {
        anchorEl: t,
        id: "account-menu",
        open: n,
        onClose: a,
        onClick: a,
        disableScrollLock: !0,
        slotProps: {
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0
              }
            }
          }
        },
        transformOrigin: { horizontal: "right", vertical: "top" },
        anchorOrigin: { horizontal: "right", vertical: "bottom" },
        children: e.map((s, l) => /* @__PURE__ */ w.jsxs(h.Fragment, { children: [
          s.divider && /* @__PURE__ */ w.jsx(yo, {}),
          s.href ? /* @__PURE__ */ w.jsxs(Di, { component: "a", href: s.href, onClick: a, children: [
            s.icon && /* @__PURE__ */ w.jsx(vo, { children: s.icon }),
            s.text
          ] }) : /* @__PURE__ */ w.jsxs(
            Di,
            {
              onClick: () => {
                var c;
                (c = s.onClick) == null || c.call(s), a();
              },
              children: [
                s.icon && /* @__PURE__ */ w.jsx(vo, { children: s.icon }),
                s.text
              ]
            }
          )
        ] }, l))
      }
    )
  ] });
}
function tv(e) {
  return he("MuiAppBar", e);
}
ge("MuiAppBar", ["root", "positionFixed", "positionAbsolute", "positionSticky", "positionStatic", "positionRelative", "colorDefault", "colorPrimary", "colorSecondary", "colorInherit", "colorTransparent", "colorError", "colorInfo", "colorSuccess", "colorWarning"]);
const rv = (e) => {
  const {
    color: t,
    position: r,
    classes: n
  } = e, o = {
    root: ["root", `color${Z(t)}`, `position${Z(r)}`]
  };
  return Te(o, tv, n);
}, cl = (e, t) => e ? `${e == null ? void 0 : e.replace(")", "")}, ${t})` : t, nv = ee(Uo, {
  name: "MuiAppBar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[`position${Z(r.position)}`], t[`color${Z(r.color)}`]];
  }
})(_e(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  boxSizing: "border-box",
  // Prevent padding issue with the Modal and fixed positioned AppBar.
  flexShrink: 0,
  variants: [{
    props: {
      position: "fixed"
    },
    style: {
      position: "fixed",
      zIndex: (e.vars || e).zIndex.appBar,
      top: 0,
      left: "auto",
      right: 0,
      "@media print": {
        // Prevent the app bar to be visible on each printed page.
        position: "absolute"
      }
    }
  }, {
    props: {
      position: "absolute"
    },
    style: {
      position: "absolute",
      zIndex: (e.vars || e).zIndex.appBar,
      top: 0,
      left: "auto",
      right: 0
    }
  }, {
    props: {
      position: "sticky"
    },
    style: {
      position: "sticky",
      zIndex: (e.vars || e).zIndex.appBar,
      top: 0,
      left: "auto",
      right: 0
    }
  }, {
    props: {
      position: "static"
    },
    style: {
      position: "static"
    }
  }, {
    props: {
      position: "relative"
    },
    style: {
      position: "relative"
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      "--AppBar-color": "inherit"
    }
  }, {
    props: {
      color: "default"
    },
    style: {
      "--AppBar-background": e.vars ? e.vars.palette.AppBar.defaultBg : e.palette.grey[100],
      "--AppBar-color": e.vars ? e.vars.palette.text.primary : e.palette.getContrastText(e.palette.grey[100]),
      ...e.applyStyles("dark", {
        "--AppBar-background": e.vars ? e.vars.palette.AppBar.defaultBg : e.palette.grey[900],
        "--AppBar-color": e.vars ? e.vars.palette.text.primary : e.palette.getContrastText(e.palette.grey[900])
      })
    }
  }, ...Object.entries(e.palette).filter(Mt(["contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--AppBar-background": (e.vars ?? e).palette[t].main,
      "--AppBar-color": (e.vars ?? e).palette[t].contrastText
    }
  })), {
    props: (t) => t.enableColorOnDark === !0 && !["inherit", "transparent"].includes(t.color),
    style: {
      backgroundColor: "var(--AppBar-background)",
      color: "var(--AppBar-color)"
    }
  }, {
    props: (t) => t.enableColorOnDark === !1 && !["inherit", "transparent"].includes(t.color),
    style: {
      backgroundColor: "var(--AppBar-background)",
      color: "var(--AppBar-color)",
      ...e.applyStyles("dark", {
        backgroundColor: e.vars ? cl(e.vars.palette.AppBar.darkBg, "var(--AppBar-background)") : null,
        color: e.vars ? cl(e.vars.palette.AppBar.darkColor, "var(--AppBar-color)") : null
      })
    }
  }, {
    props: {
      color: "transparent"
    },
    style: {
      "--AppBar-background": "transparent",
      "--AppBar-color": "inherit",
      backgroundColor: "var(--AppBar-background)",
      color: "var(--AppBar-color)",
      ...e.applyStyles("dark", {
        backgroundImage: "none"
      })
    }
  }]
}))), Hc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiAppBar"
  }), {
    className: o,
    color: a = "primary",
    enableColorOnDark: s = !1,
    position: l = "fixed",
    ...c
  } = n, u = {
    ...n,
    color: a,
    position: l,
    enableColorOnDark: s
  }, p = rv(u);
  return /* @__PURE__ */ w.jsx(nv, {
    square: !0,
    component: "header",
    ownerState: u,
    elevation: 4,
    className: oe(p.root, o, l === "fixed" && "mui-fixed"),
    ref: r,
    ...c
  });
});
process.env.NODE_ENV !== "production" && (Hc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: i.oneOfType([i.oneOf(["default", "inherit", "primary", "secondary", "transparent", "error", "info", "success", "warning"]), i.string]),
  /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */
  enableColorOnDark: i.bool,
  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Web/CSS/position).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */
  position: i.oneOf(["absolute", "fixed", "relative", "static", "sticky"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function ov(e) {
  return he("MuiToolbar", e);
}
ge("MuiToolbar", ["root", "gutters", "regular", "dense"]);
const iv = (e) => {
  const {
    classes: t,
    disableGutters: r,
    variant: n
  } = e;
  return Te({
    root: ["root", !r && "gutters", n]
  }, ov, t);
}, av = ee("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.disableGutters && t.gutters, t[r.variant]];
  }
})(_e(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: e.spacing(2),
      paddingRight: e.spacing(2),
      [e.breakpoints.up("sm")]: {
        paddingLeft: e.spacing(3),
        paddingRight: e.spacing(3)
      }
    }
  }, {
    props: {
      variant: "dense"
    },
    style: {
      minHeight: 48
    }
  }, {
    props: {
      variant: "regular"
    },
    style: e.mixins.toolbar
  }]
}))), Yc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiToolbar"
  }), {
    className: o,
    component: a = "div",
    disableGutters: s = !1,
    variant: l = "regular",
    ...c
  } = n, u = {
    ...n,
    component: a,
    disableGutters: s,
    variant: l
  }, p = iv(u);
  return /* @__PURE__ */ w.jsx(av, {
    as: a,
    className: oe(p.root, o),
    ref: r,
    ownerState: u,
    ...c
  });
});
process.env.NODE_ENV !== "production" && (Yc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: i.oneOfType([i.oneOf(["dense", "regular"]), i.string])
});
const sv = 64, Y0 = ({ rightContent: e = null, brandLogo: t = null, sx: r = {} }) => /* @__PURE__ */ w.jsx(Hc, { sx: { ...r }, position: "fixed", elevation: 1, children: /* @__PURE__ */ w.jsxs(
  Yc,
  {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      pl: 0,
      minHeight: `${sv}px !important`
    },
    children: [
      t,
      e
    ]
  }
) }), q0 = ({ children: e, sx: t = {} }) => /* @__PURE__ */ w.jsx(
  Xe,
  {
    component: "footer",
    sx: {
      position: "fixed",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "56px",
      borderTop: 1,
      borderColor: "divider",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: (r) => r.zIndex.appBar,
      ...t
    },
    children: e
  }
), lv = 64, cv = ({ children: e }) => /* @__PURE__ */ w.jsx(
  Xe,
  {
    component: "main",
    sx: {
      p: "20px",
      pb: 0,
      flexGrow: 1,
      mb: "56px",
      // space for footer
      minHeight: `calc(100vh - ${lv}px - 56px)`,
      overflow: "auto"
    },
    children: e || /* @__PURE__ */ w.jsx("div", { children: "MainContent (stub)" })
  }
), hi = 64, ul = 72, uv = { xs: 2, sm: 4, md: 8 }, K0 = ({
  appFooterEnabled: e = !0,
  children: t,
  appBarRightContent: r = null,
  brandLogo: n = null,
  appFooter: o = null,
  appBar: a = null,
  navRail: s = null
}) => /* @__PURE__ */ w.jsxs(Xe, { sx: { minHeight: "100vh", width: "100%" }, children: [
  /* @__PURE__ */ w.jsx(
    Xe,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        zIndex: 1300
      },
      children: a
    }
  ),
  /* @__PURE__ */ w.jsxs(
    Xe,
    {
      sx: {
        display: "flex",
        flexDirection: "row",
        pt: `${hi}px`
      },
      children: [
        s && /* @__PURE__ */ w.jsx(
          Xe,
          {
            sx: {
              width: ul,
              flexShrink: 0,
              position: "fixed",
              height: `calc(100vh - ${hi}px)`,
              top: hi,
              left: 0,
              zIndex: 1200
            },
            children: s
          }
        ),
        /* @__PURE__ */ w.jsx(
          Xe,
          {
            sx: {
              flexGrow: 1,
              minWidth: 0,
              ml: s ? `${ul}px` : 0,
              px: uv
            },
            children: /* @__PURE__ */ w.jsx(cv, { children: t })
          }
        )
      ]
    }
  ),
  e && o
] }), dv = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function pv(e) {
  return he("MuiChip", e);
}
const le = ge("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), fv = (e) => {
  const {
    classes: t,
    disabled: r,
    size: n,
    color: o,
    iconColor: a,
    onDelete: s,
    clickable: l,
    variant: c
  } = e, u = {
    root: ["root", c, r && "disabled", `size${Z(n)}`, `color${Z(o)}`, l && "clickable", l && `clickableColor${Z(o)}`, s && "deletable", s && `deletableColor${Z(o)}`, `${c}${Z(o)}`],
    label: ["label", `label${Z(n)}`],
    avatar: ["avatar", `avatar${Z(n)}`, `avatarColor${Z(o)}`],
    icon: ["icon", `icon${Z(n)}`, `iconColor${Z(a)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${Z(n)}`, `deleteIconColor${Z(o)}`, `deleteIcon${Z(c)}Color${Z(o)}`]
  };
  return Te(u, pv, t);
}, mv = ee("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      color: n,
      iconColor: o,
      clickable: a,
      onDelete: s,
      size: l,
      variant: c
    } = r;
    return [{
      [`& .${le.avatar}`]: t.avatar
    }, {
      [`& .${le.avatar}`]: t[`avatar${Z(l)}`]
    }, {
      [`& .${le.avatar}`]: t[`avatarColor${Z(n)}`]
    }, {
      [`& .${le.icon}`]: t.icon
    }, {
      [`& .${le.icon}`]: t[`icon${Z(l)}`]
    }, {
      [`& .${le.icon}`]: t[`iconColor${Z(o)}`]
    }, {
      [`& .${le.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${le.deleteIcon}`]: t[`deleteIcon${Z(l)}`]
    }, {
      [`& .${le.deleteIcon}`]: t[`deleteIconColor${Z(n)}`]
    }, {
      [`& .${le.deleteIcon}`]: t[`deleteIcon${Z(c)}Color${Z(n)}`]
    }, t.root, t[`size${Z(l)}`], t[`color${Z(n)}`], a && t.clickable, a && n !== "default" && t[`clickableColor${Z(n)})`], s && t.deletable, s && n !== "default" && t[`deletableColor${Z(n)}`], t[c], t[`${c}${Z(n)}`]];
  }
})(_e(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${le.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${le.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${le.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${le.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${le.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${le.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${le.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : Ne(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : Ne(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${le.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${le.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(Mt(["contrastText"])).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        backgroundColor: (e.vars || e).palette[r].main,
        color: (e.vars || e).palette[r].contrastText,
        [`& .${le.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[r].contrastTextChannel} / 0.7)` : Ne(e.palette[r].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[r].contrastText
          }
        }
      }
    })), {
      props: (r) => r.iconColor === r.color,
      style: {
        [`& .${le.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: (r) => r.iconColor === r.color && r.color !== "default",
      style: {
        [`& .${le.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${le.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Ne(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter(Mt(["dark"])).map(([r]) => ({
      props: {
        color: r,
        onDelete: !0
      },
      style: {
        [`&.${le.focusVisible}`]: {
          background: (e.vars || e).palette[r].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Ne(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${le.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Ne(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(Mt(["dark"])).map(([r]) => ({
      props: {
        color: r,
        clickable: !0
      },
      style: {
        [`&:hover, &.${le.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[r].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${le.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${le.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${le.avatar}`]: {
          marginLeft: 4
        },
        [`& .${le.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${le.icon}`]: {
          marginLeft: 4
        },
        [`& .${le.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${le.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${le.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(Mt()).map(([r]) => ({
      props: {
        variant: "outlined",
        color: r
      },
      style: {
        color: (e.vars || e).palette[r].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.7)` : Ne(e.palette[r].main, 0.7)}`,
        [`&.${le.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Ne(e.palette[r].main, e.palette.action.hoverOpacity)
        },
        [`&.${le.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.focusOpacity})` : Ne(e.palette[r].main, e.palette.action.focusOpacity)
        },
        [`& .${le.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.7)` : Ne(e.palette[r].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[r].main
          }
        }
      }
    }))]
  };
})), hv = ee("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e, {
      size: n
    } = r;
    return [t.label, t[`label${Z(n)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function dl(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const qc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiChip"
  }), {
    avatar: o,
    className: a,
    clickable: s,
    color: l = "default",
    component: c,
    deleteIcon: u,
    disabled: p = !1,
    icon: f,
    label: g,
    onClick: v,
    onDelete: y,
    onKeyDown: d,
    onKeyUp: x,
    size: b = "medium",
    variant: O = "filled",
    tabIndex: T,
    skipFocusWhenDisabled: E = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    slots: C = {},
    slotProps: $ = {},
    ...P
  } = n, k = h.useRef(null), I = tt(k, r), m = (z) => {
    z.stopPropagation(), y && y(z);
  }, R = (z) => {
    z.currentTarget === z.target && dl(z) && z.preventDefault(), d && d(z);
  }, _ = (z) => {
    z.currentTarget === z.target && y && dl(z) && y(z), x && x(z);
  }, j = s !== !1 && v ? !0 : s, V = j || y ? sr : c || "div", D = {
    ...n,
    component: V,
    disabled: p,
    size: b,
    color: l,
    iconColor: /* @__PURE__ */ h.isValidElement(f) && f.props.color || l,
    onDelete: !!y,
    clickable: j,
    variant: O
  }, M = fv(D), U = V === sr ? {
    component: c || "div",
    focusVisibleClassName: M.focusVisible,
    ...y && {
      disableRipple: !0
    }
  } : {};
  let te = null;
  y && (te = u && /* @__PURE__ */ h.isValidElement(u) ? /* @__PURE__ */ h.cloneElement(u, {
    className: oe(u.props.className, M.deleteIcon),
    onClick: m
  }) : /* @__PURE__ */ w.jsx(dv, {
    className: M.deleteIcon,
    onClick: m
  }));
  let Y = null;
  o && /* @__PURE__ */ h.isValidElement(o) && (Y = /* @__PURE__ */ h.cloneElement(o, {
    className: oe(M.avatar, o.props.className)
  }));
  let N = null;
  f && /* @__PURE__ */ h.isValidElement(f) && (N = /* @__PURE__ */ h.cloneElement(f, {
    className: oe(M.icon, f.props.className)
  })), process.env.NODE_ENV !== "production" && Y && N && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one.");
  const B = {
    slots: C,
    slotProps: $
  }, [H, q] = Be("root", {
    elementType: mv,
    externalForwardedProps: {
      ...B,
      ...P
    },
    ownerState: D,
    // The `component` prop is preserved because `Chip` relies on it for internal logic. If `shouldForwardComponentProp` were `false`, `useSlot` would remove the `component` prop, potentially breaking the component's behavior.
    shouldForwardComponentProp: !0,
    ref: I,
    className: oe(M.root, a),
    additionalProps: {
      disabled: j && p ? !0 : void 0,
      tabIndex: E && p ? -1 : T,
      ...U
    },
    getSlotProps: (z) => ({
      ...z,
      onClick: (K) => {
        var X;
        (X = z.onClick) == null || X.call(z, K), v(K);
      },
      onKeyDown: (K) => {
        var X;
        (X = z.onKeyDown) == null || X.call(z, K), R(K);
      },
      onKeyUp: (K) => {
        var X;
        (X = z.onKeyUp) == null || X.call(z, K), _(K);
      }
    })
  }), [G, Q] = Be("label", {
    elementType: hv,
    externalForwardedProps: B,
    ownerState: D,
    className: M.label
  });
  return /* @__PURE__ */ w.jsxs(H, {
    as: V,
    ...q,
    children: [Y || N, /* @__PURE__ */ w.jsx(G, {
      ...Q,
      children: g
    }), te]
  });
});
process.env.NODE_ENV !== "production" && (qc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: i.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: Um,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: i.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: i.oneOfType([i.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: i.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * Icon element.
   */
  icon: i.element,
  /**
   * The content of the component.
   */
  label: i.node,
  /**
   * @ignore
   */
  onClick: i.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: i.func,
  /**
   * @ignore
   */
  onKeyDown: i.func,
  /**
   * @ignore
   */
  onKeyUp: i.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: i.oneOfType([i.oneOf(["medium", "small"]), i.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: i.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    label: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    label: i.elementType,
    root: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * @ignore
   */
  tabIndex: i.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: i.oneOfType([i.oneOf(["filled", "outlined"]), i.string])
});
const gv = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz"), yv = ee(sr)(_e(({
  theme: e
}) => ({
  display: "flex",
  marginLeft: `calc(${e.spacing(1)} * 0.5)`,
  marginRight: `calc(${e.spacing(1)} * 0.5)`,
  ...e.palette.mode === "light" ? {
    backgroundColor: e.palette.grey[100],
    color: e.palette.grey[700]
  } : {
    backgroundColor: e.palette.grey[700],
    color: e.palette.grey[100]
  },
  borderRadius: 2,
  "&:hover, &:focus": {
    ...e.palette.mode === "light" ? {
      backgroundColor: e.palette.grey[200]
    } : {
      backgroundColor: e.palette.grey[600]
    }
  },
  "&:active": {
    boxShadow: e.shadows[0],
    ...e.palette.mode === "light" ? {
      backgroundColor: Ri(e.palette.grey[200], 0.12)
    } : {
      backgroundColor: Ri(e.palette.grey[600], 0.12)
    }
  }
}))), vv = ee(gv)({
  width: 24,
  height: 16
});
function Kc(e) {
  const {
    slots: t = {},
    slotProps: r = {},
    ...n
  } = e, o = e;
  return /* @__PURE__ */ w.jsx("li", {
    children: /* @__PURE__ */ w.jsx(yv, {
      focusRipple: !0,
      ...n,
      ownerState: o,
      children: /* @__PURE__ */ w.jsx(vv, {
        as: t.CollapsedIcon,
        ownerState: o,
        ...r.collapsedIcon
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (Kc.propTypes = {
  /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */
  slotProps: i.shape({
    collapsedIcon: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: i.shape({
    CollapsedIcon: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.object
});
function bv(e) {
  return he("MuiBreadcrumbs", e);
}
const xv = ge("MuiBreadcrumbs", ["root", "ol", "li", "separator"]), Ev = (e) => {
  const {
    classes: t
  } = e;
  return Te({
    root: ["root"],
    li: ["li"],
    ol: ["ol"],
    separator: ["separator"]
  }, bv, t);
}, Cv = ee(jt, {
  name: "MuiBreadcrumbs",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`& .${xv.li}`]: t.li
  }, t.root]
})({}), Tv = ee("ol", {
  name: "MuiBreadcrumbs",
  slot: "Ol"
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
}), Sv = ee("li", {
  name: "MuiBreadcrumbs",
  slot: "Separator"
})({
  display: "flex",
  userSelect: "none",
  marginLeft: 8,
  marginRight: 8
});
function wv(e, t, r, n) {
  return e.reduce((o, a, s) => (s < e.length - 1 ? o = o.concat(a, /* @__PURE__ */ w.jsx(Sv, {
    "aria-hidden": !0,
    className: t,
    ownerState: n,
    children: r
  }, `separator-${s}`)) : o.push(a), o), []);
}
const Gc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiBreadcrumbs"
  }), {
    children: o,
    className: a,
    component: s = "nav",
    slots: l = {},
    slotProps: c = {},
    expandText: u = "Show path",
    itemsAfterCollapse: p = 1,
    itemsBeforeCollapse: f = 1,
    maxItems: g = 8,
    separator: v = "/",
    ...y
  } = n, [d, x] = h.useState(!1), b = {
    ...n,
    component: s,
    expanded: d,
    expandText: u,
    itemsAfterCollapse: p,
    itemsBeforeCollapse: f,
    maxItems: g,
    separator: v
  }, O = Ev(b), T = va({
    elementType: l.CollapsedIcon,
    externalSlotProps: c.collapsedIcon,
    ownerState: b
  }), E = h.useRef(null), C = (P) => {
    const k = () => {
      x(!0);
      const I = E.current.querySelector("a[href],button,[tabindex]");
      I && I.focus();
    };
    return f + p >= P.length ? (process.env.NODE_ENV !== "production" && console.error(["MUI: You have provided an invalid combination of props to the Breadcrumbs.", `itemsAfterCollapse={${p}} + itemsBeforeCollapse={${f}} >= maxItems={${g}}`].join(`
`)), P) : [...P.slice(0, f), /* @__PURE__ */ w.jsx(Kc, {
      "aria-label": u,
      slots: {
        CollapsedIcon: l.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: T
      },
      onClick: k
    }, "ellipsis"), ...P.slice(P.length - p, P.length)];
  }, $ = h.Children.toArray(o).filter((P) => (process.env.NODE_ENV !== "production" && ya.isFragment(P) && console.error(["MUI: The Breadcrumbs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ h.isValidElement(P))).map((P, k) => /* @__PURE__ */ w.jsx("li", {
    className: O.li,
    children: P
  }, `child-${k}`));
  return /* @__PURE__ */ w.jsx(Cv, {
    ref: r,
    component: s,
    color: "textSecondary",
    className: oe(O.root, a),
    ownerState: b,
    ...y,
    children: /* @__PURE__ */ w.jsx(Tv, {
      className: O.ol,
      ref: E,
      ownerState: b,
      children: wv(d || g && $.length <= g ? $ : C($), O.separator, v, b)
    })
  });
});
process.env.NODE_ENV !== "production" && (Gc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Show path'
   */
  expandText: i.string,
  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */
  itemsAfterCollapse: sn,
  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */
  itemsBeforeCollapse: sn,
  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */
  maxItems: sn,
  /**
   * Custom separator node.
   * @default '/'
   */
  separator: i.node,
  /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */
  slotProps: i.shape({
    collapsedIcon: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: i.shape({
    CollapsedIcon: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function Ov(e) {
  return he("MuiButton", e);
}
const fr = ge("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge", "loading", "loadingWrapper", "loadingIconPlaceholder", "loadingIndicator", "loadingPositionCenter", "loadingPositionStart", "loadingPositionEnd"]), Xc = /* @__PURE__ */ h.createContext({});
process.env.NODE_ENV !== "production" && (Xc.displayName = "ButtonGroupContext");
const Jc = /* @__PURE__ */ h.createContext(void 0);
process.env.NODE_ENV !== "production" && (Jc.displayName = "ButtonGroupButtonContext");
const Rv = (e) => {
  const {
    color: t,
    disableElevation: r,
    fullWidth: n,
    size: o,
    variant: a,
    loading: s,
    loadingPosition: l,
    classes: c
  } = e, u = {
    root: ["root", s && "loading", a, `${a}${Z(t)}`, `size${Z(o)}`, `${a}Size${Z(o)}`, `color${Z(t)}`, r && "disableElevation", n && "fullWidth", s && `loadingPosition${Z(l)}`],
    startIcon: ["icon", "startIcon", `iconSize${Z(o)}`],
    endIcon: ["icon", "endIcon", `iconSize${Z(o)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  }, p = Te(u, Ov, c);
  return {
    ...c,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...p
  };
}, Zc = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], Pv = ee(sr, {
  shouldForwardProp: (e) => Vo(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], t[`${r.variant}${Z(r.color)}`], t[`size${Z(r.size)}`], t[`${r.variant}Size${Z(r.size)}`], r.color === "inherit" && t.colorInherit, r.disableElevation && t.disableElevation, r.fullWidth && t.fullWidth, r.loading && t.loading];
  }
})(_e(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], r = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return {
    ...e.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${fr.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (e.vars || e).shadows[2],
        "&:hover": {
          boxShadow: (e.vars || e).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (e.vars || e).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[8]
        },
        [`&.${fr.focusVisible}`]: {
          boxShadow: (e.vars || e).shadows[6]
        },
        [`&.${fr.disabled}`]: {
          color: (e.vars || e).palette.action.disabled,
          boxShadow: (e.vars || e).shadows[0],
          backgroundColor: (e.vars || e).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${fr.disabled}`]: {
          border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(e.palette).filter(Mt()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        "--variant-textColor": (e.vars || e).palette[n].main,
        "--variant-outlinedColor": (e.vars || e).palette[n].main,
        "--variant-outlinedBorder": e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.5)` : Ne(e.palette[n].main, 0.5),
        "--variant-containedColor": (e.vars || e).palette[n].contrastText,
        "--variant-containedBg": (e.vars || e).palette[n].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (e.vars || e).palette[n].dark,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Ne(e.palette[n].main, e.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (e.vars || e).palette[n].main,
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Ne(e.palette[n].main, e.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedBg : t,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedHoverBg : r,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : Ne(e.palette.text.primary, e.palette.action.hoverOpacity),
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : Ne(e.palette.text.primary, e.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${fr.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${fr.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }, {
      props: {
        loadingPosition: "center"
      },
      style: {
        transition: e.transitions.create(["background-color", "box-shadow", "border-color"], {
          duration: e.transitions.duration.short
        }),
        [`&.${fr.loading}`]: {
          color: "transparent"
        }
      }
    }]
  };
})), $v = ee("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.startIcon, r.loading && t.startIconLoadingStart, t[`iconSize${Z(r.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginRight: -8
    }
  }, ...Zc]
})), kv = ee("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.endIcon, r.loading && t.endIconLoadingEnd, t[`iconSize${Z(r.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginLeft: -8
    }
  }, ...Zc]
})), Iv = ee("span", {
  name: "MuiButton",
  slot: "LoadingIndicator"
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }, {
    props: {
      loadingPosition: "start"
    },
    style: {
      left: 14
    }
  }, {
    props: {
      loadingPosition: "start",
      size: "small"
    },
    style: {
      left: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "start"
    },
    style: {
      left: 6
    }
  }, {
    props: {
      loadingPosition: "center"
    },
    style: {
      left: "50%",
      transform: "translate(-50%)",
      color: (e.vars || e).palette.action.disabled
    }
  }, {
    props: {
      loadingPosition: "end"
    },
    style: {
      right: 14
    }
  }, {
    props: {
      loadingPosition: "end",
      size: "small"
    },
    style: {
      right: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "end"
    },
    style: {
      right: 6
    }
  }, {
    props: {
      loadingPosition: "start",
      fullWidth: !0
    },
    style: {
      position: "relative",
      left: -10
    }
  }, {
    props: {
      loadingPosition: "end",
      fullWidth: !0
    },
    style: {
      position: "relative",
      right: -10
    }
  }]
})), pl = ee("span", {
  name: "MuiButton",
  slot: "LoadingIconPlaceholder"
})({
  display: "inline-block",
  width: "1em",
  height: "1em"
}), dn = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = h.useContext(Xc), o = h.useContext(Jc), a = hn(n, t), s = ye({
    props: a,
    name: "MuiButton"
  }), {
    children: l,
    color: c = "primary",
    component: u = "button",
    className: p,
    disabled: f = !1,
    disableElevation: g = !1,
    disableFocusRipple: v = !1,
    endIcon: y,
    focusVisibleClassName: d,
    fullWidth: x = !1,
    id: b,
    loading: O = null,
    loadingIndicator: T,
    loadingPosition: E = "center",
    size: C = "medium",
    startIcon: $,
    type: P,
    variant: k = "text",
    ...I
  } = s, m = xa(b), R = T ?? /* @__PURE__ */ w.jsx(Ho, {
    "aria-labelledby": m,
    color: "inherit",
    size: 16
  }), _ = {
    ...s,
    color: c,
    component: u,
    disabled: f,
    disableElevation: g,
    disableFocusRipple: v,
    fullWidth: x,
    loading: O,
    loadingIndicator: R,
    loadingPosition: E,
    size: C,
    type: P,
    variant: k
  }, j = Rv(_), V = ($ || O && E === "start") && /* @__PURE__ */ w.jsx($v, {
    className: j.startIcon,
    ownerState: _,
    children: $ || /* @__PURE__ */ w.jsx(pl, {
      className: j.loadingIconPlaceholder,
      ownerState: _
    })
  }), D = (y || O && E === "end") && /* @__PURE__ */ w.jsx(kv, {
    className: j.endIcon,
    ownerState: _,
    children: y || /* @__PURE__ */ w.jsx(pl, {
      className: j.loadingIconPlaceholder,
      ownerState: _
    })
  }), M = o || "", U = typeof O == "boolean" ? (
    // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ w.jsx("span", {
      className: j.loadingWrapper,
      style: {
        display: "contents"
      },
      children: O && /* @__PURE__ */ w.jsx(Iv, {
        className: j.loadingIndicator,
        ownerState: _,
        children: R
      })
    })
  ) : null;
  return /* @__PURE__ */ w.jsxs(Pv, {
    ownerState: _,
    className: oe(n.className, j.root, p, M),
    component: u,
    disabled: f || O,
    focusRipple: !v,
    focusVisibleClassName: oe(j.focusVisible, d),
    ref: r,
    type: P,
    id: O ? m : b,
    ...I,
    classes: j,
    children: [V, E !== "end" && U, l, E === "end" && U, D]
  });
});
process.env.NODE_ENV !== "production" && (dn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: i.oneOfType([i.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), i.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: i.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: i.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: i.bool,
  /**
   * Element placed after the children.
   */
  endIcon: i.node,
  /**
   * @ignore
   */
  focusVisibleClassName: i.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: i.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: i.string,
  /**
   * @ignore
   */
  id: i.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: i.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: i.node,
  /**
   * The loading indicator can be positioned on the start, end, or the center of the button.
   * @default 'center'
   */
  loadingPosition: i.oneOf(["center", "end", "start"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: i.oneOfType([i.oneOf(["small", "medium", "large"]), i.string]),
  /**
   * Element placed before the children.
   */
  startIcon: i.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * @ignore
   */
  type: i.oneOfType([i.oneOf(["button", "reset", "submit"]), i.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: i.oneOfType([i.oneOf(["contained", "outlined", "text"]), i.string])
});
function Nv(e) {
  return he("MuiCard", e);
}
ge("MuiCard", ["root"]);
const Av = (e) => {
  const {
    classes: t
  } = e;
  return Te({
    root: ["root"]
  }, Nv, t);
}, Mv = ee(Uo, {
  name: "MuiCard",
  slot: "Root"
})({
  overflow: "hidden"
}), Qc = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiCard"
  }), {
    className: o,
    raised: a = !1,
    ...s
  } = n, l = {
    ...n,
    raised: a
  }, c = Av(l);
  return /* @__PURE__ */ w.jsx(Mv, {
    className: oe(c.root, o),
    elevation: a ? 8 : void 0,
    ref: r,
    ownerState: l,
    ...s
  });
});
process.env.NODE_ENV !== "production" && (Qc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: zt(i.bool, (e) => e.raised && e.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function jv(e) {
  return he("MuiCardActionArea", e);
}
const gi = ge("MuiCardActionArea", ["root", "focusVisible", "focusHighlight"]), _v = (e) => {
  const {
    classes: t
  } = e;
  return Te({
    root: ["root"],
    focusHighlight: ["focusHighlight"]
  }, jv, t);
}, Dv = ee(sr, {
  name: "MuiCardActionArea",
  slot: "Root"
})(_e(({
  theme: e
}) => ({
  display: "block",
  textAlign: "inherit",
  borderRadius: "inherit",
  // for Safari to work https://github.com/mui/material-ui/issues/36285.
  width: "100%",
  [`&:hover .${gi.focusHighlight}`]: {
    opacity: (e.vars || e).palette.action.hoverOpacity,
    "@media (hover: none)": {
      opacity: 0
    }
  },
  [`&.${gi.focusVisible} .${gi.focusHighlight}`]: {
    opacity: (e.vars || e).palette.action.focusOpacity
  }
}))), Lv = ee("span", {
  name: "MuiCardActionArea",
  slot: "FocusHighlight"
})(_e(({
  theme: e
}) => ({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit",
  opacity: 0,
  backgroundColor: "currentcolor",
  transition: e.transitions.create("opacity", {
    duration: e.transitions.duration.short
  })
}))), eu = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiCardActionArea"
  }), {
    children: o,
    className: a,
    focusVisibleClassName: s,
    slots: l = {},
    slotProps: c = {},
    ...u
  } = n, p = n, f = _v(p), g = {
    slots: l,
    slotProps: c
  }, [v, y] = Be("root", {
    elementType: Dv,
    externalForwardedProps: {
      ...g,
      ...u
    },
    shouldForwardComponentProp: !0,
    ownerState: p,
    ref: r,
    className: oe(f.root, a),
    additionalProps: {
      focusVisibleClassName: oe(s, f.focusVisible)
    }
  }), [d, x] = Be("focusHighlight", {
    elementType: Lv,
    externalForwardedProps: g,
    ownerState: p,
    ref: r,
    className: f.focusHighlight
  });
  return /* @__PURE__ */ w.jsxs(v, {
    ...y,
    children: [o, /* @__PURE__ */ w.jsx(d, {
      ...x
    })]
  });
});
process.env.NODE_ENV !== "production" && (eu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * @ignore
   */
  focusVisibleClassName: i.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    focusHighlight: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    focusHighlight: i.elementType,
    root: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function Bv(e) {
  return he("MuiCardContent", e);
}
ge("MuiCardContent", ["root"]);
const Fv = (e) => {
  const {
    classes: t
  } = e;
  return Te({
    root: ["root"]
  }, Bv, t);
}, Vv = ee("div", {
  name: "MuiCardContent",
  slot: "Root"
})({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
}), zi = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiCardContent"
  }), {
    className: o,
    component: a = "div",
    ...s
  } = n, l = {
    ...n,
    component: a
  }, c = Fv(l);
  return /* @__PURE__ */ w.jsx(Vv, {
    as: a,
    className: oe(c.root, o),
    ownerState: l,
    ref: r,
    ...s
  });
});
process.env.NODE_ENV !== "production" && (zi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
const Wi = typeof cc({}) == "function", zv = (e, t) => ({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%",
  // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
  ...t && !e.vars && {
    colorScheme: e.palette.mode
  }
}), Wv = (e) => ({
  color: (e.vars || e).palette.text.primary,
  ...e.typography.body1,
  backgroundColor: (e.vars || e).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (e.vars || e).palette.common.white
  }
}), tu = (e, t = !1) => {
  var a, s;
  const r = {};
  t && e.colorSchemes && typeof e.getColorSchemeSelector == "function" && Object.entries(e.colorSchemes).forEach(([l, c]) => {
    var p, f;
    const u = e.getColorSchemeSelector(l);
    u.startsWith("@") ? r[u] = {
      ":root": {
        colorScheme: (p = c.palette) == null ? void 0 : p.mode
      }
    } : r[u.replace(/\s*&/, "")] = {
      colorScheme: (f = c.palette) == null ? void 0 : f.mode
    };
  });
  let n = {
    html: zv(e, t),
    "*, *::before, *::after": {
      boxSizing: "inherit"
    },
    "strong, b": {
      fontWeight: e.typography.fontWeightBold
    },
    body: {
      margin: 0,
      // Remove the margin in all browsers.
      ...Wv(e),
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      "&::backdrop": {
        backgroundColor: (e.vars || e).palette.background.default
      }
    },
    ...r
  };
  const o = (s = (a = e.components) == null ? void 0 : a.MuiCssBaseline) == null ? void 0 : s.styleOverrides;
  return o && (n = [n, o]), n;
}, to = "mui-ecs", Uv = (e) => {
  const t = tu(e, !1), r = Array.isArray(t) ? t[0] : t;
  return !e.vars && r && (r.html[`:root:has(${to})`] = {
    colorScheme: e.palette.mode
  }), e.colorSchemes && Object.entries(e.colorSchemes).forEach(([n, o]) => {
    var s, l;
    const a = e.getColorSchemeSelector(n);
    a.startsWith("@") ? r[a] = {
      [`:root:not(:has(.${to}))`]: {
        colorScheme: (s = o.palette) == null ? void 0 : s.mode
      }
    } : r[a.replace(/\s*&/, "")] = {
      [`&:not(:has(.${to}))`]: {
        colorScheme: (l = o.palette) == null ? void 0 : l.mode
      }
    };
  }), t;
}, Hv = cc(Wi ? ({
  theme: e,
  enableColorScheme: t
}) => tu(e, t) : ({
  theme: e
}) => Uv(e));
function ru(e) {
  const t = ye({
    props: e,
    name: "MuiCssBaseline"
  }), {
    children: r,
    enableColorScheme: n = !1
  } = t;
  return /* @__PURE__ */ w.jsxs(h.Fragment, {
    children: [Wi && /* @__PURE__ */ w.jsx(Hv, {
      enableColorScheme: n
    }), !Wi && !n && /* @__PURE__ */ w.jsx("span", {
      className: to,
      style: {
        display: "none"
      }
    }), r]
  });
}
process.env.NODE_ENV !== "production" && (ru.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * You can wrap a node.
   */
  children: i.node,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   * @default false
   */
  enableColorScheme: i.bool
});
function Yv(e) {
  return he("MuiListItem", e);
}
ge("MuiListItem", ["root", "container", "dense", "alignItemsFlexStart", "divider", "gutters", "padding", "secondaryAction"]);
const qv = ge("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function Kv(e) {
  return he("MuiListItemSecondaryAction", e);
}
ge("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const Gv = (e) => {
  const {
    disableGutters: t,
    classes: r
  } = e;
  return Te({
    root: ["root", t && "disableGutters"]
  }, Kv, r);
}, Xv = ee("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.disableGutters && t.disableGutters];
  }
})({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  variants: [{
    props: ({
      ownerState: e
    }) => e.disableGutters,
    style: {
      right: 0
    }
  }]
}), Na = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: o,
    ...a
  } = n, s = h.useContext(Lt), l = {
    ...n,
    disableGutters: s.disableGutters
  }, c = Gv(l);
  return /* @__PURE__ */ w.jsx(Xv, {
    className: oe(c.root, o),
    ownerState: l,
    ref: r,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (Na.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
Na.muiName = "ListItemSecondaryAction";
const Jv = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, r.dense && t.dense, r.alignItems === "flex-start" && t.alignItemsFlexStart, r.divider && t.divider, !r.disableGutters && t.gutters, !r.disablePadding && t.padding, r.hasSecondaryAction && t.secondaryAction];
}, Zv = (e) => {
  const {
    alignItems: t,
    classes: r,
    dense: n,
    disableGutters: o,
    disablePadding: a,
    divider: s,
    hasSecondaryAction: l
  } = e;
  return Te({
    root: ["root", n && "dense", !o && "gutters", !a && "padding", s && "divider", t === "flex-start" && "alignItemsFlexStart", l && "secondaryAction"],
    container: ["container"]
  }, Yv, r);
}, Qv = ee("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: Jv
})(_e(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !!t.secondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.secondaryAction,
    style: {
      [`& > .${qv.root}`]: {
        paddingRight: 48
      }
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.button,
    style: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hasSecondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }]
}))), eb = ee("li", {
  name: "MuiListItem",
  slot: "Container"
})({
  position: "relative"
}), nu = /* @__PURE__ */ h.forwardRef(function(t, r) {
  const n = ye({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: o = "center",
    children: a,
    className: s,
    component: l,
    components: c = {},
    componentsProps: u = {},
    ContainerComponent: p = "li",
    ContainerProps: {
      className: f,
      ...g
    } = {},
    dense: v = !1,
    disableGutters: y = !1,
    disablePadding: d = !1,
    divider: x = !1,
    secondaryAction: b,
    slotProps: O = {},
    slots: T = {},
    ...E
  } = n, C = h.useContext(Lt), $ = h.useMemo(() => ({
    dense: v || C.dense || !1,
    alignItems: o,
    disableGutters: y
  }), [o, C.dense, v, y]), P = h.useRef(null), k = h.Children.toArray(a), I = k.length && tc(k[k.length - 1], ["ListItemSecondaryAction"]), m = {
    ...n,
    alignItems: o,
    dense: $.dense,
    disableGutters: y,
    disablePadding: d,
    divider: x,
    hasSecondaryAction: I
  }, R = Zv(m), _ = tt(P, r), j = T.root || c.Root || Qv, V = O.root || u.root || {}, D = {
    className: oe(R.root, V.className, s),
    ...E
  };
  let M = l || "li";
  return I ? (M = !D.component && !l ? "div" : M, p === "li" && (M === "li" ? M = "div" : D.component === "li" && (D.component = "div")), /* @__PURE__ */ w.jsx(Lt.Provider, {
    value: $,
    children: /* @__PURE__ */ w.jsxs(eb, {
      as: p,
      className: oe(R.container, f),
      ref: _,
      ownerState: m,
      ...g,
      children: [/* @__PURE__ */ w.jsx(j, {
        ...V,
        ...!Ni(j) && {
          as: M,
          ownerState: {
            ...m,
            ...V.ownerState
          }
        },
        ...D,
        children: k
      }), k.pop()]
    })
  })) : /* @__PURE__ */ w.jsx(Lt.Provider, {
    value: $,
    children: /* @__PURE__ */ w.jsxs(j, {
      ...V,
      as: M,
      ref: _,
      ...!Ni(j) && {
        ownerState: {
          ...m,
          ...V.ownerState
        }
      },
      ...D,
      children: [k, b && /* @__PURE__ */ w.jsx(Na, {
        children: b
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (nu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: i.oneOf(["center", "flex-start"]),
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: zt(i.node, (e) => {
    const t = h.Children.toArray(e.children);
    let r = -1;
    for (let n = t.length - 1; n >= 0; n -= 1) {
      const o = t[n];
      if (tc(o, ["ListItemSecondaryAction"])) {
        r = n;
        break;
      }
    }
    return r !== -1 && r !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  components: i.shape({
    Root: i.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  componentsProps: i.shape({
    root: i.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated Use the `component` or `slots.root` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerComponent: Ea,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated Use the `slotProps.root` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerProps: i.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: i.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: i.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: i.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: i.bool,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: i.node,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: i.shape({
    root: i.object
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: i.shape({
    root: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
const ou = Bf({
  createStyledComponent: ee("div", {
    name: "MuiStack",
    slot: "Root"
  }),
  useThemeProps: (e) => ye({
    props: e,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (ou.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: i.oneOfType([i.oneOf(["column-reverse", "column", "row-reverse", "row"]), i.arrayOf(i.oneOf(["column-reverse", "column", "row-reverse", "row"])), i.object]),
  /**
   * Add an element between each child.
   */
  divider: i.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: i.oneOfType([i.arrayOf(i.oneOfType([i.number, i.string])), i.number, i.object, i.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: i.bool
});
function ro({ message: e }) {
  return /* @__PURE__ */ w.jsxs(
    Xe,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal
      },
      children: [
        /* @__PURE__ */ w.jsx(Ho, {}),
        e && /* @__PURE__ */ w.jsx(jt, { variant: "h6", sx: { mt: 2 }, children: e })
      ]
    }
  );
}
function G0({ navigateFunction: e, location: t }) {
  return Hi(() => {
    console.log("[CallbackPage] Component mounted"), console.log("[CallbackPage] Location:", t);
    const r = setTimeout(() => {
      const n = localStorage.getItem("redirect_url") || "/";
      console.log("[CallbackPage] Redirecting to:", n), localStorage.removeItem("redirect_url"), e(n, { replace: !0 });
    }, 500);
    return () => {
      console.log("[CallbackPage] Component unmounting, clearing timeout"), clearTimeout(r);
    };
  }, [e, t]), console.log("[CallbackPage] Rendering loader"), /* @__PURE__ */ w.jsx(ro, { message: "Signing you in..." });
}
function tb({ children: e }) {
  const t = Yi(), r = window.location.pathname;
  return console.log("location", r), r !== "/" && r !== "/callback" && localStorage.setItem("redirect_url", r), Hi(() => {
    !t.isLoading && !t.isAuthenticated && !t.error && t.signinRedirect();
  }, [t.isLoading, t.isAuthenticated, t.error, t]), t.isLoading ? /* @__PURE__ */ w.jsx(ro, { message: "Loading..." }) : t.error ? /* @__PURE__ */ w.jsx(
    ro,
    {
      message: `Encountering error... ${t.error.message}`
    }
  ) : t.isAuthenticated ? e : /* @__PURE__ */ w.jsx(ro, { message: "Redirecting to login..." });
}
function X0({ cognitoAuthConfig: e, children: t }) {
  return /* @__PURE__ */ w.jsx(_u, { ...e, children: /* @__PURE__ */ w.jsx(tb, { children: t }) });
}
const rb = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add"), nb = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), "ArrowBack"), ob = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6"
}), "Brightness4"), ib = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
}), "Brightness7"), ab = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), "Delete"), sb = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Edit"), iu = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), "Home"), lb = dt(/* @__PURE__ */ w.jsx("path", {
  d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4z"
}), "Logout"), cb = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5"
}), "People"), au = dt(/* @__PURE__ */ w.jsx("path", {
  d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), "Settings"), J0 = ({
  onConfirm: e,
  onCancel: t,
  confirmText: r = "Confirm",
  cancelText: n = "Cancel",
  buttonText: o = "Delete",
  buttonIcon: a = /* @__PURE__ */ w.jsx(ab, {}),
  variant: s = "outlined",
  color: l = "error",
  size: c = "small",
  disabled: u = !1,
  "data-testid": p,
  confirmButtonTestId: f,
  cancelButtonTestId: g
}) => {
  const [v, y] = Mu(!1), d = () => {
    y(!0);
  }, x = () => {
    y(!1), e();
  }, b = () => {
    y(!1), t && t();
  };
  return v ? /* @__PURE__ */ w.jsxs(Xe, { sx: { display: "flex", gap: 1 }, children: [
    /* @__PURE__ */ w.jsx(
      dn,
      {
        variant: "contained",
        color: l,
        size: c,
        onClick: x,
        "data-testid": f,
        children: r
      }
    ),
    /* @__PURE__ */ w.jsx(
      dn,
      {
        variant: "outlined",
        size: c,
        onClick: b,
        "data-testid": g,
        children: n
      }
    )
  ] }) : /* @__PURE__ */ w.jsx(
    dn,
    {
      variant: s,
      color: l,
      size: c,
      startIcon: a,
      onClick: d,
      disabled: u,
      "data-testid": p,
      children: o
    }
  );
};
function Z0() {
  return /* @__PURE__ */ w.jsxs("div", { children: [
    "You have been logged out. ",
    /* @__PURE__ */ w.jsx("a", { href: "/", children: "Go to home" })
  ] });
}
function Q0({ navigateFunction: e }) {
  const t = Yi();
  return Hi(() => {
    let r = !0;
    async function n() {
      await t.removeUser(), r && e("/logged-out", { replace: !0 });
    }
    return n(), () => {
      r = !1;
    };
  }, [t, e]), /* @__PURE__ */ w.jsx("div", { children: "You have been logged out." });
}
function ex({ theme: e, children: t }) {
  return !e || typeof e != "object" ? (console.error("Invalid theme object provided to MuiThemeProvider"), t) : /* @__PURE__ */ w.jsxs(Em, { theme: e, children: [
    /* @__PURE__ */ w.jsx(ru, {}),
    t
  ] });
}
const ub = ee(Xe)(({ theme: e, backgroundColor: t, color: r }) => ({
  width: 72,
  height: "100%",
  backgroundColor: t || e.palette.background.paper,
  color: r || e.palette.text.primary,
  borderRight: `1px solid ${e.palette.divider}`,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingTop: e.spacing(2)
})), tx = ({
  navItems: e,
  backgroundColor: t = "#1a1a1a",
  color: r = "inherit"
}) => {
  const n = [
    {
      icon: /* @__PURE__ */ w.jsx(iu, {}),
      text: "Home",
      onClick: () => {
      }
    },
    {
      icon: /* @__PURE__ */ w.jsx(au, {}),
      text: "Settings",
      onClick: () => {
      }
    }
  ], o = e && e.length > 0 ? e : n;
  return /* @__PURE__ */ w.jsx(ub, { backgroundColor: t, color: r, children: /* @__PURE__ */ w.jsx(ba, { sx: { width: "100%", p: 0 }, children: o.map((a, s) => /* @__PURE__ */ w.jsxs(
    nu,
    {
      onClick: a.onClick,
      sx: {
        flexDirection: "column",
        py: 1,
        px: 0,
        color: "inherit",
        "&:hover": {
          backgroundColor: "transparent",
          opacity: 0.8
        }
      },
      children: [
        /* @__PURE__ */ w.jsx(
          vo,
          {
            sx: {
              minWidth: "auto",
              color: "inherit"
            },
            children: a.icon
          }
        ),
        /* @__PURE__ */ w.jsx(
          Ac,
          {
            primary: a.text,
            primaryTypographyProps: {
              variant: "caption",
              align: "center",
              sx: {
                fontSize: "0.7rem",
                mt: 0.5,
                color: "inherit"
              }
            }
          }
        )
      ]
    },
    s
  )) }) });
};
var Aa = {};
Object.defineProperty(Aa, "__esModule", { value: !0 });
Aa.parse = yb;
Aa.serialize = vb;
const db = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/, pb = /^[\u0021-\u003A\u003C-\u007E]*$/, fb = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, mb = /^[\u0020-\u003A\u003D-\u007E]*$/, hb = Object.prototype.toString, gb = /* @__PURE__ */ (() => {
  const e = function() {
  };
  return e.prototype = /* @__PURE__ */ Object.create(null), e;
})();
function yb(e, t) {
  const r = new gb(), n = e.length;
  if (n < 2)
    return r;
  const o = (t == null ? void 0 : t.decode) || bb;
  let a = 0;
  do {
    const s = e.indexOf("=", a);
    if (s === -1)
      break;
    const l = e.indexOf(";", a), c = l === -1 ? n : l;
    if (s > c) {
      a = e.lastIndexOf(";", s - 1) + 1;
      continue;
    }
    const u = fl(e, a, s), p = ml(e, s, u), f = e.slice(u, p);
    if (r[f] === void 0) {
      let g = fl(e, s + 1, c), v = ml(e, c, g);
      const y = o(e.slice(g, v));
      r[f] = y;
    }
    a = c + 1;
  } while (a < n);
  return r;
}
function fl(e, t, r) {
  do {
    const n = e.charCodeAt(t);
    if (n !== 32 && n !== 9)
      return t;
  } while (++t < r);
  return r;
}
function ml(e, t, r) {
  for (; t > r; ) {
    const n = e.charCodeAt(--t);
    if (n !== 32 && n !== 9)
      return t + 1;
  }
  return r;
}
function vb(e, t, r) {
  const n = (r == null ? void 0 : r.encode) || encodeURIComponent;
  if (!db.test(e))
    throw new TypeError(`argument name is invalid: ${e}`);
  const o = n(t);
  if (!pb.test(o))
    throw new TypeError(`argument val is invalid: ${t}`);
  let a = e + "=" + o;
  if (!r)
    return a;
  if (r.maxAge !== void 0) {
    if (!Number.isInteger(r.maxAge))
      throw new TypeError(`option maxAge is invalid: ${r.maxAge}`);
    a += "; Max-Age=" + r.maxAge;
  }
  if (r.domain) {
    if (!fb.test(r.domain))
      throw new TypeError(`option domain is invalid: ${r.domain}`);
    a += "; Domain=" + r.domain;
  }
  if (r.path) {
    if (!mb.test(r.path))
      throw new TypeError(`option path is invalid: ${r.path}`);
    a += "; Path=" + r.path;
  }
  if (r.expires) {
    if (!xb(r.expires) || !Number.isFinite(r.expires.valueOf()))
      throw new TypeError(`option expires is invalid: ${r.expires}`);
    a += "; Expires=" + r.expires.toUTCString();
  }
  if (r.httpOnly && (a += "; HttpOnly"), r.secure && (a += "; Secure"), r.partitioned && (a += "; Partitioned"), r.priority)
    switch (typeof r.priority == "string" ? r.priority.toLowerCase() : void 0) {
      case "low":
        a += "; Priority=Low";
        break;
      case "medium":
        a += "; Priority=Medium";
        break;
      case "high":
        a += "; Priority=High";
        break;
      default:
        throw new TypeError(`option priority is invalid: ${r.priority}`);
    }
  if (r.sameSite)
    switch (typeof r.sameSite == "string" ? r.sameSite.toLowerCase() : r.sameSite) {
      case !0:
      case "strict":
        a += "; SameSite=Strict";
        break;
      case "lax":
        a += "; SameSite=Lax";
        break;
      case "none":
        a += "; SameSite=None";
        break;
      default:
        throw new TypeError(`option sameSite is invalid: ${r.sameSite}`);
    }
  return a;
}
function bb(e) {
  if (e.indexOf("%") === -1)
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}
function xb(e) {
  return hb.call(e) === "[object Date]";
}
/**
 * react-router v7.6.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Ze(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function Vt(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function Ui({
  pathname: e = "/",
  search: t = "",
  hash: r = ""
}) {
  return t && t !== "?" && (e += t.charAt(0) === "?" ? t : "?" + t), r && r !== "#" && (e += r.charAt(0) === "#" ? r : "#" + r), e;
}
function Ma(e) {
  let t = {};
  if (e) {
    let r = e.indexOf("#");
    r >= 0 && (t.hash = e.substring(r), e = e.substring(0, r));
    let n = e.indexOf("?");
    n >= 0 && (t.search = e.substring(n), e = e.substring(0, n)), e && (t.pathname = e);
  }
  return t;
}
function su(e, t, r = "/") {
  return Eb(e, t, r, !1);
}
function Eb(e, t, r, n) {
  let o = typeof t == "string" ? Ma(t) : t, a = lr(o.pathname || "/", r);
  if (a == null)
    return null;
  let s = lu(e);
  Cb(s);
  let l = null;
  for (let c = 0; l == null && c < s.length; ++c) {
    let u = Ab(a);
    l = Ib(
      s[c],
      u,
      n
    );
  }
  return l;
}
function lu(e, t = [], r = [], n = "") {
  let o = (a, s, l) => {
    let c = {
      relativePath: l === void 0 ? a.path || "" : l,
      caseSensitive: a.caseSensitive === !0,
      childrenIndex: s,
      route: a
    };
    c.relativePath.startsWith("/") && (Ze(
      c.relativePath.startsWith(n),
      `Absolute route path "${c.relativePath}" nested under path "${n}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`
    ), c.relativePath = c.relativePath.slice(n.length));
    let u = Xt([n, c.relativePath]), p = r.concat(c);
    a.children && a.children.length > 0 && (Ze(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      a.index !== !0,
      `Index routes must not have child routes. Please remove all child routes from route path "${u}".`
    ), lu(a.children, t, p, u)), !(a.path == null && !a.index) && t.push({
      path: u,
      score: $b(u, a.index),
      routesMeta: p
    });
  };
  return e.forEach((a, s) => {
    var l;
    if (a.path === "" || !((l = a.path) != null && l.includes("?")))
      o(a, s);
    else
      for (let c of cu(a.path))
        o(a, s, c);
  }), t;
}
function cu(e) {
  let t = e.split("/");
  if (t.length === 0) return [];
  let [r, ...n] = t, o = r.endsWith("?"), a = r.replace(/\?$/, "");
  if (n.length === 0)
    return o ? [a, ""] : [a];
  let s = cu(n.join("/")), l = [];
  return l.push(
    ...s.map(
      (c) => c === "" ? a : [a, c].join("/")
    )
  ), o && l.push(...s), l.map(
    (c) => e.startsWith("/") && c === "" ? "/" : c
  );
}
function Cb(e) {
  e.sort(
    (t, r) => t.score !== r.score ? r.score - t.score : kb(
      t.routesMeta.map((n) => n.childrenIndex),
      r.routesMeta.map((n) => n.childrenIndex)
    )
  );
}
var Tb = /^:[\w-]+$/, Sb = 3, wb = 2, Ob = 1, Rb = 10, Pb = -2, hl = (e) => e === "*";
function $b(e, t) {
  let r = e.split("/"), n = r.length;
  return r.some(hl) && (n += Pb), t && (n += wb), r.filter((o) => !hl(o)).reduce(
    (o, a) => o + (Tb.test(a) ? Sb : a === "" ? Ob : Rb),
    n
  );
}
function kb(e, t) {
  return e.length === t.length && e.slice(0, -1).every((n, o) => n === t[o]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    e[e.length - 1] - t[t.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function Ib(e, t, r = !1) {
  let { routesMeta: n } = e, o = {}, a = "/", s = [];
  for (let l = 0; l < n.length; ++l) {
    let c = n[l], u = l === n.length - 1, p = a === "/" ? t : t.slice(a.length) || "/", f = Co(
      { path: c.relativePath, caseSensitive: c.caseSensitive, end: u },
      p
    ), g = c.route;
    if (!f && u && r && !n[n.length - 1].route.index && (f = Co(
      {
        path: c.relativePath,
        caseSensitive: c.caseSensitive,
        end: !1
      },
      p
    )), !f)
      return null;
    Object.assign(o, f.params), s.push({
      // TODO: Can this as be avoided?
      params: o,
      pathname: Xt([a, f.pathname]),
      pathnameBase: Db(
        Xt([a, f.pathnameBase])
      ),
      route: g
    }), f.pathnameBase !== "/" && (a = Xt([a, f.pathnameBase]));
  }
  return s;
}
function Co(e, t) {
  typeof e == "string" && (e = { path: e, caseSensitive: !1, end: !0 });
  let [r, n] = Nb(
    e.path,
    e.caseSensitive,
    e.end
  ), o = t.match(r);
  if (!o) return null;
  let a = o[0], s = a.replace(/(.)\/+$/, "$1"), l = o.slice(1);
  return {
    params: n.reduce(
      (u, { paramName: p, isOptional: f }, g) => {
        if (p === "*") {
          let y = l[g] || "";
          s = a.slice(0, a.length - y.length).replace(/(.)\/+$/, "$1");
        }
        const v = l[g];
        return f && !v ? u[p] = void 0 : u[p] = (v || "").replace(/%2F/g, "/"), u;
      },
      {}
    ),
    pathname: a,
    pathnameBase: s,
    pattern: e
  };
}
function Nb(e, t = !1, r = !0) {
  Vt(
    e === "*" || !e.endsWith("*") || e.endsWith("/*"),
    `Route path "${e}" will be treated as if it were "${e.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${e.replace(/\*$/, "/*")}".`
  );
  let n = [], o = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(
    /\/:([\w-]+)(\?)?/g,
    (s, l, c) => (n.push({ paramName: l, isOptional: c != null }), c ? "/?([^\\/]+)?" : "/([^\\/]+)")
  );
  return e.endsWith("*") ? (n.push({ paramName: "*" }), o += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : r ? o += "\\/*$" : e !== "" && e !== "/" && (o += "(?:(?=\\/|$))"), [new RegExp(o, t ? void 0 : "i"), n];
}
function Ab(e) {
  try {
    return e.split("/").map((t) => decodeURIComponent(t).replace(/\//g, "%2F")).join("/");
  } catch (t) {
    return Vt(
      !1,
      `The URL path "${e}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${t}).`
    ), e;
  }
}
function lr(e, t) {
  if (t === "/") return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let r = t.endsWith("/") ? t.length - 1 : t.length, n = e.charAt(r);
  return n && n !== "/" ? null : e.slice(r) || "/";
}
function Mb(e, t = "/") {
  let {
    pathname: r,
    search: n = "",
    hash: o = ""
  } = typeof e == "string" ? Ma(e) : e;
  return {
    pathname: r ? r.startsWith("/") ? r : jb(r, t) : t,
    search: Lb(n),
    hash: Bb(o)
  };
}
function jb(e, t) {
  let r = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((o) => {
    o === ".." ? r.length > 1 && r.pop() : o !== "." && r.push(o);
  }), r.length > 1 ? r.join("/") : "/";
}
function yi(e, t, r, n) {
  return `Cannot include a '${e}' character in a manually specified \`to.${t}\` field [${JSON.stringify(
    n
  )}].  Please separate it out to the \`to.${r}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function _b(e) {
  return e.filter(
    (t, r) => r === 0 || t.route.path && t.route.path.length > 0
  );
}
function ja(e) {
  let t = _b(e);
  return t.map(
    (r, n) => n === t.length - 1 ? r.pathname : r.pathnameBase
  );
}
function _a(e, t, r, n = !1) {
  let o;
  typeof e == "string" ? o = Ma(e) : (o = { ...e }, Ze(
    !o.pathname || !o.pathname.includes("?"),
    yi("?", "pathname", "search", o)
  ), Ze(
    !o.pathname || !o.pathname.includes("#"),
    yi("#", "pathname", "hash", o)
  ), Ze(
    !o.search || !o.search.includes("#"),
    yi("#", "search", "hash", o)
  ));
  let a = e === "" || o.pathname === "", s = a ? "/" : o.pathname, l;
  if (s == null)
    l = r;
  else {
    let f = t.length - 1;
    if (!n && s.startsWith("..")) {
      let g = s.split("/");
      for (; g[0] === ".."; )
        g.shift(), f -= 1;
      o.pathname = g.join("/");
    }
    l = f >= 0 ? t[f] : "/";
  }
  let c = Mb(o, l), u = s && s !== "/" && s.endsWith("/"), p = (a || s === ".") && r.endsWith("/");
  return !c.pathname.endsWith("/") && (u || p) && (c.pathname += "/"), c;
}
var Xt = (e) => e.join("/").replace(/\/\/+/g, "/"), Db = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"), Lb = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, Bb = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e;
function Fb(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.internal == "boolean" && "data" in e;
}
var uu = [
  "POST",
  "PUT",
  "PATCH",
  "DELETE"
];
new Set(
  uu
);
var Vb = [
  "GET",
  ...uu
];
new Set(Vb);
var Fr = h.createContext(null);
Fr.displayName = "DataRouter";
var Ko = h.createContext(null);
Ko.displayName = "DataRouterState";
var du = h.createContext({
  isTransitioning: !1
});
du.displayName = "ViewTransition";
var zb = h.createContext(
  /* @__PURE__ */ new Map()
);
zb.displayName = "Fetchers";
var Wb = h.createContext(null);
Wb.displayName = "Await";
var Ut = h.createContext(
  null
);
Ut.displayName = "Navigation";
var Da = h.createContext(
  null
);
Da.displayName = "Location";
var Ht = h.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
Ht.displayName = "Route";
var La = h.createContext(null);
La.displayName = "RouteError";
function Ub(e, { relative: t } = {}) {
  Ze(
    In(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  );
  let { basename: r, navigator: n } = h.useContext(Ut), { hash: o, pathname: a, search: s } = Nn(e, { relative: t }), l = a;
  return r !== "/" && (l = a === "/" ? r : Xt([r, a])), n.createHref({ pathname: l, search: s, hash: o });
}
function In() {
  return h.useContext(Da) != null;
}
function dr() {
  return Ze(
    In(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ), h.useContext(Da).location;
}
var pu = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function fu(e) {
  h.useContext(Ut).static || h.useLayoutEffect(e);
}
function mu() {
  let { isDataRoute: e } = h.useContext(Ht);
  return e ? n0() : Hb();
}
function Hb() {
  Ze(
    In(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  );
  let e = h.useContext(Fr), { basename: t, navigator: r } = h.useContext(Ut), { matches: n } = h.useContext(Ht), { pathname: o } = dr(), a = JSON.stringify(ja(n)), s = h.useRef(!1);
  return fu(() => {
    s.current = !0;
  }), h.useCallback(
    (c, u = {}) => {
      if (Vt(s.current, pu), !s.current) return;
      if (typeof c == "number") {
        r.go(c);
        return;
      }
      let p = _a(
        c,
        JSON.parse(a),
        o,
        u.relative === "path"
      );
      e == null && t !== "/" && (p.pathname = p.pathname === "/" ? t : Xt([t, p.pathname])), (u.replace ? r.replace : r.push)(
        p,
        u.state,
        u
      );
    },
    [
      t,
      r,
      a,
      o,
      e
    ]
  );
}
h.createContext(null);
function Nn(e, { relative: t } = {}) {
  let { matches: r } = h.useContext(Ht), { pathname: n } = dr(), o = JSON.stringify(ja(r));
  return h.useMemo(
    () => _a(
      e,
      JSON.parse(o),
      n,
      t === "path"
    ),
    [e, o, n, t]
  );
}
function Yb(e, t, r, n) {
  Ze(
    In(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  );
  let { navigator: o } = h.useContext(Ut), { matches: a } = h.useContext(Ht), s = a[a.length - 1], l = s ? s.params : {}, c = s ? s.pathname : "/", u = s ? s.pathnameBase : "/", p = s && s.route;
  {
    let b = p && p.path || "";
    hu(
      c,
      !p || b.endsWith("*") || b.endsWith("*?"),
      `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${c}" (under <Route path="${b}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${b}"> to <Route path="${b === "/" ? "*" : `${b}/*`}">.`
    );
  }
  let f = dr(), g;
  g = f;
  let v = g.pathname || "/", y = v;
  if (u !== "/") {
    let b = u.replace(/^\//, "").split("/");
    y = "/" + v.replace(/^\//, "").split("/").slice(b.length).join("/");
  }
  let d = su(e, { pathname: y });
  return Vt(
    p || d != null,
    `No routes matched location "${g.pathname}${g.search}${g.hash}" `
  ), Vt(
    d == null || d[d.length - 1].route.element !== void 0 || d[d.length - 1].route.Component !== void 0 || d[d.length - 1].route.lazy !== void 0,
    `Matched leaf route at location "${g.pathname}${g.search}${g.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`
  ), Jb(
    d && d.map(
      (b) => Object.assign({}, b, {
        params: Object.assign({}, l, b.params),
        pathname: Xt([
          u,
          // Re-encode pathnames that were decoded inside matchRoutes
          o.encodeLocation ? o.encodeLocation(b.pathname).pathname : b.pathname
        ]),
        pathnameBase: b.pathnameBase === "/" ? u : Xt([
          u,
          // Re-encode pathnames that were decoded inside matchRoutes
          o.encodeLocation ? o.encodeLocation(b.pathnameBase).pathname : b.pathnameBase
        ])
      })
    ),
    a,
    r,
    n
  );
}
function qb() {
  let e = r0(), t = Fb(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : JSON.stringify(e), r = e instanceof Error ? e.stack : null, n = "rgba(200,200,200, 0.5)", o = { padding: "0.5rem", backgroundColor: n }, a = { padding: "2px 4px", backgroundColor: n }, s = null;
  return console.error(
    "Error handled by React Router default ErrorBoundary:",
    e
  ), s = /* @__PURE__ */ h.createElement(h.Fragment, null, /* @__PURE__ */ h.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ h.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ h.createElement("code", { style: a }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ h.createElement("code", { style: a }, "errorElement"), " prop on your route.")), /* @__PURE__ */ h.createElement(h.Fragment, null, /* @__PURE__ */ h.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ h.createElement("h3", { style: { fontStyle: "italic" } }, t), r ? /* @__PURE__ */ h.createElement("pre", { style: o }, r) : null, s);
}
var Kb = /* @__PURE__ */ h.createElement(qb, null), Gb = class extends h.Component {
  constructor(e) {
    super(e), this.state = {
      location: e.location,
      revalidation: e.revalidation,
      error: e.error
    };
  }
  static getDerivedStateFromError(e) {
    return { error: e };
  }
  static getDerivedStateFromProps(e, t) {
    return t.location !== e.location || t.revalidation !== "idle" && e.revalidation === "idle" ? {
      error: e.error,
      location: e.location,
      revalidation: e.revalidation
    } : {
      error: e.error !== void 0 ? e.error : t.error,
      location: t.location,
      revalidation: e.revalidation || t.revalidation
    };
  }
  componentDidCatch(e, t) {
    console.error(
      "React Router caught the following error during render",
      e,
      t
    );
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ h.createElement(Ht.Provider, { value: this.props.routeContext }, /* @__PURE__ */ h.createElement(
      La.Provider,
      {
        value: this.state.error,
        children: this.props.component
      }
    )) : this.props.children;
  }
};
function Xb({ routeContext: e, match: t, children: r }) {
  let n = h.useContext(Fr);
  return n && n.static && n.staticContext && (t.route.errorElement || t.route.ErrorBoundary) && (n.staticContext._deepestRenderedBoundaryId = t.route.id), /* @__PURE__ */ h.createElement(Ht.Provider, { value: e }, r);
}
function Jb(e, t = [], r = null, n = null) {
  if (e == null) {
    if (!r)
      return null;
    if (r.errors)
      e = r.matches;
    else if (t.length === 0 && !r.initialized && r.matches.length > 0)
      e = r.matches;
    else
      return null;
  }
  let o = e, a = r == null ? void 0 : r.errors;
  if (a != null) {
    let c = o.findIndex(
      (u) => u.route.id && (a == null ? void 0 : a[u.route.id]) !== void 0
    );
    Ze(
      c >= 0,
      `Could not find a matching route for errors on route IDs: ${Object.keys(
        a
      ).join(",")}`
    ), o = o.slice(
      0,
      Math.min(o.length, c + 1)
    );
  }
  let s = !1, l = -1;
  if (r)
    for (let c = 0; c < o.length; c++) {
      let u = o[c];
      if ((u.route.HydrateFallback || u.route.hydrateFallbackElement) && (l = c), u.route.id) {
        let { loaderData: p, errors: f } = r, g = u.route.loader && !p.hasOwnProperty(u.route.id) && (!f || f[u.route.id] === void 0);
        if (u.route.lazy || g) {
          s = !0, l >= 0 ? o = o.slice(0, l + 1) : o = [o[0]];
          break;
        }
      }
    }
  return o.reduceRight((c, u, p) => {
    let f, g = !1, v = null, y = null;
    r && (f = a && u.route.id ? a[u.route.id] : void 0, v = u.route.errorElement || Kb, s && (l < 0 && p === 0 ? (hu(
      "route-fallback",
      !1,
      "No `HydrateFallback` element provided to render during initial hydration"
    ), g = !0, y = null) : l === p && (g = !0, y = u.route.hydrateFallbackElement || null)));
    let d = t.concat(o.slice(0, p + 1)), x = () => {
      let b;
      return f ? b = v : g ? b = y : u.route.Component ? b = /* @__PURE__ */ h.createElement(u.route.Component, null) : u.route.element ? b = u.route.element : b = c, /* @__PURE__ */ h.createElement(
        Xb,
        {
          match: u,
          routeContext: {
            outlet: c,
            matches: d,
            isDataRoute: r != null
          },
          children: b
        }
      );
    };
    return r && (u.route.ErrorBoundary || u.route.errorElement || p === 0) ? /* @__PURE__ */ h.createElement(
      Gb,
      {
        location: r.location,
        revalidation: r.revalidation,
        component: v,
        error: f,
        children: x(),
        routeContext: { outlet: null, matches: d, isDataRoute: !0 }
      }
    ) : x();
  }, null);
}
function Ba(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function Zb(e) {
  let t = h.useContext(Fr);
  return Ze(t, Ba(e)), t;
}
function Qb(e) {
  let t = h.useContext(Ko);
  return Ze(t, Ba(e)), t;
}
function e0(e) {
  let t = h.useContext(Ht);
  return Ze(t, Ba(e)), t;
}
function Fa(e) {
  let t = e0(e), r = t.matches[t.matches.length - 1];
  return Ze(
    r.route.id,
    `${e} can only be used on routes that contain a unique "id"`
  ), r.route.id;
}
function t0() {
  return Fa(
    "useRouteId"
    /* UseRouteId */
  );
}
function r0() {
  var n;
  let e = h.useContext(La), t = Qb(
    "useRouteError"
    /* UseRouteError */
  ), r = Fa(
    "useRouteError"
    /* UseRouteError */
  );
  return e !== void 0 ? e : (n = t.errors) == null ? void 0 : n[r];
}
function n0() {
  let { router: e } = Zb(
    "useNavigate"
    /* UseNavigateStable */
  ), t = Fa(
    "useNavigate"
    /* UseNavigateStable */
  ), r = h.useRef(!1);
  return fu(() => {
    r.current = !0;
  }), h.useCallback(
    async (o, a = {}) => {
      Vt(r.current, pu), r.current && (typeof o == "number" ? e.navigate(o) : await e.navigate(o, { fromRouteId: t, ...a }));
    },
    [e, t]
  );
}
var gl = {};
function hu(e, t, r) {
  !t && !gl[e] && (gl[e] = !0, Vt(!1, r));
}
h.memo(o0);
function o0({
  routes: e,
  future: t,
  state: r
}) {
  return Yb(e, void 0, r, t);
}
function i0({
  to: e,
  replace: t,
  state: r,
  relative: n
}) {
  Ze(
    In(),
    // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component."
  );
  let { static: o } = h.useContext(Ut);
  Vt(
    !o,
    "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change."
  );
  let { matches: a } = h.useContext(Ht), { pathname: s } = dr(), l = mu(), c = _a(
    e,
    ja(a),
    s,
    n === "path"
  ), u = JSON.stringify(c);
  return h.useEffect(() => {
    l(JSON.parse(u), { replace: t, state: r, relative: n });
  }, [l, u, n, t, r]), null;
}
var no = "get", oo = "application/x-www-form-urlencoded";
function Go(e) {
  return e != null && typeof e.tagName == "string";
}
function a0(e) {
  return Go(e) && e.tagName.toLowerCase() === "button";
}
function s0(e) {
  return Go(e) && e.tagName.toLowerCase() === "form";
}
function l0(e) {
  return Go(e) && e.tagName.toLowerCase() === "input";
}
function c0(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function u0(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !c0(e);
}
var qn = null;
function d0() {
  if (qn === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), qn = !1;
    } catch {
      qn = !0;
    }
  return qn;
}
var p0 = /* @__PURE__ */ new Set([
  "application/x-www-form-urlencoded",
  "multipart/form-data",
  "text/plain"
]);
function vi(e) {
  return e != null && !p0.has(e) ? (Vt(
    !1,
    `"${e}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${oo}"`
  ), null) : e;
}
function f0(e, t) {
  let r, n, o, a, s;
  if (s0(e)) {
    let l = e.getAttribute("action");
    n = l ? lr(l, t) : null, r = e.getAttribute("method") || no, o = vi(e.getAttribute("enctype")) || oo, a = new FormData(e);
  } else if (a0(e) || l0(e) && (e.type === "submit" || e.type === "image")) {
    let l = e.form;
    if (l == null)
      throw new Error(
        'Cannot submit a <button> or <input type="submit"> without a <form>'
      );
    let c = e.getAttribute("formaction") || l.getAttribute("action");
    if (n = c ? lr(c, t) : null, r = e.getAttribute("formmethod") || l.getAttribute("method") || no, o = vi(e.getAttribute("formenctype")) || vi(l.getAttribute("enctype")) || oo, a = new FormData(l, e), !d0()) {
      let { name: u, type: p, value: f } = e;
      if (p === "image") {
        let g = u ? `${u}.` : "";
        a.append(`${g}x`, "0"), a.append(`${g}y`, "0");
      } else u && a.append(u, f);
    }
  } else {
    if (Go(e))
      throw new Error(
        'Cannot submit element that is not <form>, <button>, or <input type="submit|image">'
      );
    r = no, n = null, o = oo, s = e;
  }
  return a && o === "text/plain" && (s = a, a = void 0), { action: n, method: r.toLowerCase(), encType: o, formData: a, body: s };
}
function Va(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
async function m0(e, t) {
  if (e.id in t)
    return t[e.id];
  try {
    let r = await import(
      /* @vite-ignore */
      /* webpackIgnore: true */
      e.module
    );
    return t[e.id] = r, r;
  } catch (r) {
    return console.error(
      `Error loading route module \`${e.module}\`, reloading page...`
    ), console.error(r), window.__reactRouterContext && window.__reactRouterContext.isSpaMode, window.location.reload(), new Promise(() => {
    });
  }
}
function h0(e) {
  return e == null ? !1 : e.href == null ? e.rel === "preload" && typeof e.imageSrcSet == "string" && typeof e.imageSizes == "string" : typeof e.rel == "string" && typeof e.href == "string";
}
async function g0(e, t, r) {
  let n = await Promise.all(
    e.map(async (o) => {
      let a = t.routes[o.route.id];
      if (a) {
        let s = await m0(a, r);
        return s.links ? s.links() : [];
      }
      return [];
    })
  );
  return x0(
    n.flat(1).filter(h0).filter((o) => o.rel === "stylesheet" || o.rel === "preload").map(
      (o) => o.rel === "stylesheet" ? { ...o, rel: "prefetch", as: "style" } : { ...o, rel: "prefetch" }
    )
  );
}
function yl(e, t, r, n, o, a) {
  let s = (c, u) => r[u] ? c.route.id !== r[u].route.id : !0, l = (c, u) => {
    var p;
    return (
      // param change, /users/123 -> /users/456
      r[u].pathname !== c.pathname || // splat param changed, which is not present in match.path
      // e.g. /files/images/avatar.jpg -> files/finances.xls
      ((p = r[u].route.path) == null ? void 0 : p.endsWith("*")) && r[u].params["*"] !== c.params["*"]
    );
  };
  return a === "assets" ? t.filter(
    (c, u) => s(c, u) || l(c, u)
  ) : a === "data" ? t.filter((c, u) => {
    var f;
    let p = n.routes[c.route.id];
    if (!p || !p.hasLoader)
      return !1;
    if (s(c, u) || l(c, u))
      return !0;
    if (c.route.shouldRevalidate) {
      let g = c.route.shouldRevalidate({
        currentUrl: new URL(
          o.pathname + o.search + o.hash,
          window.origin
        ),
        currentParams: ((f = r[0]) == null ? void 0 : f.params) || {},
        nextUrl: new URL(e, window.origin),
        nextParams: c.params,
        defaultShouldRevalidate: !0
      });
      if (typeof g == "boolean")
        return g;
    }
    return !0;
  }) : [];
}
function y0(e, t, { includeHydrateFallback: r } = {}) {
  return v0(
    e.map((n) => {
      let o = t.routes[n.route.id];
      if (!o) return [];
      let a = [o.module];
      return o.clientActionModule && (a = a.concat(o.clientActionModule)), o.clientLoaderModule && (a = a.concat(o.clientLoaderModule)), r && o.hydrateFallbackModule && (a = a.concat(o.hydrateFallbackModule)), o.imports && (a = a.concat(o.imports)), a;
    }).flat(1)
  );
}
function v0(e) {
  return [...new Set(e)];
}
function b0(e) {
  let t = {}, r = Object.keys(e).sort();
  for (let n of r)
    t[n] = e[n];
  return t;
}
function x0(e, t) {
  let r = /* @__PURE__ */ new Set();
  return new Set(t), e.reduce((n, o) => {
    let a = JSON.stringify(b0(o));
    return r.has(a) || (r.add(a), n.push({ key: a, link: o })), n;
  }, []);
}
Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
var E0 = /* @__PURE__ */ new Set([100, 101, 204, 205]);
function C0(e, t) {
  let r = typeof e == "string" ? new URL(
    e,
    // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window > "u" ? "server://singlefetch/" : window.location.origin
  ) : e;
  return r.pathname === "/" ? r.pathname = "_root.data" : t && lr(r.pathname, t) === "/" ? r.pathname = `${t.replace(/\/$/, "")}/_root.data` : r.pathname = `${r.pathname.replace(/\/$/, "")}.data`, r;
}
function gu() {
  let e = h.useContext(Fr);
  return Va(
    e,
    "You must render this element inside a <DataRouterContext.Provider> element"
  ), e;
}
function T0() {
  let e = h.useContext(Ko);
  return Va(
    e,
    "You must render this element inside a <DataRouterStateContext.Provider> element"
  ), e;
}
var za = h.createContext(void 0);
za.displayName = "FrameworkContext";
function yu() {
  let e = h.useContext(za);
  return Va(
    e,
    "You must render this element inside a <HydratedRouter> element"
  ), e;
}
function S0(e, t) {
  let r = h.useContext(za), [n, o] = h.useState(!1), [a, s] = h.useState(!1), { onFocus: l, onBlur: c, onMouseEnter: u, onMouseLeave: p, onTouchStart: f } = t, g = h.useRef(null);
  h.useEffect(() => {
    if (e === "render" && s(!0), e === "viewport") {
      let d = (b) => {
        b.forEach((O) => {
          s(O.isIntersecting);
        });
      }, x = new IntersectionObserver(d, { threshold: 0.5 });
      return g.current && x.observe(g.current), () => {
        x.disconnect();
      };
    }
  }, [e]), h.useEffect(() => {
    if (n) {
      let d = setTimeout(() => {
        s(!0);
      }, 100);
      return () => {
        clearTimeout(d);
      };
    }
  }, [n]);
  let v = () => {
    o(!0);
  }, y = () => {
    o(!1), s(!1);
  };
  return r ? e !== "intent" ? [a, g, {}] : [
    a,
    g,
    {
      onFocus: en(l, v),
      onBlur: en(c, y),
      onMouseEnter: en(u, v),
      onMouseLeave: en(p, y),
      onTouchStart: en(f, v)
    }
  ] : [!1, g, {}];
}
function en(e, t) {
  return (r) => {
    e && e(r), r.defaultPrevented || t(r);
  };
}
function w0({
  page: e,
  ...t
}) {
  let { router: r } = gu(), n = h.useMemo(
    () => su(r.routes, e, r.basename),
    [r.routes, e, r.basename]
  );
  return n ? /* @__PURE__ */ h.createElement(R0, { page: e, matches: n, ...t }) : null;
}
function O0(e) {
  let { manifest: t, routeModules: r } = yu(), [n, o] = h.useState([]);
  return h.useEffect(() => {
    let a = !1;
    return g0(e, t, r).then(
      (s) => {
        a || o(s);
      }
    ), () => {
      a = !0;
    };
  }, [e, t, r]), n;
}
function R0({
  page: e,
  matches: t,
  ...r
}) {
  let n = dr(), { manifest: o, routeModules: a } = yu(), { basename: s } = gu(), { loaderData: l, matches: c } = T0(), u = h.useMemo(
    () => yl(
      e,
      t,
      c,
      o,
      n,
      "data"
    ),
    [e, t, c, o, n]
  ), p = h.useMemo(
    () => yl(
      e,
      t,
      c,
      o,
      n,
      "assets"
    ),
    [e, t, c, o, n]
  ), f = h.useMemo(() => {
    if (e === n.pathname + n.search + n.hash)
      return [];
    let y = /* @__PURE__ */ new Set(), d = !1;
    if (t.forEach((b) => {
      var T;
      let O = o.routes[b.route.id];
      !O || !O.hasLoader || (!u.some((E) => E.route.id === b.route.id) && b.route.id in l && ((T = a[b.route.id]) != null && T.shouldRevalidate) || O.hasClientLoader ? d = !0 : y.add(b.route.id));
    }), y.size === 0)
      return [];
    let x = C0(e, s);
    return d && y.size > 0 && x.searchParams.set(
      "_routes",
      t.filter((b) => y.has(b.route.id)).map((b) => b.route.id).join(",")
    ), [x.pathname + x.search];
  }, [
    s,
    l,
    n,
    o,
    u,
    t,
    e,
    a
  ]), g = h.useMemo(
    () => y0(p, o),
    [p, o]
  ), v = O0(p);
  return /* @__PURE__ */ h.createElement(h.Fragment, null, f.map((y) => /* @__PURE__ */ h.createElement("link", { key: y, rel: "prefetch", as: "fetch", href: y, ...r })), g.map((y) => /* @__PURE__ */ h.createElement("link", { key: y, rel: "modulepreload", href: y, ...r })), v.map(({ key: y, link: d }) => (
    // these don't spread `linkProps` because they are full link descriptors
    // already with their own props
    /* @__PURE__ */ h.createElement("link", { key: y, ...d })
  )));
}
function P0(...e) {
  return (t) => {
    e.forEach((r) => {
      typeof r == "function" ? r(t) : r != null && (r.current = t);
    });
  };
}
var vu = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
try {
  vu && (window.__reactRouterVersion = "7.6.1");
} catch {
}
var bu = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, xu = h.forwardRef(
  function({
    onClick: t,
    discover: r = "render",
    prefetch: n = "none",
    relative: o,
    reloadDocument: a,
    replace: s,
    state: l,
    target: c,
    to: u,
    preventScrollReset: p,
    viewTransition: f,
    ...g
  }, v) {
    let { basename: y } = h.useContext(Ut), d = typeof u == "string" && bu.test(u), x, b = !1;
    if (typeof u == "string" && d && (x = u, vu))
      try {
        let I = new URL(window.location.href), m = u.startsWith("//") ? new URL(I.protocol + u) : new URL(u), R = lr(m.pathname, y);
        m.origin === I.origin && R != null ? u = R + m.search + m.hash : b = !0;
      } catch {
        Vt(
          !1,
          `<Link to="${u}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`
        );
      }
    let O = Ub(u, { relative: o }), [T, E, C] = S0(
      n,
      g
    ), $ = N0(u, {
      replace: s,
      state: l,
      target: c,
      preventScrollReset: p,
      relative: o,
      viewTransition: f
    });
    function P(I) {
      t && t(I), I.defaultPrevented || $(I);
    }
    let k = (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      /* @__PURE__ */ h.createElement(
        "a",
        {
          ...g,
          ...C,
          href: x || O,
          onClick: b || a ? t : P,
          ref: P0(v, E),
          target: c,
          "data-discover": !d && r === "render" ? "true" : void 0
        }
      )
    );
    return T && !d ? /* @__PURE__ */ h.createElement(h.Fragment, null, k, /* @__PURE__ */ h.createElement(w0, { page: O })) : k;
  }
);
xu.displayName = "Link";
var $0 = h.forwardRef(
  function({
    "aria-current": t = "page",
    caseSensitive: r = !1,
    className: n = "",
    end: o = !1,
    style: a,
    to: s,
    viewTransition: l,
    children: c,
    ...u
  }, p) {
    let f = Nn(s, { relative: u.relative }), g = dr(), v = h.useContext(Ko), { navigator: y, basename: d } = h.useContext(Ut), x = v != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    D0(f) && l === !0, b = y.encodeLocation ? y.encodeLocation(f).pathname : f.pathname, O = g.pathname, T = v && v.navigation && v.navigation.location ? v.navigation.location.pathname : null;
    r || (O = O.toLowerCase(), T = T ? T.toLowerCase() : null, b = b.toLowerCase()), T && d && (T = lr(T, d) || T);
    const E = b !== "/" && b.endsWith("/") ? b.length - 1 : b.length;
    let C = O === b || !o && O.startsWith(b) && O.charAt(E) === "/", $ = T != null && (T === b || !o && T.startsWith(b) && T.charAt(b.length) === "/"), P = {
      isActive: C,
      isPending: $,
      isTransitioning: x
    }, k = C ? t : void 0, I;
    typeof n == "function" ? I = n(P) : I = [
      n,
      C ? "active" : null,
      $ ? "pending" : null,
      x ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let m = typeof a == "function" ? a(P) : a;
    return /* @__PURE__ */ h.createElement(
      xu,
      {
        ...u,
        "aria-current": k,
        className: I,
        ref: p,
        style: m,
        to: s,
        viewTransition: l
      },
      typeof c == "function" ? c(P) : c
    );
  }
);
$0.displayName = "NavLink";
var k0 = h.forwardRef(
  ({
    discover: e = "render",
    fetcherKey: t,
    navigate: r,
    reloadDocument: n,
    replace: o,
    state: a,
    method: s = no,
    action: l,
    onSubmit: c,
    relative: u,
    preventScrollReset: p,
    viewTransition: f,
    ...g
  }, v) => {
    let y = j0(), d = _0(l, { relative: u }), x = s.toLowerCase() === "get" ? "get" : "post", b = typeof l == "string" && bu.test(l), O = (T) => {
      if (c && c(T), T.defaultPrevented) return;
      T.preventDefault();
      let E = T.nativeEvent.submitter, C = (E == null ? void 0 : E.getAttribute("formmethod")) || s;
      y(E || T.currentTarget, {
        fetcherKey: t,
        method: C,
        navigate: r,
        replace: o,
        state: a,
        relative: u,
        preventScrollReset: p,
        viewTransition: f
      });
    };
    return /* @__PURE__ */ h.createElement(
      "form",
      {
        ref: v,
        method: x,
        action: d,
        onSubmit: n ? c : O,
        ...g,
        "data-discover": !b && e === "render" ? "true" : void 0
      }
    );
  }
);
k0.displayName = "Form";
function I0(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function Eu(e) {
  let t = h.useContext(Fr);
  return Ze(t, I0(e)), t;
}
function N0(e, {
  target: t,
  replace: r,
  state: n,
  preventScrollReset: o,
  relative: a,
  viewTransition: s
} = {}) {
  let l = mu(), c = dr(), u = Nn(e, { relative: a });
  return h.useCallback(
    (p) => {
      if (u0(p, t)) {
        p.preventDefault();
        let f = r !== void 0 ? r : Ui(c) === Ui(u);
        l(e, {
          replace: f,
          state: n,
          preventScrollReset: o,
          relative: a,
          viewTransition: s
        });
      }
    },
    [
      c,
      l,
      u,
      r,
      n,
      t,
      e,
      o,
      a,
      s
    ]
  );
}
var A0 = 0, M0 = () => `__${String(++A0)}__`;
function j0() {
  let { router: e } = Eu(
    "useSubmit"
    /* UseSubmit */
  ), { basename: t } = h.useContext(Ut), r = t0();
  return h.useCallback(
    async (n, o = {}) => {
      let { action: a, method: s, encType: l, formData: c, body: u } = f0(
        n,
        t
      );
      if (o.navigate === !1) {
        let p = o.fetcherKey || M0();
        await e.fetch(p, r, o.action || a, {
          preventScrollReset: o.preventScrollReset,
          formData: c,
          body: u,
          formMethod: o.method || s,
          formEncType: o.encType || l,
          flushSync: o.flushSync
        });
      } else
        await e.navigate(o.action || a, {
          preventScrollReset: o.preventScrollReset,
          formData: c,
          body: u,
          formMethod: o.method || s,
          formEncType: o.encType || l,
          replace: o.replace,
          state: o.state,
          fromRouteId: r,
          flushSync: o.flushSync,
          viewTransition: o.viewTransition
        });
    },
    [e, t, r]
  );
}
function _0(e, { relative: t } = {}) {
  let { basename: r } = h.useContext(Ut), n = h.useContext(Ht);
  Ze(n, "useFormAction must be used inside a RouteContext");
  let [o] = n.matches.slice(-1), a = { ...Nn(e || ".", { relative: t }) }, s = dr();
  if (e == null) {
    a.search = s.search;
    let l = new URLSearchParams(a.search), c = l.getAll("index");
    if (c.some((p) => p === "")) {
      l.delete("index"), c.filter((f) => f).forEach((f) => l.append("index", f));
      let p = l.toString();
      a.search = p ? `?${p}` : "";
    }
  }
  return (!e || e === ".") && o.route.index && (a.search = a.search ? a.search.replace(/^\?/, "?index&") : "?index"), r !== "/" && (a.pathname = a.pathname === "/" ? r : Xt([r, a.pathname])), Ui(a);
}
function D0(e, t = {}) {
  let r = h.useContext(du);
  Ze(
    r != null,
    "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?"
  );
  let { basename: n } = Eu(
    "useViewTransitionState"
    /* useViewTransitionState */
  ), o = Nn(e, { relative: t.relative });
  if (!r.isTransitioning)
    return !1;
  let a = lr(r.currentLocation.pathname, n) || r.currentLocation.pathname, s = lr(r.nextLocation.pathname, n) || r.nextLocation.pathname;
  return Co(o.pathname, s) != null || Co(o.pathname, a) != null;
}
[
  ...E0
];
function rx({ children: e }) {
  return Yi().isAuthenticated ? e : /* @__PURE__ */ w.jsx(i0, { to: "/callback", replace: !0 });
}
const nx = ({
  children: e,
  maxWidth: t = 600,
  minWidth: r = 320,
  backTo: n,
  backLabel: o,
  breadcrumbs: a,
  onBack: s
}) => {
  const l = () => {
    s && s();
  };
  return /* @__PURE__ */ w.jsxs(
    Xe,
    {
      maxWidth: t,
      minWidth: r,
      mt: 4,
      pb: 8,
      sx: {
        overflowX: "auto"
      },
      children: [
        /* @__PURE__ */ w.jsx(
          Xe,
          {
            sx: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              mb: 3
            },
            children: /* @__PURE__ */ w.jsxs(Xe, { sx: { display: "flex", alignItems: "center", gap: 2, flex: 1 }, children: [
              n && /* @__PURE__ */ w.jsx(
                dn,
                {
                  startIcon: /* @__PURE__ */ w.jsx(nb, {}),
                  onClick: l,
                  variant: "outlined",
                  size: "small",
                  children: o || "Back"
                }
              ),
              a && /* @__PURE__ */ w.jsx(Gc, { separator: "", children: ot.Children.map(a, (c, u) => {
                const p = ot.Children.count(a);
                let f = "middle";
                return p === 1 ? f = "single" : u === 0 ? f = "first" : u === p - 1 && (f = "last"), ot.cloneElement(c, { position: f });
              }) })
            ] })
          }
        ),
        e
      ]
    }
  );
}, wt = "12px", L0 = ee(Xe, {
  shouldForwardProp: (e) => e !== "position"
})(({ theme: e, position: t }) => {
  const r = () => {
    switch (t) {
      case "first":
        return `polygon(0 0, 100% 0, calc(100% - ${wt}) 100%, 0 100%)`;
      case "middle":
        return `polygon(${wt} 0, 100% 0, calc(100% - ${wt}) 100%, 0 100%)`;
      case "last":
        return `polygon(${wt} 0, calc(100% - ${wt}) 0, 100% 50%, calc(100% - ${wt}) 100%, 0 100%)`;
      case "single":
      default:
        return `polygon(0 0, calc(100% - ${wt}) 0, 100% 50%, calc(100% - ${wt}) 100%, 0 100%)`;
    }
  };
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "24px",
    backgroundColor: e.palette.mode === "dark" ? e.palette.grey[800] : e.palette.grey[200],
    color: e.palette.getContrastText(
      e.palette.mode === "dark" ? e.palette.grey[800] : e.palette.grey[200]
    ),
    cursor: "pointer",
    textDecoration: "none",
    clipPath: r(),
    // Nudge the items together to overlap
    marginLeft: t === "middle" || t === "last" ? `-${wt}` : 0,
    // Adjust padding to make space for the clipped areas
    paddingLeft: t === "middle" || t === "last" ? `calc(${wt} + ${e.spacing(1)})` : e.spacing(2),
    paddingRight: `calc(${wt} + ${e.spacing(1)})`,
    "&:hover, &:focus-within": {
      backgroundColor: e.palette.mode === "dark" ? e.palette.grey[700] : e.palette.grey[300]
    }
  };
}), B0 = ee(jt)({
  whiteSpace: "nowrap",
  fontSize: "0.8125rem",
  fontWeight: 400,
  color: "inherit"
}), ox = ({ label: e, component: t = "a", ...r }) => /* @__PURE__ */ w.jsx(L0, { component: t, ...r, children: /* @__PURE__ */ w.jsx(B0, { children: e }) }), ix = ({ onClick: e, label: t, "data-testid": r }) => /* @__PURE__ */ w.jsx(
  eu,
  {
    onClick: e,
    sx: {
      height: "100%",
      minHeight: 140,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: (n) => n.palette.mode === "dark" ? n.palette.grey[800] : n.palette.grey[200],
      borderRadius: (n) => n.shape.borderRadius,
      padding: 2,
      "&:hover": {
        backgroundColor: (n) => n.palette.mode === "dark" ? n.palette.grey[700] : n.palette.grey[300]
      }
    },
    "data-testid": r || "new-item-card-button",
    children: /* @__PURE__ */ w.jsxs(
      Xe,
      {
        sx: {
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: "3px dashed",
          borderColor: "grey.500",
          borderRadius: "10px",
          padding: "20px",
          color: "grey.500"
        },
        children: [
          /* @__PURE__ */ w.jsx(
            Xe,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                borderRadius: "50%",
                border: "3px solid",
                borderColor: "inherit",
                mb: 1
              },
              children: /* @__PURE__ */ w.jsx(rb, { sx: { fontSize: 32 } })
            }
          ),
          /* @__PURE__ */ w.jsx(jt, { variant: "button", component: "span", children: t })
        ]
      }
    )
  }
), ax = ({ title: e, icon: t, tags: r = [], onEdit: n, showEdit: o, onMembers: a, showMembers: s, "data-testid": l, editButtonTestId: c, membersButtonTestId: u }) => /* @__PURE__ */ w.jsxs(
  Qc,
  {
    sx: {
      position: "relative",
      minHeight: 120,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: 0,
      backgroundColor: (p) => p.palette.mode === "dark" ? p.palette.grey[900] : p.palette.background.paper
    },
    "data-testid": l,
    elevation: 1,
    children: [
      /* @__PURE__ */ w.jsx(zi, { sx: { pb: 1 }, children: /* @__PURE__ */ w.jsxs(Xe, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
        t && ot.cloneElement(t, { sx: { mr: 1.5, color: "text.secondary" } }),
        /* @__PURE__ */ w.jsx(jt, { variant: "h6", component: "div", noWrap: !0, children: e })
      ] }) }),
      /* @__PURE__ */ w.jsx(zi, { sx: { pt: 0, flexGrow: 1 }, children: /* @__PURE__ */ w.jsx(ou, { direction: "row", spacing: 1, children: r.map((p, f) => /* @__PURE__ */ w.jsx(
        qc,
        {
          label: p.label,
          color: p.color || "default",
          size: p.size || "small",
          variant: "outlined"
        },
        f
      )) }) }),
      /* @__PURE__ */ w.jsxs(Xe, { sx: { position: "absolute", top: 8, right: 8, display: "flex", gap: 0.5 }, children: [
        s && /* @__PURE__ */ w.jsx(
          bo,
          {
            "aria-label": `manage members for ${e}`,
            onClick: a,
            sx: {
              color: "text.secondary"
            },
            "data-testid": u,
            children: /* @__PURE__ */ w.jsx(cb, {})
          }
        ),
        o && /* @__PURE__ */ w.jsx(
          bo,
          {
            "aria-label": `edit ${e}`,
            onClick: n,
            sx: {
              color: "text.secondary"
            },
            "data-testid": c,
            children: /* @__PURE__ */ w.jsx(sb, {})
          }
        )
      ] })
    ]
  }
);
function F0({ clientId: e, cognitoDomain: t, logoutUri: r }) {
  if (e && t && r) {
    const n = `https://${t}/logout?client_id=${e}&logout_uri=${encodeURIComponent(r)}`;
    window.location.replace(n);
  }
}
function sx() {
  const { mode: e, setMode: t } = bm();
  return { mode: e, toggleTheme: () => {
    t(e === "dark" ? "light" : "dark");
  } };
}
function lx({ t: e, mode: t, toggleTheme: r, navigate: n, cognitoConfig: o, settingsLink: a = "/settings" }) {
  return [
    {
      icon: /* @__PURE__ */ w.jsx(iu, {}),
      text: e("navigation.homeLink"),
      onClick: () => n("/")
    },
    {
      icon: /* @__PURE__ */ w.jsx(au, {}),
      text: e("navigation.settingsLink"),
      onClick: () => window.location.href = a
    },
    {
      icon: t === "dark" ? /* @__PURE__ */ w.jsx(ib, { fontSize: "small" }) : /* @__PURE__ */ w.jsx(ob, { fontSize: "small" }),
      text: e(t === "dark" ? "navigation.theme.switchToLightMode" : "navigation.theme.switchToDarkMode"),
      onClick: r
    },
    {
      icon: /* @__PURE__ */ w.jsx(lb, {}),
      text: e("navigation.logoutLink"),
      onClick: () => F0(o)
    }
  ];
}
export {
  H0 as AccountMenu,
  Y0 as AppBar,
  q0 as AppFooter,
  K0 as AppLayout,
  G0 as CallbackPage,
  X0 as CognitoAuthProvider,
  J0 as ConfirmButton,
  ro as FullScreenLoader,
  ax as ItemCard,
  Z0 as LoggedOutPage,
  Q0 as LogoutPage,
  cv as MainContent,
  ex as MuiThemeProvider,
  tx as NavRail,
  ix as NewItemCard,
  nx as PageLayout,
  rx as ProtectedRoute,
  ox as StyledBreadcrumb,
  lx as getDefaultAccountMenuItems,
  F0 as logoutCognito,
  sx as useThemeSwitcher
};
//# sourceMappingURL=common-fe.js.map
